const answers = [
  {
    id: "4",
    test_id: "3",
    answer: "Б",
  },
  {
    id: "3",
    test_id: "3",
    answer: "А",
  },
  {
    id: "5",
    test_id: "3",
    answer: "В",
  },
  {
    id: "6",
    test_id: "3",
    answer: "Г",
  },
  {
    id: "7",
    test_id: "3",
    answer: "Д",
  },
  {
    id: "8",
    test_id: "4",
    answer: "Тээврийн хэрэгслийн хөдөлгөөнд зориулсан замын хэсэг",
  },
  {
    id: "9",
    test_id: "4",
    answer: "Явган зорчигчийн хөдөлгөөнд зориулсан замын хэсэг",
  },
  {
    id: "10",
    test_id: "4",
    answer: "Зогсоол болон хөдөлгөөнд зориулагдаагүй замын хэсэг",
  },
  {
    id: "11",
    test_id: "5",
    answer: "Зөвхөн А",
  },
  {
    id: "12",
    test_id: "5",
    answer: "Зөвхөн Б",
  },
  {
    id: "13",
    test_id: "5",
    answer: "А, Б",
  },
  {
    id: "14",
    test_id: "6",
    answer: "Нэг эгнээтэй",
  },
  {
    id: "15",
    test_id: "6",
    answer: "Хоёр эгнээтэй",
  },
  {
    id: "16",
    test_id: "6",
    answer: "Гурван эгнээтэй",
  },
  {
    id: "17",
    test_id: "7",
    answer: "Зөвхөн А",
  },
  {
    id: "18",
    test_id: "7",
    answer: "Зөвхөн Б",
  },
  {
    id: "19",
    test_id: "7",
    answer: "Зөвхөн В",
  },
  {
    id: "20",
    test_id: "7",
    answer: "Зөвхөн Б, В",
  },
  {
    id: "21",
    test_id: "7",
    answer: "А, Б, В",
  },
  {
    id: "22",
    test_id: "8",
    answer: "Зөвхөн А",
  },
  {
    id: "23",
    test_id: "8",
    answer: "Зөвхөн Б",
  },
  {
    id: "24",
    test_id: "8",
    answer: "А, Б",
  },
  {
    id: "25",
    test_id: "9",
    answer: "Мотоцикл",
  },
  {
    id: "26",
    test_id: "9",
    answer: "Мопед",
  },
  {
    id: "27",
    test_id: "9",
    answer: "Унадаг дугуй",
  },
  {
    id: "28",
    test_id: "9",
    answer: "Мотоцикл болон мопед",
  },
  {
    id: "29",
    test_id: "9",
    answer: "Дээрх бүгд",
  },
  {
    id: "30",
    test_id: "10",
    answer:
      "Тогтоосон буудал бүхий чиглэлийн дагуу зорчигч тээвэрлэх зориулалтаар нийтийн үйлчилгээнд явж байгаа автобус,троллейбус",
  },
  {
    id: "31",
    test_id: "10",
    answer: "Бүх төрлийн автобус",
  },
  {
    id: "32",
    test_id: "10",
    answer: "Хүн тээвэрлэхэд зориулсан тээврийн хэрэгсэл",
  },
  {
    id: "33",
    test_id: "11",
    answer: "Тээврийн хэрэгслийн тухайн үеийн жин",
  },
  {
    id: "34",
    test_id: "11",
    answer: "Тээврийн хэрэгслийн техникийн тодорхойлолтоор тогтоосон жин",
  },
  {
    id: "35",
    test_id: "11",
    answer: "Тээврийн хэрэгслийн өөрийн жин",
  },
  {
    id: "36",
    test_id: "12",
    answer: "Тээврийн хэрэгслийн тухайн үеийн жин",
  },
  {
    id: "37",
    test_id: "12",
    answer: "Тээврийн хэрэгслийн техникийн тодорхойлолтоор тогтоосон жин",
  },
  {
    id: "38",
    test_id: "12",
    answer: "Тээврийн хэрэгслийн даацын хэмжээ",
  },
  {
    id: "39",
    test_id: "13",
    answer: "Зөвхөн А",
  },
  {
    id: "40",
    test_id: "13",
    answer: "Зөвхөн Б",
  },
  {
    id: "41",
    test_id: "13",
    answer: "Зөвхөн В",
  },
  {
    id: "42",
    test_id: "13",
    answer: "Зөвхөн А, Б",
  },
  {
    id: "43",
    test_id: "13",
    answer: "Бүгд",
  },
  {
    id: "44",
    test_id: "14",
    answer: "Жолоодлогын дадлага хийлгэж яваа багш",
  },
  {
    id: "45",
    test_id: "14",
    answer: "Ердийн хөсөг хөтөлж замаар яваа хүн",
  },
  {
    id: "46",
    test_id: "14",
    answer: "Унадаг дугуй унаж яваа хүн",
  },
  {
    id: "47",
    test_id: "14",
    answer: "Дээрх бүгдийг хамааруулж ойлгоно",
  },
  {
    id: "55",
    test_id: "15",
    answer:
      "Байгалийн тогтоц, газрын тэгш бус байдалд замын дагуух үзэгдэх орчин халхлагдсан байдал",
  },
  {
    id: "54",
    test_id: "15",
    answer:
      "Утаа, тоос боссоноос 300 м-ийн дотор зам харагдахгүй болсон нөхцөл",
  },
  {
    id: "52",
    test_id: "16",
    answer: "Тээврийн хэрэгслийг зогсоолд байрлуулах үйлдэл",
  },
  {
    id: "53",
    test_id: "16",
    answer: "Явж байгаа чигтээ эгнээ байраа солих үйлдэл",
  },
  {
    id: "56",
    test_id: "16",
    answer: "Замаас гарах буюу замд нийлэх үйлдэл",
  },
  {
    id: "57",
    test_id: "17",
    answer: "Зөвхөн А",
  },
  {
    id: "58",
    test_id: "17",
    answer: "Зөвхөн Б",
  },
  {
    id: "59",
    test_id: "17",
    answer: "А, Б",
  },
  {
    id: "60",
    test_id: "18",
    answer: "Гүйцэх үйлдэл",
  },
  {
    id: "61",
    test_id: "18",
    answer: "Гүйцэж түрүүлэх үйлдэл",
  },
  {
    id: "62",
    test_id: "18",
    answer: "Саадыг тойрон гарах үйлдэл",
  },
  {
    id: "63",
    test_id: "19",
    answer: "Техникийн дээд хурд нь цагт 40км-ээс ихгүй тээврийн хэрэгсэл",
  },
  {
    id: "64",
    test_id: "19",
    answer: "Механикжсан тээврийн хэрэгсэл чирч яваа тээврийн хэрэгсэл",
  },
  {
    id: "65",
    test_id: "19",
    answer: "Цагт 40 км-ээс бага хурдтай яваа автомашин",
  },
  {
    id: "66",
    test_id: "19",
    answer: "Дээрх бүгдийг хориглоно",
  },
  {
    id: "67",
    test_id: "20",
    answer:
      "Хориглосон дохиогоор зогсож байгаа тээврийн хэрэгслийг тойрон гарах",
  },
  {
    id: "68",
    test_id: "20",
    answer:
      "Хөдөлгөөний түгжрэлд зогсож байгаа тээврийн хэрэгслийг тойрон гарах",
  },
  {
    id: "69",
    test_id: "20",
    answer: "Зайлшгүй  зогсолт хийсэн тээврийн хэрэгслийг тойрон гарах",
  },
  {
    id: "70",
    test_id: "20",
    answer: "Дээрх бүгд",
  },
  {
    id: "71",
    test_id: "21",
    answer: "Техникийн дээд хурд нь цагт 40км-ээс ихгүй тээврийн хэрэгсэл",
  },
  {
    id: "72",
    test_id: "21",
    answer: "Механикжсан тээврийн хэрэгсэл чирч яваа тээврийн хэрэгсэл",
  },
  {
    id: "73",
    test_id: "21",
    answer: "Цагт 40 км-ээс бага хурдтай яваа автомашин",
  },
  {
    id: "74",
    test_id: "21",
    answer: "Дээрх бүгдийг хориглоно",
  },
  {
    id: "75",
    test_id: "22",
    answer: "Тийм",
  },
  {
    id: "82",
    test_id: "24",
    answer: "Хориглосон дохиогоор тээврийн хэрэгслээ зогсоох",
  },
  {
    id: "76",
    test_id: "22",
    answer: "Үгүй",
  },
  {
    id: "80",
    test_id: "23",
    answer: "Удаан зогсолт",
  },
  {
    id: "81",
    test_id: "23",
    answer: "Зайлшгүй зогсолт",
  },
  {
    id: "77",
    test_id: "22",
    answer: "Хурдаа хасаж, зогсож өнгөрүүлсэн бол зөв",
  },
  {
    id: "79",
    test_id: "23",
    answer: "Түр зогсолт",
  },
  {
    id: "83",
    test_id: "24",
    answer: "Ачаа буулгах шаардлагаар тээврийн хэрэгслээ зогсоох",
  },
  {
    id: "84",
    test_id: "24",
    answer:
      "Зорчигчийн биеийн байдал муудсаны улмаас тээврийн хэрэгслээ зогсоох",
  },
  {
    id: "85",
    test_id: "24",
    answer: "Дээрх бүх үйлдэл хамаарагдана",
  },
  {
    id: "86",
    test_id: "25",
    answer: "Суудлын автомашин",
  },
  {
    id: "87",
    test_id: "25",
    answer: "Мотоцикл",
  },
  {
    id: "88",
    test_id: "25",
    answer: "Мотоцикл болон мопед",
  },
  {
    id: "89",
    test_id: "25",
    answer: "Дээрх бүгд",
  },
  {
    id: "90",
    test_id: "26",
    answer: "16 нас",
  },
  {
    id: "91",
    test_id: "26",
    answer: "18 нас",
  },
  {
    id: "92",
    test_id: "26",
    answer: "21 нас",
  },
  {
    id: "93",
    test_id: "27",
    answer: "Хамаарагдана",
  },
  {
    id: "94",
    test_id: "27",
    answer: "Хамаарагдахгүй",
  },
  {
    id: "95",
    test_id: "27",
    answer: "Чиргүүлийн бүх жин 750 кг-аас ихгүй бол хамаарагдана",
  },
  {
    id: "96",
    test_id: "28",
    answer: "Хамаарагдана",
  },
  {
    id: "97",
    test_id: "28",
    answer: "Хамаарагдахгүй",
  },
  {
    id: "98",
    test_id: "28",
    answer: "бүх жин нь 3.5 тонноос бага бол хамаарагдана",
  },
  {
    id: "99",
    test_id: "29",
    answer: "Зөвхөн 'В' ангилал",
  },
  {
    id: "100",
    test_id: "29",
    answer: "Зөвхөн 'С' ангилал",
  },
  {
    id: "101",
    test_id: "29",
    answer: "Зөвхөн 'С1' дэд ангилал",
  },
  {
    id: "102",
    test_id: "29",
    answer: "'В' болон 'С1' дэд ангилал",
  },
  {
    id: "103",
    test_id: "30",
    answer: "Зөвшөөрнө",
  },
  {
    id: "104",
    test_id: "30",
    answer: "Хориглоно",
  },
  {
    id: "105",
    test_id: "30",
    answer: "Чиргүүлийн бүх жин 750 кг-аас бага бол зөвшөөрнө",
  },
  {
    id: "106",
    test_id: "30",
    answer: "Чиргүүлийн бүх жин нь 3500 кг-аас бага бол зөвшөөрнө",
  },
  {
    id: "107",
    test_id: "31",
    answer: "'В' ангилал",
  },
  {
    id: "108",
    test_id: "31",
    answer: "'ВЕ' ангилал",
  },
  {
    id: "109",
    test_id: "31",
    answer: "'С' ангилал",
  },
  {
    id: "110",
    test_id: "31",
    answer: "'СЕ' ангилал",
  },
  {
    id: "111",
    test_id: "32",
    answer: "Бүх жин нь 750 кг-аас илүү чиргүүлтэй 'В' ангиллын автомашин",
  },
  {
    id: "112",
    test_id: "32",
    answer: "Бүх жин нь 750 кг-аас илүү чиргүүлтэй бага оврын автобус",
  },
  {
    id: "113",
    test_id: "32",
    answer:
      "Бүх жин нь 750 кг-аас илүү чиргүүлтэй бүх төрлийн ачааны автомашин",
  },
  {
    id: "114",
    test_id: "32",
    answer: "Дээрх бүгд",
  },
  {
    id: "115",
    test_id: "33",
    answer: "Хамаарагдана",
  },
  {
    id: "116",
    test_id: "33",
    answer: "Хамаарагдахгүй",
  },
  {
    id: "117",
    test_id: "33",
    answer: "Жолоочоос гадна 16-аас илүүгүй хүний суудалтай бол хамаарагдана",
  },
  {
    id: "118",
    test_id: "34",
    answer: "4 м-ээс илүүгүй",
  },
  {
    id: "119",
    test_id: "34",
    answer: "4 м-ээс 6м",
  },
  {
    id: "120",
    test_id: "34",
    answer: "6 м -ээс багагүй",
  },
  {
    id: "121",
    test_id: "35",
    answer: "Зөвшөөрнө",
  },
  {
    id: "122",
    test_id: "35",
    answer: "Хориглоно",
  },
  {
    id: "123",
    test_id: "35",
    answer: "Өөрөөсөө гадна 8-аас илүүгүй хүн тээвэрлэх бол зөвшөөрнө",
  },
  {
    id: "124",
    test_id: "36",
    answer: "Чиргүүлтэй автомашин",
  },
  {
    id: "125",
    test_id: "36",
    answer: "Мотоцикл",
  },
  {
    id: "126",
    test_id: "36",
    answer: "Трактор",
  },
  {
    id: "127",
    test_id: "36",
    answer: "Дээрх бүгдийг хориглоно",
  },
  {
    id: "128",
    test_id: "37",
    answer: "Техникийн дээд хурд нь цагт 40км-ээс ихгүй тээврийн хэрэгсэл",
  },
  {
    id: "129",
    test_id: "37",
    answer: "Механикжсан тээврийн хэрэгсэл чирч яваа тээврийн хэрэгсэл",
  },
  {
    id: "130",
    test_id: "37",
    answer: "Цагт 40км-ээс бага хурдтай автомашин",
  },
  {
    id: "131",
    test_id: "37",
    answer: "Дээрх бүгдийг хориглоно",
  },
  {
    id: "132",
    test_id: "38",
    answer: "Зөвшөөрнө",
  },
  {
    id: "133",
    test_id: "38",
    answer: "Хориглоно",
  },
  {
    id: "134",
    test_id: "38",
    answer:
      "Зорчих хэсгийн хамгийн баруун гар талын эгнээгээр байрлан явах тохиолдолд зөвшөөрнө.",
  },
  {
    id: "135",
    test_id: "39",
    answer: "4 м-ээс илүүгүй",
  },
  {
    id: "136",
    test_id: "39",
    answer: "4 м-ээс 6м",
  },
  {
    id: "137",
    test_id: "39",
    answer: "6 м -ээс багагүй",
  },
  {
    id: "138",
    test_id: "40",
    answer: "Зөвшөөрнө",
  },
  {
    id: "139",
    test_id: "40",
    answer: "Хориглоно",
  },
  {
    id: "140",
    test_id: "40",
    answer: "Зөвхөн гүүр хүртэлх ухрахыг зөвшөөрнө.",
  },
  {
    id: "141",
    test_id: "41",
    answer: "Гүйцэх ",
  },
  {
    id: "142",
    test_id: "41",
    answer: "Саадыг тойрох гарах",
  },
  {
    id: "143",
    test_id: "41",
    answer: "Буцаж эргэх",
  },
  {
    id: "144",
    test_id: "41",
    answer: "Дээрх бүгдийг хориглоно",
  },
  {
    id: "145",
    test_id: "42",
    answer: "Зөвхөн суудлын автомашин",
  },
  {
    id: "146",
    test_id: "42",
    answer: "Зөвхөн ачааны автомашин",
  },
  {
    id: "147",
    test_id: "42",
    answer: "Хоёуланг хориглоно",
  },
  {
    id: "148",
    test_id: "42",
    answer: "Хоёуланг зөвшөөрнө",
  },
  {
    id: "149",
    test_id: "43",
    answer: "Баруун гар талын эгнээнүүд чөлөөгүй тохиолдолд зөвшөөрнө.",
  },
  {
    id: "150",
    test_id: "43",
    answer:
      "Баруун гар талын нэг ба хоёр дахь эгнээнээс бусад эгнээгээр байрлан явахыг хориглоно.",
  },
  {
    id: "151",
    test_id: "44",
    answer: "Хориглоно",
  },
  {
    id: "152",
    test_id: "44",
    answer: "Зөвхөн зөөлөн холбоогоор чирэхийг хориглоно",
  },
  {
    id: "153",
    test_id: "44",
    answer: "Зөвхөн цоройлгон ачих байдлаар чирэхийг зөвшөөрнө",
  },
  {
    id: "154",
    test_id: "45",
    answer: "Зөвшөөрнө",
  },
  {
    id: "155",
    test_id: "45",
    answer: "Бүх жин нь 3.5 тонноос илүүгүй бол зөвшөөрнө",
  },
  {
    id: "156",
    test_id: "45",
    answer: "Буцаж эргэхийн тулд байр эзэлсэн бол зөвшөөрнө",
  },
  {
    id: "157",
    test_id: "45",
    answer: "Хориглоно",
  },
  {
    id: "158",
    test_id: "46",
    answer: "Бүх жин нь 3.5 тонноос их ачааны автомашин",
  },
  {
    id: "159",
    test_id: "46",
    answer: "Бүх жин нь 3.5 тонноос бага ачааны автомашин",
  },
  {
    id: "160",
    test_id: "46",
    answer: "Бүх төрлийн ачааны автомашин",
  },
  {
    id: "161",
    test_id: "47",
    answer: "Зорчих хэсгийн баруун гар талын захад ",
  },
  {
    id: "162",
    test_id: "47",
    answer: "Зорчих хэсгийг чөлөөлж хөвөөн дээр ",
  },
  {
    id: "163",
    test_id: "47",
    answer: "Зөвхөн 500м-ийн цаана, амрах газарт ",
  },
  {
    id: "164",
    test_id: "47",
    answer: "Дээрх бүх газарт зөвшөөрнө.",
  },
  {
    id: "165",
    test_id: "48",
    answer: "Шаардлагатай.",
  },
  {
    id: "166",
    test_id: "48",
    answer: "Зорчих хэсгийг чөлөөлсөн тохиолдолд шаардлагагүй",
  },
  {
    id: "167",
    test_id: "49",
    answer: "Зөвшөөрнө",
  },
  {
    id: "168",
    test_id: "49",
    answer: "Хориглоно",
  },
  {
    id: "169",
    test_id: "49",
    answer: "Бодит жин нь 3.5 тонноос хэтрээгүй бол зөвшөөрнө",
  },
  {
    id: "170",
    test_id: "50",
    answer: "'С' ангилал",
  },
  {
    id: "171",
    test_id: "50",
    answer: "'СЕ' ангилал",
  },
  {
    id: "172",
    test_id: "50",
    answer: "'М' ангилал",
  },
  {
    id: "173",
    test_id: "51",
    answer: "Бүх жин нь 3.5 тонноос бага ачааны автомашин",
  },
  {
    id: "174",
    test_id: "51",
    answer: "Бүх жин нь 3.5 тонноос 7.5 тонн хүртэлх ачааны автомашин",
  },
  {
    id: "175",
    test_id: "51",
    answer: "Бүх жин нь 3.5 тонноос их бүх ачааны автомашин",
  },
  {
    id: "176",
    test_id: "52",
    answer: "Хориглоно",
  },
  {
    id: "177",
    test_id: "52",
    answer: "Зөвхөн зөөлөн холбоогоор чирэхийг хориглоно",
  },
  {
    id: "178",
    test_id: "52",
    answer: "Зөвхөн цоройлгон ачих байдлаар чирэхийг зөвшөөрнө",
  },
  {
    id: "179",
    test_id: "53",
    answer: "Жолоочоос гадна 8-аас илүүгүй хүний суудалтай автомашин",
  },
  {
    id: "180",
    test_id: "53",
    answer: "Зөвхөн 16 хүртэл хүний суудалтай автобус",
  },
  {
    id: "181",
    test_id: "53",
    answer: "Бүх төрлийн автобус,троллейбус",
  },
  {
    id: "182",
    test_id: "54",
    answer: "Хориглох тэмдэг",
  },
  {
    id: "183",
    test_id: "54",
    answer: "Дарааллын тэмдэг",
  },
  {
    id: "184",
    test_id: "54",
    answer: "Заах тэмдэг",
  },
  {
    id: "185",
    test_id: "54",
    answer: "Мэдээлэх тэмдэг",
  },
  {
    id: "186",
    test_id: "54",
    answer: "Дээрх бүгд",
  },
  {
    id: "187",
    test_id: "55",
    answer: "'D' ангилал",
  },
  {
    id: "188",
    test_id: "55",
    answer: "'DЕ' ангилал",
  },
  {
    id: "189",
    test_id: "55",
    answer: "'D1' дэд ангилал",
  },
  {
    id: "190",
    test_id: "55",
    answer: "'D1Е' дэд ангилал",
  },
  {
    id: "191",
    test_id: "56",
    answer: "Жолооны механизм",
  },
  {
    id: "192",
    test_id: "56",
    answer: "Тоормосны систем",
  },
  {
    id: "193",
    test_id: "56",
    answer: "Дуут дохио",
  },
  {
    id: "194",
    test_id: "56",
    answer: "Дээрх бүгд",
  },
  {
    id: "195",
    test_id: "57",
    answer: "Хурд хэмжүүр ажиллахгүй болсон",
  },
  {
    id: "196",
    test_id: "57",
    answer: "Ослын дохионы гэрэл ажиллахгүй болсон",
  },
  {
    id: "197",
    test_id: "57",
    answer: "Дуут дохио ажиллахгүй болсон",
  },
  {
    id: "198",
    test_id: "57",
    answer: "Дээрх бүгдийг хориглоно",
  },
  {
    id: "199",
    test_id: "58",
    answer:
      "Жолоочоос гадна 8-аас илүүгүй хүний суудалтай хүн тээвэрлэхэд зориулсан автомашин",
  },
  {
    id: "200",
    test_id: "58",
    answer: "Жолоочоос гадна 16-аас илүүгүй хүний суудалтай автобус",
  },
  {
    id: "201",
    test_id: "58",
    answer: "Бүх төрлийн автобус",
  },
  {
    id: "202",
    test_id: "59",
    answer: "'В' ангилал",
  },
  {
    id: "203",
    test_id: "59",
    answer: "Зөвхөн 'D' ангилал",
  },
  {
    id: "204",
    test_id: "59",
    answer: "Зөвхөн 'D1' дэд ангилал",
  },
  {
    id: "205",
    test_id: "59",
    answer: "'D' ангилал болон 'D1' дэд ангилал",
  },
  {
    id: "206",
    test_id: "60",
    answer: "'С' ангилал",
  },
  {
    id: "207",
    test_id: "60",
    answer: "'СЕ' ангилал",
  },
  {
    id: "208",
    test_id: "60",
    answer: "'М' ангилал",
  },
  {
    id: "209",
    test_id: "61",
    answer: "18 нас",
  },
  {
    id: "210",
    test_id: "61",
    answer: "21 нас",
  },
  {
    id: "211",
    test_id: "61",
    answer: "24 нас",
  },
  {
    id: "212",
    test_id: "62",
    answer: "Зөвхөн дарааллын тэмдгийн заалтыг мөрдөхгүй",
  },
  {
    id: "213",
    test_id: "62",
    answer: "Зөвхөн гэрэл дохионы заалтыг мөрдөхгүй",
  },
  {
    id: "214",
    test_id: "62",
    answer: "Гэрэл дохио болон дарааллын тэмдгийн заалтыг мөрдөхгүй",
  },
  {
    id: "215",
    test_id: "62",
    answer: "Гэрэл дохио болон бүх  тэмдгийн заалтыг мөрдөхгүй",
  },
  {
    id: "216",
    test_id: "63",
    answer: "Гэрэл дохиог баримталж <<Зогс шугам>>-ын өмнө зогсоно",
  },
  {
    id: "217",
    test_id: "63",
    answer: "Зохицуулагчийн дохиог баримталж бүх чигт явахыг зөвшөөрнө",
  },
  {
    id: "218",
    test_id: "63",
    answer:
      "Зохицуулагчийн  дохио болон заах тэмдгийг баримталж зөвхөн чигээрээ явна",
  },
  {
    id: "219",
    test_id: "64",
    answer: "Гэрэл дохиог баримталж дурын чигт явна",
  },
  {
    id: "220",
    test_id: "64",
    answer:
      "Гэрэл дохио болон заах тэмдгийг баримталж зөвхөн баруун гар тийш эргэнэ",
  },
  {
    id: "221",
    test_id: "64",
    answer:
      "Гэрэл дохио болон заах тэмдгийг баримталж баруун гар тийш эргэхдээ дарааллын тэмдгийг мөрдөж ачааны автомашинд зам тавьж өгнө",
  },
  {
    id: "222",
    test_id: "65",
    answer: "Зөвхөн чирч яваа автомашинд зөвшөөрнө",
  },
  {
    id: "223",
    test_id: "65",
    answer: "Зөвхөн чирүүлж яваа автомашинд зөвшөөрнө",
  },
  {
    id: "224",
    test_id: "65",
    answer: "Хоёуланд нь зөвшөөрнө.",
  },
  {
    id: "225",
    test_id: "65",
    answer: "Хоёуланд нь хоргиглоно",
  },
  {
    id: "226",
    test_id: "66",
    answer: "Зөвхөн А",
  },
  {
    id: "227",
    test_id: "66",
    answer: "Зөвхөн В",
  },
  {
    id: "228",
    test_id: "66",
    answer: "Зөвхөн А, Б",
  },
  {
    id: "229",
    test_id: "66",
    answer: "Зөвхөн А, В",
  },
  {
    id: "230",
    test_id: "66",
    answer: "Бүгд",
  },
  {
    id: "231",
    test_id: "67",
    answer: "Явган зорчигчийн хөдөлгөөнд саад болохгүйгээр гарцын өмнө ",
  },
  {
    id: "232",
    test_id: "67",
    answer: "Гэрлэн дохионы өмнө",
  },
  {
    id: "233",
    test_id: "67",
    answer: "<<Зогс-шугам>> тэмдгийн өмнө",
  },
  {
    id: "234",
    test_id: "68",
    answer: "Зөвхөн жолоодох эрхийн үнэмлэх",
  },
  {
    id: "235",
    test_id: "68",
    answer: "Зөвхөн тээврийн хэрэгслийн бүртгэлийн гэрчилгээ",
  },
  {
    id: "236",
    test_id: "68",
    answer: "Зөвхөн жолоочийн даатгалын баталгаа",
  },
  {
    id: "237",
    test_id: "68",
    answer: "Дээрх бүгд",
  },
  {
    id: "238",
    test_id: "69",
    answer: "Зөвхөн А",
  },
  {
    id: "239",
    test_id: "69",
    answer: "Зөвхөн Б",
  },
  {
    id: "240",
    test_id: "69",
    answer: "Зөвхөн А, Б",
  },
  {
    id: "241",
    test_id: "70",
    answer: "Зөвхөн зохицуулагчид",
  },
  {
    id: "242",
    test_id: "70",
    answer: "Зөвхөн цагдаагийн алба хаагч болон олон нийтийн цагдаад",
  },
  {
    id: "243",
    test_id: "70",
    answer: "Зөвхөн автотээврийн болон байгаль орчны хяналтын улсын байцаагчид",
  },
  {
    id: "244",
    test_id: "70",
    answer: "Дээрх бүгдэд",
  },
  {
    id: "245",
    test_id: "71",
    answer: "Хориглоно",
  },
  {
    id: "246",
    test_id: "71",
    answer: "Зогсоолын тоормос ажиллаж байгаа бол зөвшөөрнө",
  },
  {
    id: "247",
    test_id: "71",
    answer: "Зөвхөн ойр байгаа зогсоол буюу засварын газарт очих бол зөвшөөрнө",
  },
  {
    id: "248",
    test_id: "72",
    answer: "Баруун гар талын сум хөдөлгөөнд ашиглагдахгүйг",
  },
  {
    id: "249",
    test_id: "72",
    answer:
      "Баруун гар тийш эргэх хөдөлгөөн нэмэгдэл гэрэл дохиогоор зохицуулагдахыг ",
  },
  {
    id: "250",
    test_id: "72",
    answer: "Баруун гар талын эгнээнээс зүүн гар тийш эргэж болохыг",
  },
  {
    id: "251",
    test_id: "73",
    answer: "Холын гэрэл асаж байгаа бол зөвшөөрнө",
  },
  {
    id: "252",
    test_id: "73",
    answer: "Жолооч талын ойрын гэрэл асаж байгаа бол зөвшөөрнө",
  },
  {
    id: "253",
    test_id: "73",
    answer: "Зөвхөн ойр байгаа зогсоол буюу засварын газарт очих бол зөвшөөрнө",
  },
  {
    id: "254",
    test_id: "73",
    answer: "Хориглоно",
  },
  {
    id: "255",
    test_id: "74",
    answer: "Зөвшөөрнө",
  },
  {
    id: "256",
    test_id: "74",
    answer: "Хориглоно",
  },
  {
    id: "257",
    test_id: "74",
    answer:
      "Бусад чиглэлээс яваа хөдөлгөөнд оролцогчдод зам тавьж өгөөд баруун гар тийш эргэхийг зөвшөөөрнө",
  },
  {
    id: "258",
    test_id: "75",
    answer: "Зөвхөн зүүн гар тийш эргэхийг хориглоно",
  },
  {
    id: "259",
    test_id: "75",
    answer: "Зөвхөн зүүн гар тийш эргэхийг зөвшөөрнө",
  },
  {
    id: "260",
    test_id: "75",
    answer: "Зүүн гар тийш болон буцаж эргэхийг зөвшөөрнө",
  },
  {
    id: "261",
    test_id: "76",
    answer: "Зөвшөөрнө",
  },
  {
    id: "262",
    test_id: "76",
    answer: "Хориглоно",
  },
  {
    id: "263",
    test_id: "77",
    answer: "Зөвхөн  чигээрээ",
  },
  {
    id: "264",
    test_id: "77",
    answer: "Зөвхөн баруун гар тийш ",
  },
  {
    id: "265",
    test_id: "77",
    answer: "Чигээрээ буюу баруун гар тийш",
  },
  {
    id: "266",
    test_id: "78",
    answer: "Хориглоно",
  },
  {
    id: "267",
    test_id: "78",
    answer: "Гэрэлтүүлэгтэй замаар яваа бол зөвшөөрнө",
  },
  {
    id: "268",
    test_id: "78",
    answer: "Зөвхөн ойр байгаа зогсоол буюу засварын газарт очих бол зөвшөөрнө",
  },
  {
    id: "269",
    test_id: "79",
    answer: "Зөвшөөрнө ",
  },
  {
    id: "270",
    test_id: "79",
    answer: "Хориглоно",
  },
  {
    id: "2353",
    test_id: "83",
    answer:
      "<<Зогс-шугам>> -ын өмнө зогсож, үндсэн ногоон гэрэл дохио асахыг хүлээнэ",
  },
  {
    id: "272",
    test_id: "80",
    answer: "Зөвхөн чигээрээ",
  },
  {
    id: "273",
    test_id: "80",
    answer: "Зөвхөн баруун гар тийш",
  },
  {
    id: "274",
    test_id: "80",
    answer: "Чигээрээ буюу баруун гар тийш",
  },
  {
    id: "2352",
    test_id: "361",
    answer: "А, Б",
  },
  {
    id: "275",
    test_id: "81",
    answer: "Зөвхөн А",
  },
  {
    id: "276",
    test_id: "81",
    answer: "Зөвхөн Б",
  },
  {
    id: "277",
    test_id: "81",
    answer: "Аль нэг нь ажиллахгүй бол хөдөлгөөнөө үргэлжлүүлэхийг хориглоно.",
  },
  {
    id: "278",
    test_id: "82",
    answer: "Жолооны механизм ажиллахгүй болсон",
  },
  {
    id: "279",
    test_id: "82",
    answer: "Хөдөлгүүрийн ажиллагаа доголдсон",
  },
  {
    id: "280",
    test_id: "82",
    answer: "Хурд хэмжүүр ажиллахгүй болсон",
  },
  {
    id: "281",
    test_id: "82",
    answer: "Дээрх бүх тохиолдолд",
  },
  {
    id: "282",
    test_id: "83",
    answer: "Хөдөлгөөнөө үргэлжлүүлж чигээрээ нэвтэрнэ",
  },
  {
    id: "283",
    test_id: "83",
    answer: "Өөрийн явах чигийг үл харгалзан зүүн гар тийш эргэнэ",
  },
  {
    id: "284",
    test_id: "84",
    answer: "Зөвхөн чирч яваа автомашинд зөвшөөрнө",
  },
  {
    id: "285",
    test_id: "84",
    answer: "Зөвхөн чирүүлж яваа автомашинд зөвшөөрнө",
  },
  {
    id: "286",
    test_id: "84",
    answer: "Хоёуланд нь зөвшөөрнө",
  },
  {
    id: "287",
    test_id: "84",
    answer: "Хоёуланд нь хориглоно",
  },
  {
    id: "288",
    test_id: "85",
    answer: "Зөвшөөрнө",
  },
  {
    id: "289",
    test_id: "85",
    answer: "Хориглоно",
  },
  {
    id: "290",
    test_id: "85",
    answer:
      "Ууулзварын өмнө огцом тормослохгүйгээр зогсох боломжтой тохиолдолд хориглоно",
  },
  {
    id: "291",
    test_id: "86",
    answer: "Тооцно",
  },
  {
    id: "292",
    test_id: "86",
    answer: "Огцом тоормослохоос зайлсхийж орсон бол тооцохгүй",
  },
  {
    id: "293",
    test_id: "87",
    answer: "Уулзварт зогсож, дараагийн зөвшөөрөх дохиог хүлээнэ ",
  },
  {
    id: "294",
    test_id: "87",
    answer: "Аюулгүй байдлыг хангаж хөдөлгөөнөө үргэлжлүүлнэ",
  },
  {
    id: "295",
    test_id: "87",
    answer: "Ухарч зохих байраа эзэлнэ",
  },
  {
    id: "296",
    test_id: "88",
    answer: "Зөвшөөрнө",
  },
  {
    id: "297",
    test_id: "88",
    answer: "Уулзварт орж амжаагүй байгаа энэ тохиолдолд хориглоно",
  },
  {
    id: "298",
    test_id: "89",
    answer: "Зөвхөн А",
  },
  {
    id: "299",
    test_id: "89",
    answer: "Зөвхөн Б",
  },
  {
    id: "300",
    test_id: "89",
    answer: "А, Б",
  },
  {
    id: "301",
    test_id: "90",
    answer: "Хөдөлгөөнийг бүх чигт хориглоно",
  },
  {
    id: "302",
    test_id: "90",
    answer:
      "Хөдөлгөөнийг зөвшөөрөх бөгөөд уулзвар зохицуулгагүй болсныг мэдээлж болгоомжтой явахыг анхааруулна",
  },
  {
    id: "303",
    test_id: "90",
    answer: "Гэрэл дохио солигдох гэж байгааг анхааруулна",
  },
  {
    id: "304",
    test_id: "91",
    answer: "Хөдөлгөөнийг бүх чигт хориглоно",
  },
  {
    id: "305",
    test_id: "91",
    answer:
      "Хөдөлгөөнийг зөвшөөрөх бөгөөд уулзвар зохицуулгагүй болсныг мэдээлж болгоомжтой явахыг анхааруулна",
  },
  {
    id: "306",
    test_id: "91",
    answer: "Гэрэл дохио солигдох гэж байгааг анхааруулна",
  },
  {
    id: "307",
    test_id: "92",
    answer: "Зөвхөн  чигээрээ явахыг зөвшөөрнө",
  },
  {
    id: "308",
    test_id: "92",
    answer: "Зөвхөн чигээрээ явах буюу баруун гар тийш эргэхийг зөшөөрнө",
  },
  {
    id: "309",
    test_id: "92",
    answer: "Уулзар руу орохыг хориглоно",
  },
  {
    id: "310",
    test_id: "93",
    answer: "<<Зогс-шугам>> тэмдэглэлийн өмнө очиж зогсоно",
  },
  {
    id: "311",
    test_id: "93",
    answer:
      "Баруун гар талын хашлаганд шахаж, бусдын хөдөлгөөнд саад болохооргүй тохиромжтой байрлал сонгож зогсоно",
  },
  {
    id: "312",
    test_id: "93",
    answer: "Буцаж эргэнэ",
  },
  {
    id: "313",
    test_id: "94",
    answer: "Хориглоно",
  },
  {
    id: "314",
    test_id: "94",
    answer:
      "Уулзварын өмнө огцом тоормослохгүйгээр зогсох боломжгүй бол зөвшөөрнө",
  },
  {
    id: "315",
    test_id: "95",
    answer: "8 метр орчим",
  },
  {
    id: "316",
    test_id: "95",
    answer: "12 метр орчим",
  },
  {
    id: "317",
    test_id: "95",
    answer: "22 метр орчим",
  },
  {
    id: "318",
    test_id: "95",
    answer: "32 метр орчим",
  },
  {
    id: "319",
    test_id: "96",
    answer: "Ихэснэ",
  },
  {
    id: "320",
    test_id: "96",
    answer: "Багасна",
  },
  {
    id: "321",
    test_id: "96",
    answer: "Өөрчлөгдөхгүй",
  },
  {
    id: "322",
    test_id: "97",
    answer: "Самбаачлах хугацаа ихэснэ",
  },
  {
    id: "323",
    test_id: "97",
    answer: "Самбаачлах хугацаа багасна",
  },
  {
    id: "324",
    test_id: "97",
    answer: "Нөлөөлөхгүй",
  },
  {
    id: "325",
    test_id: "98",
    answer: "Чиргүүл нь хөдөлгөөнд эсэргүүцэл нэмэх тул багасна",
  },
  {
    id: "326",
    test_id: "98",
    answer: "Чиргүүл нь инерцийг нэмэгдүүлэх тул ихэснэ",
  },
  {
    id: "327",
    test_id: "98",
    answer: "Өөрчлөгдөхгүй",
  },
  {
    id: "328",
    test_id: "99",
    answer: "Их радиустай тойргоор бага хурдтай эргэхэд",
  },
  {
    id: "329",
    test_id: "99",
    answer: "Бага радиустай тойргоор бага хурдтай эргэхэд",
  },
  {
    id: "330",
    test_id: "99",
    answer: "Бага радиустай тойргоор их хурдтай эргэхэд",
  },
  {
    id: "331",
    test_id: "99",
    answer: "Их радиустай тойргоор их хурдтай эргэхэд",
  },
  {
    id: "332",
    test_id: "100",
    answer: "Тоормосны дөрөөг тултал гишгэнэ",
  },
  {
    id: "333",
    test_id: "100",
    answer: "Тоормосны дөрөөг тасалдалтай гишгэнэ",
  },
  {
    id: "334",
    test_id: "100",
    answer:
      "Тоормосны дөрөөг гишгэх үедээ зогсоолын  тоормосыг давхар ашиглана",
  },
  {
    id: "335",
    test_id: "101",
    answer:
      "Түлш өгөлтийг багасгаж, жолооны хүрдийг шарвасан тал руу эргүүлнэ ",
  },
  {
    id: "336",
    test_id: "101",
    answer: "Тоормослож, жолооны хүрдийг шарвасан тал руу эргүүлнэ",
  },
  {
    id: "337",
    test_id: "101",
    answer:
      "Түлш өгөлтийг нэмж, жолооны  хүрдийг  шарвалтын эсрэг тал руу эргүүлнэ",
  },
  {
    id: "338",
    test_id: "102",
    answer:
      "Түлш өгөлтийг багасгаж, жолооны хүрдээр хөдөлгөөнийг тогтворжуулна",
  },
  {
    id: "339",
    test_id: "102",
    answer: "Тоормослож, жолооны хүрдийг шарвасан тал руу эргүүлнэ",
  },
  {
    id: "340",
    test_id: "102",
    answer: "Түлш өгөлтийг нэмж, жолооны хүрдээр хөдөлгөөний  чигийг засна ",
  },
  {
    id: "341",
    test_id: "103",
    answer: "Хүнд араан дамжуулгыг ",
  },
  {
    id: "342",
    test_id: "103",
    answer: "Хөнгөн араан дамжуулгыг",
  },
  {
    id: "343",
    test_id: "104",
    answer:
      "Хөдөлгүүрийг унтрааж, авцуулах холбоо болон араан дамжуулгыг салгалгүй туулна",
  },
  {
    id: "344",
    test_id: "104",
    answer:
      "Хөдөлгүүрийг унтрааж, авцуулах холбоо буюу араан дамжуулгыг салгаж туулна",
  },
  {
    id: "345",
    test_id: "104",
    answer:
      "Хөдөлгүүрийг унтраахгүйгээр, авцуулах холбоо болон араан дамжуулгыг салгалгүй туулна",
  },
  {
    id: "346",
    test_id: "104",
    answer:
      "Хөдөлгүүрийг унтраахгүйгээр, авцуулах холбоо буюу араан дамжуулгыг салгаж туулна",
  },
  {
    id: "347",
    test_id: "105",
    answer: "Хориглоно",
  },
  {
    id: "348",
    test_id: "105",
    answer: "Зөвшөөрнө",
  },
  {
    id: "349",
    test_id: "105",
    answer:
      "Гараар дохио өгөх байдлаар аль ойр байгаа зогсоол буюу засварын газарт очихыг зөвшөөрнө",
  },
  {
    id: "350",
    test_id: "106",
    answer: "Зөвхөн жолооч",
  },
  {
    id: "351",
    test_id: "106",
    answer: "Зөвхөн жолооч болон урд суудалд сууж яваа зорчигч",
  },
  {
    id: "352",
    test_id: "106",
    answer: "Хамгаалах бүсээр тоноглосон суудалд сууж яваа бүх хүн",
  },
  {
    id: "353",
    test_id: "107",
    answer: "Зөвхөн тухайн зорчигчийн хүлээх үүрэг",
  },
  {
    id: "354",
    test_id: "107",
    answer: "Жолоочийн хүлээх үүрэг",
  },
  {
    id: "355",
    test_id: "107",
    answer: "Хоёулангийнх нь хүлээх үүрэг",
  },
  {
    id: "356",
    test_id: "108",
    answer: "Хориглоно",
  },
  {
    id: "357",
    test_id: "108",
    answer: "Зөвхөн арын суудалд тээвэрлэхийг хориглоно",
  },
  {
    id: "358",
    test_id: "108",
    answer: "Жолооч хамгаалах малгай өмссөн бол зөвшөөрнө",
  },
  {
    id: "359",
    test_id: "109",
    answer: "Тийм",
  },
  {
    id: "360",
    test_id: "109",
    answer: "Үгүй",
  },
  {
    id: "361",
    test_id: "109",
    answer: "Зөвхөн зорчигч зөрчил гаргасан",
  },
  {
    id: "362",
    test_id: "110",
    answer: "Хүлээнэ",
  },
  {
    id: "363",
    test_id: "110",
    answer: "Энэ нь зөвхөн осолд холбогдсон жолоочийн үүрэг тул хүлээхгүй",
  },
  {
    id: "364",
    test_id: "111",
    answer: "Тийм",
  },
  {
    id: "365",
    test_id: "111",
    answer: "Үгүй",
  },
  {
    id: "366",
    test_id: "112",
    answer: "Гэмт этгээдийг цагдаагийн байгууллагад хүргэхээр яваа",
  },
  {
    id: "367",
    test_id: "112",
    answer:
      "Эрүүл мэндэд нь ноцтой хохирол учирч болох гэмтэлтэй хүнийг эмнэлэгт хүргэхээр яваа",
  },
  {
    id: "368",
    test_id: "112",
    answer: "Гэмт этгээдийг мөрдөн хөөх зорилгоор яваа",
  },
  {
    id: "369",
    test_id: "112",
    answer: "Дээрх бүх тохиолдолд",
  },
  {
    id: "370",
    test_id: "113",
    answer: "Зөвшөөрнө",
  },
  {
    id: "371",
    test_id: "113",
    answer: "Хориглоно",
  },
  {
    id: "372",
    test_id: "114",
    answer: "Зөвхөн өөрийн явах чиглэлийн дагуу бол үйлчилнэ",
  },
  {
    id: "373",
    test_id: "114",
    answer: "Чиглэл үл харгалзан үйлчилнэ",
  },
  {
    id: "374",
    test_id: "114",
    answer: "Үйлчлэх үүрэг хүлээхгүй",
  },
  {
    id: "375",
    test_id: "115",
    answer: "Зөвхөн Б",
  },
  {
    id: "376",
    test_id: "115",
    answer: "Зөвхөн В",
  },
  {
    id: "377",
    test_id: "115",
    answer: "Зөвхөн Б, В",
  },
  {
    id: "378",
    test_id: "115",
    answer: "А, Б, В",
  },
  {
    id: "379",
    test_id: "115",
    answer: "Уулзвар руу орохыг хориглоно",
  },
  {
    id: "380",
    test_id: "116",
    answer: "Бүх чигт",
  },
  {
    id: "381",
    test_id: "116",
    answer: "Зөвхөн зүүн гар тийш болон буцаж эргэх чигт",
  },
  {
    id: "382",
    test_id: "116",
    answer: "Баруун гар тийш эргэхээс бусад чигт",
  },
  {
    id: "383",
    test_id: "117",
    answer: "Зөвхөн Б",
  },
  {
    id: "384",
    test_id: "117",
    answer: "Зөвхөн А, Б",
  },
  {
    id: "385",
    test_id: "117",
    answer: "Зөвхөн Б, В",
  },
  {
    id: "386",
    test_id: "117",
    answer: "А, Б, В",
  },
  {
    id: "387",
    test_id: "118",
    answer: "Зорчих хэсгийг чөлөөлөх",
  },
  {
    id: "388",
    test_id: "118",
    answer:
      "Тээврийн хэрэгслээ зогсоож, ослын дохионы гэрлээ асаах ба ослын зогсолтын тэмдгийг байрлуулах",
  },
  {
    id: "389",
    test_id: "118",
    answer: "Цагдаагийн байгууллагад мэдэгдэх",
  },
  {
    id: "390",
    test_id: "119",
    answer: "Зөвхөн А",
  },
  {
    id: "391",
    test_id: "119",
    answer: "Зөвхөн Б",
  },
  {
    id: "392",
    test_id: "119",
    answer: "Зөвхөн В",
  },
  {
    id: "393",
    test_id: "119",
    answer: "А, В",
  },
  {
    id: "394",
    test_id: "119",
    answer: "Б, В",
  },
  {
    id: "395",
    test_id: "120",
    answer: "Зөвхөн А",
  },
  {
    id: "396",
    test_id: "120",
    answer: "Зөвхөн Б",
  },
  {
    id: "397",
    test_id: "120",
    answer: "Зөвхөн Б, В",
  },
  {
    id: "398",
    test_id: "120",
    answer: "Зөвхөн А, Б",
  },
  {
    id: "399",
    test_id: "120",
    answer: "А, Б, В",
  },
  {
    id: "400",
    test_id: "121",
    answer: "Бололцоотой бол аль тааралдсан тээврийн хэрэгслээр хүргүүлнэ",
  },
  {
    id: "401",
    test_id: "121",
    answer: "Зөвхөн өөрийн жолоодож яваа тээврийн хэрэгслээр хүргэнэ",
  },
  {
    id: "402",
    test_id: "121",
    answer: "Зөвхөн эмнэлэгийн түргэн тусламжийн тээврийн хэрэгслээр хүргүүлнэ",
  },
  {
    id: "403",
    test_id: "122",
    answer: "Зөвхөн мотоцикл",
  },
  {
    id: "404",
    test_id: "122",
    answer: "Зөвхөн суудлын автомашин",
  },
  {
    id: "405",
    test_id: "122",
    answer: "Хоёул",
  },
  {
    id: "406",
    test_id: "123",
    answer: "Зөвхөн  баруун гар тийш",
  },
  {
    id: "407",
    test_id: "123",
    answer: "Зөвхөн зүүн гар тийш буюу буцаж эргэх чигт",
  },
  {
    id: "408",
    test_id: "123",
    answer: "Зөвхөн чигээрээ буюу баруун гар тийш",
  },
  {
    id: "409",
    test_id: "123",
    answer: "Бүх чигт",
  },
  {
    id: "410",
    test_id: "124",
    answer: "Зөвхөн  баруун гар тийш",
  },
  {
    id: "411",
    test_id: "124",
    answer: "Чигээрээ буюу баруун гар тийш ",
  },
  {
    id: "412",
    test_id: "124",
    answer: "Бүх чигт",
  },
  {
    id: "413",
    test_id: "124",
    answer: "Уулзвар руу орохыг хориглоно",
  },
  {
    id: "414",
    test_id: "125",
    answer: "Хориглоно",
  },
  {
    id: "415",
    test_id: "125",
    answer: "Зөвшөөрнө",
  },
  {
    id: "416",
    test_id: "125",
    answer:
      "Хөндлөнгийн хоёроос доошгүй гэрчийг байлцуулан,тээврийн хэрэгслийнхээ ул мөрийн байрлалыг тэмдэглэж, баримтжуулсны дараа хөдөлгөхийг зөвшөөрнө",
  },
  {
    id: "417",
    test_id: "126",
    answer: "Зөвхөн  баруун гар тийш эргэхийг зөвшөөрнө",
  },
  {
    id: "418",
    test_id: "126",
    answer: "Чигээрээ буюу баруун гар тийш нэвтрэхийг зөвшөөрнө",
  },
  {
    id: "419",
    test_id: "126",
    answer: "Зөвхөн буцаж эргэхийг зөвшөөрнө",
  },
  {
    id: "420",
    test_id: "126",
    answer: "Уулзвар руу орохыг хориглоно",
  },
  {
    id: "421",
    test_id: "127",
    answer: "Ослын тухай цагдаагийн байгууллагад яаралтай мэдэгдэх үүрэгтэй",
  },
  {
    id: "422",
    test_id: "127",
    answer:
      "Өөр хоорондоо зөвшилцөн тохиролцсон бол цагдаагийн байгууллагад мэдэгдэх шаардлагагүй",
  },
  {
    id: "423",
    test_id: "128",
    answer: "Зөвхөн А",
  },
  {
    id: "424",
    test_id: "128",
    answer: "Зөвхөн Б",
  },
  {
    id: "425",
    test_id: "128",
    answer: "Зөвхөн В, Г",
  },
  {
    id: "426",
    test_id: "128",
    answer: "Зөвхөн Б, В, Г",
  },
  {
    id: "427",
    test_id: "128",
    answer: "Бүх чигт",
  },
  {
    id: "428",
    test_id: "129",
    answer: "Баруун гар тийш эргэнэ",
  },
  {
    id: "429",
    test_id: "129",
    answer: "Чигээрээ явна",
  },
  {
    id: "430",
    test_id: "129",
    answer:
      "Зохицуулагчийн дараагийн зөвшөөрсөн дохиогоор зөвхөн чигээрээ явна",
  },
  {
    id: "431",
    test_id: "130",
    answer: "Шаардлагатай",
  },
  {
    id: "432",
    test_id: "130",
    answer: "Шаардлагагүй",
  },
  {
    id: "433",
    test_id: "130",
    answer:
      "Осолд холбогдсон жолооч нар өөр хоорондоо буюу даатгалын байгууллагатай харилцан маргаангүй шийдвэрлэхээр тохиролцсон бол шаардлагагүй",
  },
  {
    id: "434",
    test_id: "131",
    answer: "Зөвхөн  баруун гар тийш",
  },
  {
    id: "435",
    test_id: "131",
    answer: "Чигээрээ буюу баруун гар тийш ",
  },
  {
    id: "436",
    test_id: "131",
    answer: "Бүх чигт",
  },
  {
    id: "437",
    test_id: "131",
    answer: "Уулзвар руу орохыг хориглоно",
  },
  {
    id: "438",
    test_id: "132",
    answer: "Зөвшөөрнө",
  },
  {
    id: "439",
    test_id: "132",
    answer: "Хөдөлгөөний аюулгүй байдлыг хангаж чадахааргүй бол хориглоно",
  },
  {
    id: "440",
    test_id: "133",
    answer: "Зөвхөн  баруун гар тийш эргэхийг зөвшөөрнө",
  },
  {
    id: "441",
    test_id: "133",
    answer: "Чигээрээ буюу баруун гар тийш нэвтрэхийг зөвшөөрнө",
  },
  {
    id: "442",
    test_id: "133",
    answer: "Зөвхөн буцаж эргэхийг зөвшөөрнө",
  },
  {
    id: "443",
    test_id: "133",
    answer: "Уулзвар руу орохыг хориглоно",
  },
  {
    id: "444",
    test_id: "134",
    answer: "Зөвхөн А",
  },
  {
    id: "445",
    test_id: "134",
    answer: "Зөвхөн Б",
  },
  {
    id: "446",
    test_id: "134",
    answer: "Зөвхөн В, Г",
  },
  {
    id: "447",
    test_id: "134",
    answer: "Зөвхөн Б, В, Г",
  },
  {
    id: "448",
    test_id: "134",
    answer: "Бүх чигт",
  },
  {
    id: "449",
    test_id: "135",
    answer: "Зөвхөн тухайн ангиллын тээврийн хэрэгслийг жолоодох эрхгүй хүнд",
  },
  {
    id: "450",
    test_id: "135",
    answer:
      "Зөвхөн согтууруулах ундаа, мансууруулах эм, сэтгэцэд нөлөөт бодис хэрэглэсэн хүнд",
  },
  {
    id: "451",
    test_id: "135",
    answer:
      "Зөвхөн хөдөлгөөний аюулгүй байдлыг хангаж чадахааргүй өвчтэй буюу ядарсан хүнд",
  },
  {
    id: "452",
    test_id: "135",
    answer: "Дээрх бүгдэд",
  },
  {
    id: "453",
    test_id: "136",
    answer: "Баруун гар тийш эргэнэ",
  },
  {
    id: "454",
    test_id: "136",
    answer: "Чигээрээ явна",
  },
  {
    id: "455",
    test_id: "136",
    answer:
      "Зохицуулагчийн дараагийн зөвшөөрсөн дохиогоор зөвхөн чигээрээ явна",
  },
  {
    id: "456",
    test_id: "137",
    answer: "Хөдөлгөөнөө үргэлжлүүлнэ",
  },
  {
    id: "457",
    test_id: "137",
    answer: "Чигээ өөрчлөн баруун гар тийш эргэнэ",
  },
  {
    id: "458",
    test_id: "137",
    answer: "Уулзварын өмнө зогсож, зохицуулагчын дохио өөрчлөгдөхийг хүлээнэ",
  },
  {
    id: "459",
    test_id: "138",
    answer: "Зөвшөөрнө",
  },
  {
    id: "460",
    test_id: "138",
    answer: "Тэмдгийн заалтыг зөрчих тул хориглоно",
  },
  {
    id: "461",
    test_id: "139",
    answer: "Зөвшөөрнө",
  },
  {
    id: "462",
    test_id: "139",
    answer: "Хориглоно",
  },
  {
    id: "463",
    test_id: "139",
    answer: "Гарны оролцоотой ашиглах бол хориглоно",
  },
  {
    id: "464",
    test_id: "140",
    answer: "Зөвшөөрнө",
  },
  {
    id: "465",
    test_id: "140",
    answer: "Хориглоно",
  },
  {
    id: "466",
    test_id: "140",
    answer: "Гарны оролцоотойгоор ашиглах бол хориглоно",
  },
  {
    id: "467",
    test_id: "141",
    answer: "Зөвшөөрнө",
  },
  {
    id: "468",
    test_id: "141",
    answer: "Гарны оролцоогүйгээр ашиглах бол зөвшөөрнө",
  },
  {
    id: "469",
    test_id: "141",
    answer: "Хориглоно",
  },
  {
    id: "470",
    test_id: "142",
    answer: "Зохицуулагчийн дохиог баримталж зогсоно",
  },
  {
    id: "471",
    test_id: "142",
    answer: "Хориглох тэмдгийг баримтлан зогсохгүйгээр явна",
  },
  {
    id: "472",
    test_id: "142",
    answer: "Тэмдгийн үйлчлэх хүрээг өнгөрөөж зогсоно",
  },
  {
    id: "473",
    test_id: "143",
    answer: "Гарны оролцоогүйгээр ашиглах бол зөвшөөрнө",
  },
  {
    id: "474",
    test_id: "143",
    answer: "Бусдын дуут дохиог сонсох боломжийг хязгаарласан бол хориглоно",
  },
  {
    id: "475",
    test_id: "144",
    answer: "Гол замаас яваа тул зөвшөөрнө",
  },
  {
    id: "476",
    test_id: "144",
    answer: "Хориглоно",
  },
  {
    id: "477",
    test_id: "145",
    answer: "Хурдаа нэмнэ",
  },
  {
    id: "478",
    test_id: "145",
    answer: "Анхаарал болгоомжтойгоор хөдөлгөөнөө үргэлжлүүлнэ",
  },
  {
    id: "479",
    test_id: "145",
    answer:
      "Зохицуулагчийн заасан газарт буюу замын тухайн хэсэгт бусдын хөдөлгөөнд саад болхооргүй тохиромжтой байрлал сонгож зогсоно",
  },
  {
    id: "480",
    test_id: "146",
    answer: "Зүүн гар талын эгнээ чөлөөгүй бол зөвшөөрнө",
  },
  {
    id: "481",
    test_id: "146",
    answer: "Цуваа цагт 30 км-ээс бага хурдтай яваа бол зөвшөөрнө",
  },
  {
    id: "482",
    test_id: "146",
    answer: "Хориглоно",
  },
  {
    id: "483",
    test_id: "147",
    answer: "Зохицуулагчийн ойлгогдохуйц дохиог удирдлага болгоно",
  },
  {
    id: "484",
    test_id: "147",
    answer: "Дүрмийн тухайн заалтыг удирдлага болгоно",
  },
  {
    id: "485",
    test_id: "147",
    answer: "Зохицуулагчийн дараагийн дохиог хүлээнэ",
  },
  {
    id: "486",
    test_id: "148",
    answer: "Хориглоно",
  },
  {
    id: "487",
    test_id: "148",
    answer: "Зорчих хэсгийн өргөн хүрэлцэхгүй бол зөвшөөрнө",
  },
  {
    id: "488",
    test_id: "149",
    answer: "Шаардлагатай",
  },
  {
    id: "489",
    test_id: "149",
    answer: "Хориглоогүй газарт зогссон тохиолдолд шаардлагагүй",
  },
  {
    id: "490",
    test_id: "149",
    answer: "Ослын үед хүний амь нас, эрүүл мэнд хохироогүй бол шаардлагагүй",
  },
  {
    id: "491",
    test_id: "150",
    answer: "Хөдөлгөөний түгжирлээс шалгаалж  зогссон тохиолдолд",
  },
  {
    id: "492",
    test_id: "150",
    answer: "Бусдад зам тавьж өгөхийн тулд зогссон тохиолдолд",
  },
  {
    id: "493",
    test_id: "150",
    answer: "Зайлшгүй зогсолт хийсэн тохиолдолд",
  },
  {
    id: "494",
    test_id: "150",
    answer: "Дээрх бүх тохиолдолд",
  },
  {
    id: "495",
    test_id: "151",
    answer: "Шаардлагатай",
  },
  {
    id: "496",
    test_id: "151",
    answer: "Зогсохыг хориглоогүй газарт зогссон бол шаардлагагүй",
  },
  {
    id: "497",
    test_id: "152",
    answer: "Зөвхөн ачааны автомашин ",
  },
  {
    id: "498",
    test_id: "152",
    answer: "Зөвхөн суудлын автомашин",
  },
  {
    id: "499",
    test_id: "152",
    answer: "Хоёул",
  },
  {
    id: "500",
    test_id: "153",
    answer: "Зөвшөөрнө",
  },
  {
    id: "501",
    test_id: "153",
    answer: "Хориглоно",
  },
  {
    id: "502",
    test_id: "153",
    answer: "Зөвхөн хүн буулгах, суулгахын тулд түр зогсохыг зөвшөөрнө",
  },
  {
    id: "503",
    test_id: "154",
    answer: "Шаардлагатай",
  },
  {
    id: "504",
    test_id: "154",
    answer: "Оврын гэрлээ асаасан бол шаардлагагүй ",
  },
  {
    id: "505",
    test_id: "154",
    answer: "Замын гэрэлтүүлэгтэй хэсэгт зогссон бол шаардлагагүй",
  },
  {
    id: "506",
    test_id: "155",
    answer: "Ослын дохионы гэрлийг асаана",
  },
  {
    id: "507",
    test_id: "155",
    answer: "Ойрын гэрлийг асаана",
  },
  {
    id: "508",
    test_id: "155",
    answer: "Хориглоогүй газарт зогссон бол гэрэл асаах шаардлагагүй ",
  },
  {
    id: "509",
    test_id: "156",
    answer: "Зөвхөн баруун гар тийш",
  },
  {
    id: "510",
    test_id: "156",
    answer: "Зөвхөн чигээрээ буюу баруун гар тийш",
  },
  {
    id: "511",
    test_id: "156",
    answer: "Бүх чигт",
  },
  {
    id: "512",
    test_id: "157",
    answer: "Хөдөлгөөний аюулгүй байдлыг хангасан нөхцөлд зөвшөөрнө",
  },
  {
    id: "513",
    test_id: "157",
    answer: "Тусгай дуут дохиогоо хамт ажиллуулаагүй тохиолдолд хориглоно",
  },
  {
    id: "514",
    test_id: "157",
    answer: "Суурин газрын доторх замд хориглоно",
  },
  {
    id: "515",
    test_id: "158",
    answer: "Шаардлагатай",
  },
  {
    id: "516",
    test_id: "158",
    answer: "Замын гэрэлтүүлэгтэй хэсэгт зогссон тохиолдолд шаардлагагүй",
  },
  {
    id: "517",
    test_id: "159",
    answer: "Тусгай гэрлэн дохиогоо ажиллуулсан тохиолдолд",
  },
  {
    id: "518",
    test_id: "159",
    answer:
      "Тусгай гэрлэн дохиог тусгай дуут дохиотой хамт ажиллуулсан тохиолдолд",
  },
  {
    id: "519",
    test_id: "159",
    answer: "Дээрх хоёр тохиолдолд",
  },
  {
    id: "520",
    test_id: "160",
    answer: "Зориулалтын бус газарт зайлшгүй зогсолт хийснийг",
  },
  {
    id: "521",
    test_id: "160",
    answer: "Уг автобус хүүхэд тээвэрлэхэд зориулагдсан болохыг",
  },
  {
    id: "522",
    test_id: "160",
    answer: "Автобусаас хүүхэд буулгаж буюу түүнд суулгаж байгааг",
  },
  {
    id: "523",
    test_id: "160",
    answer: "Өдрийн цагт асаах ойрын гэрэл нь асахгүй болсныг",
  },
  {
    id: "524",
    test_id: "161",
    answer: "Гэрлэн дохионы заалтыг",
  },
  {
    id: "525",
    test_id: "161",
    answer: "Зам тавьж өгөхийг шаардсан тэмдгийн заалтыг",
  },
  {
    id: "526",
    test_id: "161",
    answer: "Тэмдэглэлийн заалтыг",
  },
  {
    id: "527",
    test_id: "161",
    answer: "Дээрх бүгдийг",
  },
  {
    id: "528",
    test_id: "162",
    answer: "Ослын дохионы гэрлээ асаана",
  },
  {
    id: "529",
    test_id: "162",
    answer: "Холын гэрлээ асаана",
  },
  {
    id: "530",
    test_id: "162",
    answer: "Холын гэрлээ ойрын гэрэлд шүүлжүүлнэ",
  },
  {
    id: "531",
    test_id: "163",
    answer: "Чирч яваа ",
  },
  {
    id: "532",
    test_id: "163",
    answer: "Чирүүлж яваа",
  },
  {
    id: "533",
    test_id: "163",
    answer: "Хоёул",
  },
  {
    id: "534",
    test_id: "164",
    answer: "Тийм",
  },
  {
    id: "535",
    test_id: "164",
    answer: "Үгүй",
  },
  {
    id: "536",
    test_id: "165",
    answer: "5 м-ээс багагүй зайд",
  },
  {
    id: "537",
    test_id: "165",
    answer: "15 м-ээс багагүй зайд",
  },
  {
    id: "538",
    test_id: "165",
    answer: "30 м-ээс багагүй зайд",
  },
  {
    id: "539",
    test_id: "165",
    answer: "50-ээс багагүй зайд",
  },
  {
    id: "540",
    test_id: "166",
    answer: "5 м-ээс багагүй зайд",
  },
  {
    id: "541",
    test_id: "166",
    answer: "15 м-ээс багагүй зайд",
  },
  {
    id: "542",
    test_id: "166",
    answer: "30 м-ээс багагүй зайд",
  },
  {
    id: "543",
    test_id: "166",
    answer: "50-ээс багагүй зайд",
  },
  {
    id: "544",
    test_id: "167",
    answer: "15 м-ээс багагүй зайд",
  },
  {
    id: "545",
    test_id: "167",
    answer: "30 м-ээс багагүйзайд",
  },
  {
    id: "546",
    test_id: "167",
    answer: "50 м-ээс багагүй зайд",
  },
  {
    id: "547",
    test_id: "167",
    answer: "100 м-ээс багагүй зайд",
  },
  {
    id: "548",
    test_id: "168",
    answer: "Баруун гар талын эгнээнд шилжиж, чөлөөтэй зорчих боломжийг хангах",
  },
  {
    id: "549",
    test_id: "168",
    answer: "Баруун гар талын эгнээнд шилжиж, зогсож өнгөрүүлэх",
  },
  {
    id: "550",
    test_id: "169",
    answer: "Шаардлагатай",
  },
  {
    id: "551",
    test_id: "169",
    answer: "Ослын дохионы гэрлээ асаасан бол шаардлагагүй",
  },
  {
    id: "552",
    test_id: "170",
    answer:
      "Ойртон ирж яваа бусад жолооч нарт харагдахаар газарт зогссон тохиолдолд шаардлагагүй",
  },
  {
    id: "553",
    test_id: "170",
    answer: "Ослын дохионы гэрэл нь ажиллахгүй тохиолдолд шаардлагатай",
  },
  {
    id: "554",
    test_id: "171",
    answer: "Зөвхөн тусгай дуут болон гэрлэн дохио ажиллуулсан автомашинд",
  },
  {
    id: "555",
    test_id: "171",
    answer:
      "Тусгай дуут болон гэрлэн дохио ажиллуулсан автомашинд болон цуваагаар яваа тээврийн хэрэгслүүдэд",
  },
  {
    id: "556",
    test_id: "171",
    answer: "Зам тавьж өгөх шаардлагагүй",
  },
  {
    id: "557",
    test_id: "172",
    answer: "Захын үргэлжилсэн шугамд шахаж, зорчих хэсэг дээр зогсооно",
  },
  {
    id: "558",
    test_id: "172",
    answer: "Хашлаганд шахаж, хөвөөн дээр зогсооно",
  },
  {
    id: "559",
    test_id: "173",
    answer: "Зөвхөн А",
  },
  {
    id: "560",
    test_id: "173",
    answer: "Зөвхөн Б",
  },
  {
    id: "561",
    test_id: "173",
    answer: "Хоёуланг нь хориглоно",
  },
  {
    id: "562",
    test_id: "173",
    answer: "Хоёуланг нь зөвшөөрнө",
  },
  {
    id: "563",
    test_id: "174",
    answer: "Хашлагыг давж, явган хүний зам дээр гаргаж зогсооно",
  },
  {
    id: "564",
    test_id: "174",
    answer: "Хашлагыг унуулж зогсооно",
  },
  {
    id: "565",
    test_id: "174",
    answer: "Хашлаганд шахаж зогсооно",
  },
  {
    id: "566",
    test_id: "175",
    answer: "Шаардлагатай",
  },
  {
    id: "567",
    test_id: "175",
    answer: "Шаардлагагүй",
  },
  {
    id: "568",
    test_id: "175",
    answer:
      "Тусгай дохиогоо дуугаргах буюу чанга яригч хэрэгслээр шаардвал зогсоно",
  },
  {
    id: "569",
    test_id: "176",
    answer:
      "Шаардлагатай тохиолдолд нэн даруй зогсох боломжтой байхаар хурдаа хасна",
  },
  {
    id: "570",
    test_id: "176",
    answer: "Хурдаа хасахгүйгээр хөдөлгөөнөө үргэлжлүүлнэ",
  },
  {
    id: "571",
    test_id: "176",
    answer:
      "Зогсож, цагдаагийн ажилтанг зөвшөөрсний дараа хөдөлгөөнөө үргэлжлүүлнэ",
  },
  {
    id: "572",
    test_id: "177",
    answer: "Зөвхөн холын гэрэл",
  },
  {
    id: "573",
    test_id: "177",
    answer: "Зөвхөн ойрын гэрэл",
  },
  {
    id: "574",
    test_id: "177",
    answer: "Холын буюу ойрын гэрэл",
  },
  {
    id: "575",
    test_id: "178",
    answer: "Төмөр замын хаалттай гарамд ойртож байгааг",
  },
  {
    id: "576",
    test_id: "178",
    answer: "Зам дээр засварын ажил хийгдэж байгааг",
  },
  {
    id: "577",
    test_id: "178",
    answer: "Зам хаалттай байгааг",
  },
  {
    id: "578",
    test_id: "179",
    answer: "Холын гэрэл ",
  },
  {
    id: "579",
    test_id: "179",
    answer: "Ойрын гэрэл ",
  },
  {
    id: "580",
    test_id: "179",
    answer: "Оврын гэрэл",
  },
  {
    id: "581",
    test_id: "179",
    answer: "Гэрэл хэрэглэх шаардлагагүй",
  },
  {
    id: "582",
    test_id: "180",
    answer: "Зөвхөн А",
  },
  {
    id: "583",
    test_id: "180",
    answer: "Зөвхөн Б, В",
  },
  {
    id: "584",
    test_id: "180",
    answer: "Зөвхөн А, В",
  },
  {
    id: "585",
    test_id: "180",
    answer: "А, Б, В",
  },
  {
    id: "586",
    test_id: "181",
    answer: "50 метр ",
  },
  {
    id: "587",
    test_id: "181",
    answer: "100 метр",
  },
  {
    id: "588",
    test_id: "181",
    answer: "150 метр",
  },
  {
    id: "589",
    test_id: "181",
    answer: "300 метр",
  },
  {
    id: "590",
    test_id: "182",
    answer: "Зөвшөөрнө",
  },
  {
    id: "591",
    test_id: "182",
    answer: "Хориглоно",
  },
  {
    id: "592",
    test_id: "182",
    answer: "Зөвхөн хүн буулгах, суулгахын тулд түр зогсохыг зөвшөөрнө",
  },
  {
    id: "593",
    test_id: "183",
    answer: "Өөдөөс тээврийн хэрэгсэл гарч ирж болзошгүй тул шаардлагатай",
  },
  {
    id: "594",
    test_id: "183",
    answer: "Шаардлагагүй",
  },
  {
    id: "595",
    test_id: "184",
    answer: "Үргэлжилсэн шугамыг давж, зорчих хэсгийг чөлөөлж зогсооно",
  },
  {
    id: "596",
    test_id: "184",
    answer: "Үргэлжилсэн шугамд шахаж, зорчих хэсэг дээр зогсооно",
  },
  {
    id: "597",
    test_id: "185",
    answer: "1",
  },
  {
    id: "598",
    test_id: "185",
    answer: "2",
  },
  {
    id: "599",
    test_id: "186",
    answer: "Зөвхөн А",
  },
  {
    id: "600",
    test_id: "186",
    answer: "Зөвхөн Б",
  },
  {
    id: "601",
    test_id: "186",
    answer: "А, Б",
  },
  {
    id: "602",
    test_id: "187",
    answer: "Ослын дохионы гэрлээ асааж зогсоно",
  },
  {
    id: "603",
    test_id: "187",
    answer: "Холын гэрлээ ойрын гэрэлд нэн даруй шилжүүлнэ",
  },
  {
    id: "604",
    test_id: "187",
    answer:
      "Өөдөөс яваа автомашин зөвхөн 150 м-ийн дотор ойртож ирсэн үед холын гэрлээ ойрын гэрэлд шилжүүлнэ",
  },
  {
    id: "605",
    test_id: "188",
    answer: "Адил замын уулзвар нэвтрэх журам",
  },
  {
    id: "606",
    test_id: "188",
    answer: "Гол ба туслах замын уулзвар нэвтрэх журам",
  },
  {
    id: "607",
    test_id: "188",
    answer: "Гарц нэвтрэх журам",
  },
  {
    id: "608",
    test_id: "189",
    answer: "Дуут дохио өгнө",
  },
  {
    id: "609",
    test_id: "189",
    answer: "Ослын дохионы гэрлээ асаана",
  },
  {
    id: "610",
    test_id: "189",
    answer: "Зүүн гар тийш дохио өгнө",
  },
  {
    id: "611",
    test_id: "189",
    answer: "Гэрэл шилжүүлэх дохио өгнө",
  },
  {
    id: "612",
    test_id: "190",
    answer: "Хориглоно",
  },
  {
    id: "613",
    test_id: "190",
    answer:
      "Өөдөөс яваа тээврийн хэрэгслийн хөдөлгөөнд саад учруулахгүй бол зөвшөөрнө",
  },
  {
    id: "2055",
    test_id: "663",
    answer: "Б, Г",
  },
  {
    id: "2052",
    test_id: "663",
    answer: "Зөвхөн А",
  },
  {
    id: "2053",
    test_id: "663",
    answer: "Зөвхөн Б",
  },
  {
    id: "2054",
    test_id: "663",
    answer: "А, Б",
  },
  {
    id: "616",
    test_id: "192",
    answer: "Зөвхөн А",
  },
  {
    id: "617",
    test_id: "192",
    answer: "Зөвхөн Б",
  },
  {
    id: "618",
    test_id: "192",
    answer: "А, Б",
  },
  {
    id: "619",
    test_id: "193",
    answer: "Чигээ өөрчилж гялбалтын хүрээнээс гарна",
  },
  {
    id: "620",
    test_id: "193",
    answer: "Гэрлээ унтрааж, зорчих хэсгийг чөлөөлж зогсоно",
  },
  {
    id: "621",
    test_id: "193",
    answer:
      "Ослын дохионы гэрлээ асааж, эзэлж яваа эгнээгээ өөрчлөхгүйгээр хурдаа хасах буюу зогсоно",
  },
  {
    id: "622",
    test_id: "194",
    answer: "Холын гэрэл ",
  },
  {
    id: "623",
    test_id: "194",
    answer: "Ойрын гэрэл ",
  },
  {
    id: "624",
    test_id: "194",
    answer: "Оврын гэрэл",
  },
  {
    id: "625",
    test_id: "194",
    answer: "Гэрэл асаах шаардлагагүй",
  },
  {
    id: "626",
    test_id: "195",
    answer: "Төмөр замын гармын өмнөх гэрэл дохионы зохицуулгыг",
  },
  {
    id: "627",
    test_id: "195",
    answer: "Уулзвар буюу явган хүний гарцын  өмнөх гэрэл дохионы зохицуулгыг",
  },
  {
    id: "628",
    test_id: "195",
    answer: "Бүх төрлийн гэрэл дохионы зохицуулгыг",
  },
  {
    id: "629",
    test_id: "196",
    answer: "Зөвхөн ачааны автомашин",
  },
  {
    id: "630",
    test_id: "196",
    answer: "Зөвхөн суудлын автомашин",
  },
  {
    id: "631",
    test_id: "196",
    answer: "Хоёул буруу",
  },
  {
    id: "632",
    test_id: "196",
    answer: "Хоёул зөв",
  },
  {
    id: "633",
    test_id: "197",
    answer: "Шаардлагагүй",
  },
  {
    id: "634",
    test_id: "197",
    answer: "Зөвхөн оврын гэрлийг асаах шаардлагатай",
  },
  {
    id: "635",
    test_id: "197",
    answer:
      "Оврын гэрэлтэй хамт ойрын буюу манангийн гэрлийг асаах шаардлагатай",
  },
  {
    id: "636",
    test_id: "198",
    answer: "Хориглоно",
  },
  {
    id: "637",
    test_id: "198",
    answer: "Өөдөөс тээврийн хэрэгсэлгүй үед зөвшөөрнө",
  },
  {
    id: "638",
    test_id: "198",
    answer:
      "Зөвхөн тусгай дуут болон гэрлэн дохиогоор тоноглосон автомашины жолооч албан үүрэг гүйцэтгэж явахдаа шаардлагатай үед хэрэглэхийг зөвшөөрнө",
  },
  {
    id: "639",
    test_id: "199",
    answer: "Гэмтээгүй талаас нь тайлах буюу өмсүүлнэ",
  },
  {
    id: "640",
    test_id: "199",
    answer: "Гэмтсэн талаас нь тайлах буюу өмсүүлнэ",
  },
  {
    id: "641",
    test_id: "199",
    answer: "Гэмтээгүй талаас нь тайлж, гэмтсэн талаас нь өмсүүлнэ",
  },
  {
    id: "642",
    test_id: "199",
    answer: "Гэмтсэн талаас нь тайлж, гэмтээгүй талаас нь өмсүүлнэ",
  },
  {
    id: "643",
    test_id: "200",
    answer: "Зөвшөөрнө",
  },
  {
    id: "644",
    test_id: "200",
    answer: "Хориглоно",
  },
  {
    id: "645",
    test_id: "200",
    answer: "Зөвхөн түр зогсохыг зөвшөөрнө",
  },
  {
    id: "646",
    test_id: "201",
    answer: "Замын огцом эргэх хэсгийг",
  },
  {
    id: "647",
    test_id: "201",
    answer: "Уулзвар дахь гол замын чигийг",
  },
  {
    id: "648",
    test_id: "201",
    answer: "Замын огцом өгсүүр хэсгийг",
  },
  {
    id: "649",
    test_id: "202",
    answer: "1",
  },
  {
    id: "650",
    test_id: "202",
    answer: "2",
  },
  {
    id: "651",
    test_id: "202",
    answer: "3",
  },
  {
    id: "652",
    test_id: "203",
    answer: "Шархны бүх гадаргууд түрхэнэ",
  },
  {
    id: "653",
    test_id: "203",
    answer: "Шархны зөвхөн ирмэг болон түүнийг тойрсон арьсанд түрхэнэ",
  },
  {
    id: "654",
    test_id: "204",
    answer: "Зөвхөн хамгийн баруун гар талын эгнээгээр ",
  },
  {
    id: "655",
    test_id: "204",
    answer: "Зөвхөн баруун гар талаас хоёр дахь эгнээгээр ",
  },
  {
    id: "656",
    test_id: "204",
    answer:
      "Хамгийн баруун болон хамгийн зүүн гар талын эгнээнээс бусад эгнээгээр",
  },
  {
    id: "657",
    test_id: "205",
    answer: "Шархан дээр даралттай боолт хийнэ",
  },
  {
    id: "658",
    test_id: "205",
    answer: "Шархны дээд хэсэгт чангалуур тавина",
  },
  {
    id: "659",
    test_id: "205",
    answer: "Шархны доод хэсэгт чангалуур тавина",
  },
  {
    id: "660",
    test_id: "205",
    answer: "Шархыг ариутгаж боох буюу шархны наалт тавина",
  },
  {
    id: "661",
    test_id: "206",
    answer: "Шархан дээр даралттай боолт хийнэ",
  },
  {
    id: "662",
    test_id: "206",
    answer: "Шархны дээд хэсэгт чангалуур тавина",
  },
  {
    id: "663",
    test_id: "206",
    answer: "Шархны доод хэсэгт чангалуур тавина",
  },
  {
    id: "664",
    test_id: "207",
    answer: "Шархан дээр",
  },
  {
    id: "665",
    test_id: "207",
    answer: "Шархны дээд хэсэгт",
  },
  {
    id: "666",
    test_id: "207",
    answer: "Шархны доод хэсэгт",
  },
  {
    id: "667",
    test_id: "208",
    answer:
      "Дулааны улиралд 30 минутаас ихгүй, хүйтний улиралд 1 цагаас ихгүй ",
  },
  {
    id: "668",
    test_id: "208",
    answer: "Дулааны улиралд 1 цагаас ихгүй, хүйтний улиралд 30 минутаас ихгүй",
  },
  {
    id: "669",
    test_id: "208",
    answer: "Аль ч улиралд 1 цагаас ихгүй",
  },
  {
    id: "670",
    test_id: "208",
    answer: "Аль ч улиралд 2 цагаас ихгүй",
  },
  {
    id: "671",
    test_id: "209",
    answer: "Налуу түшлэгтэй зөөлөн сандалд суулгана",
  },
  {
    id: "672",
    test_id: "209",
    answer: "Цээжин биеийг нь хагас өндийлгөж хэвтүүлнэ",
  },
  {
    id: "673",
    test_id: "209",
    answer: "Хөлийг нь хагас өндөрлөж  хэвтүүлнэ.",
  },
  {
    id: "674",
    test_id: "210",
    answer:
      "Зүрхэнд гадна талын иллэг хийж, амьсгалын замыг чөлөөлөн, хиймэл амьсгал хийнэ",
  },
  {
    id: "675",
    test_id: "210",
    answer:
      "Хиймэл амьсгал хийж, зүрхэнд гадна талын иллэг хийн, амьсгалын замыг чөлөөлнө",
  },
  {
    id: "676",
    test_id: "210",
    answer:
      "Амьсгалын замыг чөлөөлөн, хиймэл амьсгал хийж, зүрхэнд гадна талын иллэг хийнэ",
  },
  {
    id: "677",
    test_id: "211",
    answer: "Тээврийн хэрэгслийг ачиж журамлахыг",
  },
  {
    id: "678",
    test_id: "211",
    answer: "Уулын өндөрлөг хясаа, цавчим эрэгт ойртож байгааг",
  },
  {
    id: "679",
    test_id: "211",
    answer: "Замын огцом өгсүүр хэсэгт ойртож байгааг",
  },
  {
    id: "680",
    test_id: "212",
    answer: "Хатуу тавцан дээр хэвлийгээр нь доош харуулан хэвтүүлэх байдлаар",
  },
  {
    id: "681",
    test_id: "212",
    answer: "Хатуу тавцан дээр дээш харуулан нуруугаар нь хэвтүүлэх байдлаар ",
  },
  {
    id: "682",
    test_id: "212",
    answer: "Зөөлөн дэвсгэр дээр хэвтүүлэх байдлаар ",
  },
  {
    id: "683",
    test_id: "212",
    answer: "Суугаа болон хагас суугаа байдлаар",
  },
  {
    id: "684",
    test_id: "213",
    answer: "Шаардлагатай",
  },
  {
    id: "685",
    test_id: "213",
    answer: "Шаардлагагүй",
  },
  {
    id: "686",
    test_id: "213",
    answer:
      "Ойртон ирж яваа бусад жолооч нарт харагдахааргүй газарт зогссон бол шаардлагатай",
  },
  {
    id: "687",
    test_id: "214",
    answer: "50-100 метр",
  },
  {
    id: "688",
    test_id: "214",
    answer: "100-150 метр",
  },
  {
    id: "689",
    test_id: "214",
    answer: "150-300 метр",
  },
  {
    id: "690",
    test_id: "215",
    answer: "Тэмдэг байрласан хэсгээс",
  },
  {
    id: "691",
    test_id: "215",
    answer: "Тэмдгээс цааш 50-100 метрээс",
  },
  {
    id: "692",
    test_id: "215",
    answer: "Тэмдгээс цааш 150-300 метрээс",
  },
  {
    id: "693",
    test_id: "216",
    answer: "Хажуугаар нь хэвтүүлэх байдлаар",
  },
  {
    id: "694",
    test_id: "216",
    answer: "Дээш харуулан нуруугаар нь хэвтүүлэх байдлаар",
  },
  {
    id: "695",
    test_id: "216",
    answer: "Хэвлийгээр нь доош харуулан хэвтүүлэх байдлаар",
  },
  {
    id: "696",
    test_id: "216",
    answer: "Суугаа болон хагас суугаа байдлаар",
  },
  {
    id: "697",
    test_id: "217",
    answer: "Замын энэ хэсгээс эхлэн",
  },
  {
    id: "698",
    test_id: "217",
    answer: "Замын аюул бүхий хэсэгт очсон үеэс эхлэн",
  },
  {
    id: "699",
    test_id: "217",
    answer: "Замын аюул бүхий хэсэг рүү орсон үеэс эхлэн",
  },
  {
    id: "700",
    test_id: "218",
    answer: "Зөвшөөрнө",
  },
  {
    id: "701",
    test_id: "218",
    answer: "Хориглоно",
  },
  {
    id: "702",
    test_id: "219",
    answer:
      "Ачааны автомашины тэвшинд ачааг дагалдаж яваа хүмүүсийг тээвэрлэсэн бол зөвшөөрнө",
  },
  {
    id: "703",
    test_id: "219",
    answer: "Суудлын автомашинд хүн тээвэрлээгүй бол зөвшөөрнө",
  },
  {
    id: "704",
    test_id: "219",
    answer: "Хориглоно",
  },
  {
    id: "705",
    test_id: "220",
    answer: "Зөвхөн А",
  },
  {
    id: "706",
    test_id: "220",
    answer: "Зөвхөн Б",
  },
  {
    id: "707",
    test_id: "220",
    answer: "А, Б",
  },
  {
    id: "708",
    test_id: "221",
    answer: "Зөвхөн наана яваа хүн",
  },
  {
    id: "709",
    test_id: "221",
    answer: "Зөвхөн цаана яваа хүн",
  },
  {
    id: "710",
    test_id: "221",
    answer: "Хоёул",
  },
  {
    id: "711",
    test_id: "222",
    answer: "Зөвшөөрнө",
  },
  {
    id: "712",
    test_id: "222",
    answer: "Зөвхөн хатуу холбоогоор чирэхийг зөвшөөрнө",
  },
  {
    id: "713",
    test_id: "222",
    answer: "Зөвхөн цоройлгон ачих байдлаар чирэхийг зөвшөөрнө",
  },
  {
    id: "714",
    test_id: "222",
    answer: "Дээрх хоёр аргаар чирэхийг зөвшөөрнө",
  },
  {
    id: "715",
    test_id: "222",
    answer: "Хориглоно",
  },
  {
    id: "716",
    test_id: "223",
    answer: "Дээрээс шороо, чулуу нурж болзошгүйг",
  },
  {
    id: "717",
    test_id: "223",
    answer: "Замын хажуугийн хөвөө нурж болзошгүйг",
  },
  {
    id: "718",
    test_id: "223",
    answer: "Хажуугаас хүчтэй салхилж болзошгүйг",
  },
  {
    id: "719",
    test_id: "224",
    answer: "Онгоцтой шүргэлцэж болзошгүй аюулыг",
  },
  {
    id: "720",
    test_id: "224",
    answer: "Зорчих хэсэг дээр онгоц бууж болзошгүйг",
  },
  {
    id: "721",
    test_id: "224",
    answer: "Онгоцны дуу чимээнээс цочирдохгүй байхыг",
  },
  {
    id: "722",
    test_id: "225",
    answer:
      "Ачааны автомашины тэвшинд ачааг дагалдаж яваа хүмүүсийг тээвэрлэсэн бол зөвшөөрнө",
  },
  {
    id: "723",
    test_id: "225",
    answer: "Суудлын автомашинд хүн тээвэрлээгүй бол зөвшөөрнө",
  },
  {
    id: "724",
    test_id: "225",
    answer: "Хориглоно",
  },
  {
    id: "725",
    test_id: "226",
    answer:
      "Хонгил дотор тээврийн хэрэгслийнхээ гадна талын гэрэлтүүлэх хэрэгслийг хэрэглэх шаардлагатайг",
  },
  {
    id: "726",
    test_id: "226",
    answer: "Хонгил доторх зорчих хэсэг огцом өгсүүр болохыг",
  },
  {
    id: "727",
    test_id: "226",
    answer: "Хонгил нарийсахыг",
  },
  {
    id: "728",
    test_id: "227",
    answer: "Зөвшөөрнө",
  },
  {
    id: "729",
    test_id: "227",
    answer: "Хориглоно",
  },
  {
    id: "730",
    test_id: "228",
    answer: "Зөвшөөрнө",
  },
  {
    id: "731",
    test_id: "228",
    answer: "Зөвхөн хатуу холбоогоор чирэхийг зөвшөөрнө",
  },
  {
    id: "732",
    test_id: "228",
    answer: "Зөвхөн цоройлгон ачих байдлаар чирэхийг зөвшөөрнө",
  },
  {
    id: "733",
    test_id: "228",
    answer: "Дээрх хоёр аргаар чирэхийг зөвшөөрнө",
  },
  {
    id: "734",
    test_id: "228",
    answer: "Хориглоно",
  },
  {
    id: "735",
    test_id: "229",
    answer: "Т-хэлбэрийн уулзвар буюу замын салаалсан хэсэгт эргэх чигийг",
  },
  {
    id: "736",
    test_id: "229",
    answer:
      "Замын үзэгдэлт хязгаарлагдмал, эргэх радиус багатай хэсэгт эргэх чигийг",
  },
  {
    id: "737",
    test_id: "230",
    answer: "Зөвшөөрнө",
  },
  {
    id: "738",
    test_id: "230",
    answer: "Хориглоно",
  },
  {
    id: "739",
    test_id: "230",
    answer:
      "Чиргүүлтэй автомашины нийлбэр бодит жин нь чирч яваа автомашиныхаас илүүгүй бол зөвшөөрнө",
  },
  {
    id: "740",
    test_id: "231",
    answer: "Дүрэмд тусгагдсан бүх анхааруулах тэмдгийн утгыг агуулна",
  },
  {
    id: "741",
    test_id: "231",
    answer:
      "Дүрэмд тусгагдсан тэмдгээр анхааруулаагүй бусад аюул бүхий замын хэсгийг анхааруулна",
  },
  {
    id: "742",
    test_id: "231",
    answer: "Анхааруулах тэмдгүүдийн үйлчлэлийг төгсгөнө",
  },
  {
    id: "743",
    test_id: "232",
    answer: "Зөвхөн А",
  },
  {
    id: "744",
    test_id: "232",
    answer: "Зөвхөн Б",
  },
  {
    id: "745",
    test_id: "232",
    answer: "А, Б",
  },
  {
    id: "746",
    test_id: "233",
    answer: "Зөвхөн А",
  },
  {
    id: "747",
    test_id: "233",
    answer: "Зөвхөн Б",
  },
  {
    id: "748",
    test_id: "233",
    answer: "А, Б",
  },
  {
    id: "749",
    test_id: "234",
    answer: "Зөвхөн А",
  },
  {
    id: "750",
    test_id: "234",
    answer: "Зөвхөн Б",
  },
  {
    id: "751",
    test_id: "234",
    answer: "Зөвхөн А, В",
  },
  {
    id: "752",
    test_id: "234",
    answer: "А, Б, В",
  },
  {
    id: "753",
    test_id: "235",
    answer: "Тийм",
  },
  {
    id: "754",
    test_id: "235",
    answer: "Үгүй",
  },
  {
    id: "755",
    test_id: "236",
    answer: "Зөвхөн Б",
  },
  {
    id: "756",
    test_id: "236",
    answer: "Зөвхөн В",
  },
  {
    id: "757",
    test_id: "236",
    answer: "Зөвхөн Б, В",
  },
  {
    id: "758",
    test_id: "236",
    answer: "Зөвхөн А, Б",
  },
  {
    id: "759",
    test_id: "236",
    answer: "А, Б, В",
  },
  {
    id: "760",
    test_id: "237",
    answer: "Зөвхөн чиргүүл чирч яваа ",
  },
  {
    id: "761",
    test_id: "237",
    answer: "Зөвхөн механикжсан тээврийн хэрэгсэл чирч яваа",
  },
  {
    id: "762",
    test_id: "237",
    answer: "Хоёуланг хориглоно",
  },
  {
    id: "763",
    test_id: "237",
    answer: "Хоёуланг зөвшөөрнө",
  },
  {
    id: "764",
    test_id: "238",
    answer: "Зөвшөөрнө",
  },
  {
    id: "765",
    test_id: "238",
    answer: "Хориглоно",
  },
  {
    id: "766",
    test_id: "239",
    answer: "Зөвхөн В",
  },
  {
    id: "767",
    test_id: "239",
    answer: "Зөвхөн Б",
  },
  {
    id: "768",
    test_id: "239",
    answer: "А, В",
  },
  {
    id: "769",
    test_id: "240",
    answer: "Зөвшөөрнө",
  },
  {
    id: "770",
    test_id: "240",
    answer: "Хориглоно",
  },
  {
    id: "771",
    test_id: "241",
    answer: "Зөвхөн А, Б",
  },
  {
    id: "772",
    test_id: "241",
    answer: "Зөвхөн А, В",
  },
  {
    id: "773",
    test_id: "241",
    answer: "Зөвхөн Б, Г",
  },
  {
    id: "774",
    test_id: "241",
    answer: "Зөвхөн А, Б, В",
  },
  {
    id: "775",
    test_id: "241",
    answer: "А, Б, В, Г",
  },
  {
    id: "776",
    test_id: "242",
    answer: "Зөвшөөрнө",
  },
  {
    id: "777",
    test_id: "242",
    answer: "Өөдөөс яваа тээврийн хэрэгсэлгүй үед зөвшөөрнө",
  },
  {
    id: "778",
    test_id: "242",
    answer: "Хориглоно",
  },
  {
    id: "779",
    test_id: "243",
    answer: "Зөвшөөрнө",
  },
  {
    id: "780",
    test_id: "243",
    answer: "Хориглоно",
  },
  {
    id: "781",
    test_id: "244",
    answer: "Зөвшөөрнө",
  },
  {
    id: "782",
    test_id: "244",
    answer: "Хориглоно",
  },
  {
    id: "783",
    test_id: "245",
    answer: "Зөвшөөрнө",
  },
  {
    id: "784",
    test_id: "245",
    answer: "Хориглоно",
  },
  {
    id: "785",
    test_id: "245",
    answer:
      "Удаан явдалт тээврийн хэрэгсэл, ердийн хөсөг, унадаг дугуй, мопед, хоёр дугуйт мотоциклоос бусад тээврийн хэрэгслийг гүйцэж түрүүлэхийг хориглоно",
  },
  {
    id: "786",
    test_id: "246",
    answer: "Цагт 50 км-ээс ихгүй",
  },
  {
    id: "787",
    test_id: "246",
    answer: "Цагт 80 км-ээс ихгүй",
  },
  {
    id: "788",
    test_id: "246",
    answer: "Цагт 50-аас 80 км-ийн хооронд",
  },
  {
    id: "789",
    test_id: "247",
    answer: "Зөвшөөрнө",
  },
  {
    id: "790",
    test_id: "247",
    answer: "Зөвхөн түр зогсохыг зөвшөөрнө",
  },
  {
    id: "791",
    test_id: "247",
    answer: "Хориглоно",
  },
  {
    id: "792",
    test_id: "248",
    answer: "Зөвшөөрнө",
  },
  {
    id: "793",
    test_id: "248",
    answer: "Хориглоно",
  },
  {
    id: "794",
    test_id: "248",
    answer: "Гарцаас 10 м-ээс хол зайд зогссон бол зөвшөөрнө",
  },
  {
    id: "795",
    test_id: "249",
    answer: "Зөвхөн А",
  },
  {
    id: "796",
    test_id: "249",
    answer: "Зөвхөн Б",
  },
  {
    id: "797",
    test_id: "249",
    answer: "А, Б",
  },
  {
    id: "798",
    test_id: "250",
    answer: "Зөвхөн суудлын автомашин",
  },
  {
    id: "799",
    test_id: "250",
    answer: "Зөвхөн ачааны автомашин",
  },
  {
    id: "800",
    test_id: "250",
    answer: "Хоёуланг хориглоно",
  },
  {
    id: "801",
    test_id: "250",
    answer: "Хоёуланг зөвшөөрнө",
  },
  {
    id: "802",
    test_id: "251",
    answer: "Зөвшөөрнө",
  },
  {
    id: "803",
    test_id: "251",
    answer: "Хориглоно",
  },
  {
    id: "804",
    test_id: "251",
    answer: "Зөвхөн хүн буулгах, суулгахын тулд зогсохыг зөвшөөрнө.",
  },
  {
    id: "805",
    test_id: "252",
    answer: "Ослын дохионы гэрлээ асаасан тохиолдолд шаардлагагүй",
  },
  {
    id: "806",
    test_id: "252",
    answer: "Шаардлагатай",
  },
  {
    id: "807",
    test_id: "253",
    answer: "Шаардлагатай",
  },
  {
    id: "808",
    test_id: "253",
    answer: "Шаардлагагүй",
  },
  {
    id: "809",
    test_id: "253",
    answer: "Ослын дохионы гэрэл нь ажиллахгүй дохиолдолд шаардлагатай",
  },
  {
    id: "810",
    test_id: "254",
    answer: "Шаардлагатай",
  },
  {
    id: "811",
    test_id: "254",
    answer: "Үзэгдэх орчин халхлагдаагүй хэсэгт зогссон бол шаардлагагүй",
  },
  {
    id: "812",
    test_id: "254",
    answer: "Хориглоогүй газарт зогссон бол шаардлагагүй",
  },
  {
    id: "813",
    test_id: "255",
    answer: "Хориглоно",
  },
  {
    id: "814",
    test_id: "255",
    answer:
      "Чирч яваа тээврийн хэрэгслийн ослын дохионы гэрэл ажиллаж байгаа тохиолдолд зөвшөөрнө",
  },
  {
    id: "815",
    test_id: "255",
    answer:
      "Чирүүлж яваа автомашины ард ослын зогсолтын тэмдэг байршуулсан бол зөвшөөрнө",
  },
  {
    id: "816",
    test_id: "256",
    answer: "Шаардлагатай",
  },
  {
    id: "817",
    test_id: "256",
    answer: "Шаардлагагүй",
  },
  {
    id: "818",
    test_id: "256",
    answer: "Эгнээ байр өөрчлөхгүй тохиолдолд шаардлагагүй",
  },
  {
    id: "819",
    test_id: "257",
    answer: "Үйлдэл хийхийн өмнө ",
  },
  {
    id: "820",
    test_id: "257",
    answer: "Үйлдлээ эхэлсний дараа",
  },
  {
    id: "821",
    test_id: "257",
    answer: "Үйлдлээ хийж дуусмагц",
  },
  {
    id: "822",
    test_id: "258",
    answer: "Зөвхөн ердийн хөсөг",
  },
  {
    id: "823",
    test_id: "258",
    answer: "Зөвхөн суудлын автомашин",
  },
  {
    id: "824",
    test_id: "258",
    answer: "Хоёуланд зөвшөөрнө",
  },
  {
    id: "825",
    test_id: "258",
    answer: "Хоёуланд хориглоно",
  },
  {
    id: "826",
    test_id: "259",
    answer: "Зөвхөн А",
  },
  {
    id: "827",
    test_id: "259",
    answer: "Зөвхөн Б",
  },
  {
    id: "828",
    test_id: "259",
    answer: "Хоёул",
  },
  {
    id: "829",
    test_id: "260",
    answer: "Зөвхөн А",
  },
  {
    id: "830",
    test_id: "260",
    answer: "Зөвхөн Б",
  },
  {
    id: "831",
    test_id: "260",
    answer: "Хоёул",
  },
  {
    id: "832",
    test_id: "261",
    answer: "Зөвхөн А",
  },
  {
    id: "833",
    test_id: "261",
    answer: "Зөвхөн Б",
  },
  {
    id: "834",
    test_id: "261",
    answer: "Хоёул",
  },
  {
    id: "835",
    test_id: "262",
    answer: "Зөвхөн ачааны автомашин ",
  },
  {
    id: "836",
    test_id: "262",
    answer: "Мотоцикл болон ачааны автомашин",
  },
  {
    id: "837",
    test_id: "262",
    answer: "Зөвхөн суудлын авотмашин",
  },
  {
    id: "838",
    test_id: "262",
    answer: "Бүгд",
  },
  {
    id: "839",
    test_id: "263",
    answer: "Баруун гар талын эгнээг эзлэх",
  },
  {
    id: "840",
    test_id: "263",
    answer: "Зүүн гар талын эгнээг эзлэх",
  },
  {
    id: "841",
    test_id: "264",
    answer: "Баруун гар тийш эргэх",
  },
  {
    id: "842",
    test_id: "264",
    answer: "Буцаж эргэх",
  },
  {
    id: "843",
    test_id: "264",
    answer: "Тойрох хөдөлгөөнд нийлэх",
  },
  {
    id: "844",
    test_id: "264",
    answer: "Хурдаа хасах",
  },
  {
    id: "845",
    test_id: "265",
    answer: "Шаардлагатай",
  },
  {
    id: "846",
    test_id: "265",
    answer: "Шаардлагагүй",
  },
  {
    id: "847",
    test_id: "266",
    answer: "Шаардлагатай",
  },
  {
    id: "848",
    test_id: "266",
    answer: "Шаардлагагүй",
  },
  {
    id: "849",
    test_id: "267",
    answer: "Зөвшөөрнө",
  },
  {
    id: "850",
    test_id: "267",
    answer: "Хориглоно",
  },
  {
    id: "851",
    test_id: "267",
    answer:
      "Зам тээврийн ослоос урьдчилан сэргийлэх зорилгоор өгөхийг зөвшөөрнө",
  },
  {
    id: "852",
    test_id: "268",
    answer: "Зөвшөөрнө",
  },
  {
    id: "853",
    test_id: "268",
    answer: "Хориглоно",
  },
  {
    id: "854",
    test_id: "268",
    answer: "Зөвхөн суурин газрын гаднах замд зөвшөөрнө",
  },
  {
    id: "855",
    test_id: "269",
    answer: "Бусад жолоочын нүдийг гялбуулахааргүй бол зөвшөөрнө",
  },
  {
    id: "856",
    test_id: "269",
    answer: "Зөвхөн суурин газрын гаднах замд зөвшөөрнө ",
  },
  {
    id: "857",
    test_id: "269",
    answer: "Хориглоно",
  },
  {
    id: "858",
    test_id: "270",
    answer: "Дуут дохио өгнө ",
  },
  {
    id: "859",
    test_id: "270",
    answer: "Ослын дохионы гэрлээ асаана",
  },
  {
    id: "860",
    test_id: "270",
    answer: "Гэрэл шилжүүлэх дохио өгнө",
  },
  {
    id: "861",
    test_id: "270",
    answer: "Баруун гар тийш эргэх дохио өгнө",
  },
  {
    id: "862",
    test_id: "271",
    answer: "Аюултай ачаа тээвэрлэж яваа болохыг",
  },
  {
    id: "863",
    test_id: "271",
    answer: "Механикжсан тээврийн хэрэгсэл чирч яваа болохыг ",
  },
  {
    id: "864",
    test_id: "271",
    answer: "Овор ихтэй ачаа тээвэрлэж яваа болохыг ",
  },
  {
    id: "865",
    test_id: "271",
    answer: "Чиргүүл чирч яваа болохыг",
  },
  {
    id: "866",
    test_id: "272",
    answer: "Аюултай ачаатай бөгөөд хурд нь цагт 40 км -ээс хэтрэхгүй болохыг ",
  },
  {
    id: "867",
    test_id: "272",
    answer:
      "Хүнд ачаатай бөгөөд  араас нь яваа тээврийн хэрэгслүүд цагт 40 км-ээс илүү хурдтай явах хориотойг ",
  },
  {
    id: "868",
    test_id: "272",
    answer:
      "Урт тээврийн хэрэгслийг цагт 40 км-ээс илүү хурдаар гүйцэх хориотойг",
  },
  {
    id: "869",
    test_id: "273",
    answer: "Дадлагын тээврийн хэрэгсэл",
  },
  {
    id: "870",
    test_id: "273",
    answer: "Удаан явдалт тээврийн хэрэгсэл",
  },
  {
    id: "871",
    test_id: "273",
    answer: "Хадаастай дугуйтай тээврийн хэрэгсэл",
  },
  {
    id: "872",
    test_id: "273",
    answer: "Чирүүлж яваа тээврийн хэрэгсэл",
  },
  {
    id: "873",
    test_id: "274",
    answer: "Урт тээврийн хэрэгсэл ",
  },
  {
    id: "874",
    test_id: "274",
    answer: "Хүнд даацын тээврийн хэрэгсэл",
  },
  {
    id: "875",
    test_id: "274",
    answer: "Аюултай ачаатай тээврийн хэрэгсэл",
  },
  {
    id: "876",
    test_id: "274",
    answer: "Овор ихтэй тээврийн хэрэгсэл",
  },
  {
    id: "877",
    test_id: "275",
    answer: "Зөвшөөрнө",
  },
  {
    id: "878",
    test_id: "275",
    answer: "Хориглоно",
  },
  {
    id: "879",
    test_id: "275",
    answer: "Зөвхөн түр зогсохыг зөвшөөрнө",
  },
  {
    id: "880",
    test_id: "276",
    answer: "Зөвшөөрнө",
  },
  {
    id: "881",
    test_id: "276",
    answer: "Зөвхөн 5 минут хүртэл хугацаагаар зогсохыг зөвшөөрнө",
  },
  {
    id: "882",
    test_id: "276",
    answer: "Хориглоно",
  },
  {
    id: "883",
    test_id: "277",
    answer: "Зөвхөн А",
  },
  {
    id: "884",
    test_id: "277",
    answer: "Зөвхөн Б",
  },
  {
    id: "885",
    test_id: "277",
    answer: "А, Б",
  },
  {
    id: "2065",
    test_id: "667",
    answer: "Зөвшөөрнө",
  },
  {
    id: "2064",
    test_id: "666",
    answer: "А, Б",
  },
  {
    id: "2063",
    test_id: "666",
    answer: "Зөвхөн Б",
  },
  {
    id: "2062",
    test_id: "666",
    answer: "Зөвхөн А",
  },
  {
    id: "891",
    test_id: "279",
    answer: "Зөвшөөрнө",
  },
  {
    id: "892",
    test_id: "279",
    answer: "Хориглоно",
  },
  {
    id: "893",
    test_id: "280",
    answer: "Нэг чигт 3буюу түүнээс олон эгнээгээр зорчдог замд зөвшөрнө",
  },
  {
    id: "894",
    test_id: "280",
    answer: "Хүн буулгах, суулгахын тулд түр зогсохыг зөвшөөрнө",
  },
  {
    id: "895",
    test_id: "280",
    answer: "Хориглоно",
  },
  {
    id: "896",
    test_id: "281",
    answer: "Зөвшөөрнө",
  },
  {
    id: "897",
    test_id: "281",
    answer: "Хөдөлгөөний эрчим бага, бусад эгнээ чөлөөтэй үед зөвшөөрнө",
  },
  {
    id: "898",
    test_id: "281",
    answer: "Зөвхөн хоёр дугуйт тээврийн хэрэгслийг зөвшөөрнө",
  },
  {
    id: "899",
    test_id: "281",
    answer: "Хориглоно",
  },
  {
    id: "900",
    test_id: "282",
    answer: "Хөвөөгүй замд хориглоно",
  },
  {
    id: "901",
    test_id: "282",
    answer: "Автомашины өргөнөөс илүү гаргахгүйгээр зогсоосон бол зөвшөөрнө",
  },
  {
    id: "2099",
    test_id: "676",
    answer: "А, Б, В, Г",
  },
  {
    id: "2096",
    test_id: "676",
    answer: "Зөвхөн А",
  },
  {
    id: "2097",
    test_id: "676",
    answer: "Зөвхөн Б, В",
  },
  {
    id: "2098",
    test_id: "676",
    answer: "Зөвхөн Б, В, Г",
  },
  {
    id: "904",
    test_id: "284",
    answer: "Зөвшөөрнө",
  },
  {
    id: "905",
    test_id: "284",
    answer: "хориглоно",
  },
  {
    id: "906",
    test_id: "284",
    answer: "Цувуулан зогсоох хангалттай зай байхгүй тохиолдолд зөвшөөрнө",
  },
  {
    id: "2107",
    test_id: "679",
    answer: "Зөвхөн Б",
  },
  {
    id: "2106",
    test_id: "679",
    answer: "Зөвхөн А",
  },
  {
    id: "2105",
    test_id: "678",
    answer: "А, В, Г",
  },
  {
    id: "2102",
    test_id: "678",
    answer: "Зөвхөн А, Б",
  },
  {
    id: "2103",
    test_id: "678",
    answer: "Зөвхөн А, В",
  },
  {
    id: "2104",
    test_id: "678",
    answer: "А, Б, В",
  },
  {
    id: "912",
    test_id: "286",
    answer: "Зөвхөн ачааны автомашин",
  },
  {
    id: "913",
    test_id: "286",
    answer: "Зөвхөн суудлын автомашин",
  },
  {
    id: "914",
    test_id: "286",
    answer: "Ачааны болон суудлын автомашин",
  },
  {
    id: "915",
    test_id: "286",
    answer: "Бүгд буруу",
  },
  {
    id: "916",
    test_id: "287",
    answer: "Зөвхөн суудлын автомашин",
  },
  {
    id: "917",
    test_id: "287",
    answer: "Зөвхөн ачааны автомашин",
  },
  {
    id: "918",
    test_id: "287",
    answer: "Хоёуланг зөвшөөрнө",
  },
  {
    id: "919",
    test_id: "287",
    answer: "Хоёуланг хориглоно",
  },
  {
    id: "920",
    test_id: "288",
    answer: "Зөвшөөрнө",
  },
  {
    id: "921",
    test_id: "288",
    answer: "Хориглоно",
  },
  {
    id: "922",
    test_id: "289",
    answer: "Зөвхөн суудлын автомашин",
  },
  {
    id: "923",
    test_id: "289",
    answer: "Зөвхөн ачааны автомашин",
  },
  {
    id: "924",
    test_id: "289",
    answer: "Хоёуланг хориглоно",
  },
  {
    id: "925",
    test_id: "290",
    answer: "Зөвхөн суудлын автомашин",
  },
  {
    id: "926",
    test_id: "290",
    answer: "Зөвхөн ачааны автомашин",
  },
  {
    id: "927",
    test_id: "290",
    answer: "Хоёуланг хориглоно",
  },
  {
    id: "928",
    test_id: "291",
    answer: "Зөвшөөрнө",
  },
  {
    id: "929",
    test_id: "291",
    answer: "Хориглоно",
  },
  {
    id: "930",
    test_id: "291",
    answer: "Бүх жин нь 3.5 тонноос бага бол зөвшөөрнө",
  },
  {
    id: "931",
    test_id: "292",
    answer: "Зөвхөн А",
  },
  {
    id: "932",
    test_id: "292",
    answer: "Зөвхөн Б",
  },
  {
    id: "933",
    test_id: "292",
    answer: "Хоёуланг зөвшөөрнө",
  },
  {
    id: "934",
    test_id: "292",
    answer: "Хоёуланг хориглоно",
  },
  {
    id: "2135",
    test_id: "688",
    answer: "Цагт 50 км-ээс 100 км-ийн хооронд",
  },
  {
    id: "2134",
    test_id: "688",
    answer: "Цагт 50 км-ээс 80 км-ийн хооронд",
  },
  {
    id: "2133",
    test_id: "688",
    answer: "Цагт 50 км-ээс ихгүй",
  },
  {
    id: "939",
    test_id: "294",
    answer:
      "Зогсоолын тоормосыг идэвхжүүлэх,дугуйнд ивүүр тавих зэргээр тээврийн хэрэгслийг байрнаасаа хөдлөх боломжгүй болгох",
  },
  {
    id: "940",
    test_id: "294",
    answer: "Хулгайлахаас сэргийлэх дохиоллын төхөөрөмжийг идэвхжүүлэх",
  },
  {
    id: "2167",
    test_id: "697",
    answer: "Хөдөлгөөний тохиромжтой чигийг мэдээлнэ",
  },
  {
    id: "941",
    test_id: "294",
    answer: "Тээврийн хэрэгслийг харгалзах хүнтэй үлдээх ",
  },
  {
    id: "942",
    test_id: "294",
    answer: "Дээрх бүх арга хэмжээг авах",
  },
  {
    id: "2146",
    test_id: "691",
    answer: "Цагт 50 км-ээс ихгүй",
  },
  {
    id: "2145",
    test_id: "691",
    answer: "Цагт 50 км-ээс багагүй, 60 км-ээс ихгүй",
  },
  {
    id: "2143",
    test_id: "691",
    answer: "Цагт 80 км-ээс ихгүй",
  },
  {
    id: "2144",
    test_id: "691",
    answer: "Цагт 50 км-ээс багагүй, 80 км-ээс ихгүй",
  },
  {
    id: "2142",
    test_id: "690",
    answer: "Хориглоно",
  },
  {
    id: "2141",
    test_id: "690",
    answer: "Цагт 30 км-ээс 50 км хурдтай явах бол зөвшөөрнө",
  },
  {
    id: "2140",
    test_id: "690",
    answer: "Цагт 50 км-ээс их хурдтай явах бол зөвшөөрнө",
  },
  {
    id: "2139",
    test_id: "690",
    answer: "Цагт 30 км-ээс бага хурдтай явах бол зөвшөөрнө",
  },
  {
    id: "951",
    test_id: "297",
    answer: "Цүнх, гар тээшээ тээврийн хэрэгсэлд үлдээх",
  },
  {
    id: "952",
    test_id: "297",
    answer: "Үл таних зорчигчийг тээврийн хэрэгсэлд үлдээх",
  },
  {
    id: "953",
    test_id: "297",
    answer: "10 нас хүрээгүй хүүхдийг ганцааранг нь үлдээх",
  },
  {
    id: "954",
    test_id: "297",
    answer: "Дээрх бүгдийг хориглоно",
  },
  {
    id: "955",
    test_id: "298",
    answer: "Тээврийн хэрэгслийг хөдөлгөх боломжгүй болгосон бол зөвшөөрнө",
  },
  {
    id: "956",
    test_id: "298",
    answer:
      "Хүүхдийг зориулалтын нэмэгдэл суудал, хамгаалах хэрэгсэлд суулгаж бэхэлсэн бол зөвшөөрнө ",
  },
  {
    id: "957",
    test_id: "298",
    answer: "Хүүхдийн өндөр 140 см-ээс дээш бол зөвшөөрнө",
  },
  {
    id: "958",
    test_id: "298",
    answer: "Дээрх бүх тохиолдолд зөвшөөрнө ",
  },
  {
    id: "959",
    test_id: "298",
    answer: "Хориглоно",
  },
  {
    id: "960",
    test_id: "299",
    answer: "Аюултай ачаа тээвэрлэж яваа болохыг",
  },
  {
    id: "961",
    test_id: "299",
    answer: "Хөгжлийн бэрхшээлтэй хүн жолоодож яваа болохыг",
  },
  {
    id: "962",
    test_id: "299",
    answer: "Жолоодох эрх аваад удаагүй хүн жолоодож яваа болохыг",
  },
  {
    id: "963",
    test_id: "299",
    answer:
      "Дүрэмд тусгагдсан таних тэмдгээр анхааруулааагүй бусад онцлог бүхий ачаа тээвэрлэж яваа болохыг",
  },
  {
    id: "964",
    test_id: "300",
    answer: "Цагдаагийн байгууллагын автомашин",
  },
  {
    id: "965",
    test_id: "300",
    answer: "Цэргийн ангийн автомашин",
  },
  {
    id: "966",
    test_id: "300",
    answer: "Цэцэрлэгийн хүүхэд тээвэрлэж яваа автомашин",
  },
  {
    id: "967",
    test_id: "300",
    answer: "Цуваагаар яваа автомашин",
  },
  {
    id: "968",
    test_id: "301",
    answer:
      "Зам, орчны байдлыг биеэр шалгаж, аюул, осол үүсгэхгүй байх нөхцөлийг хангана",
  },
  {
    id: "969",
    test_id: "301",
    answer: "Чиг заах дохио өгнө",
  },
  {
    id: "970",
    test_id: "301",
    answer: "Бусад оролцогчдод зам тавьж өгнө",
  },
  {
    id: "971",
    test_id: "301",
    answer: "Дээрх бүх үүргийг хүлээнэ",
  },
  {
    id: "972",
    test_id: "302",
    answer: "Ачааны автомашин",
  },
  {
    id: "973",
    test_id: "302",
    answer: "Суудлын автомашин",
  },
  {
    id: "974",
    test_id: "303",
    answer: "Тийм",
  },
  {
    id: "975",
    test_id: "303",
    answer: "Үгүй",
  },
  {
    id: "976",
    test_id: "304",
    answer: "Хөдөлгөөн эхлэх гэж байгаа нь",
  },
  {
    id: "977",
    test_id: "304",
    answer: "Зогсох гэж байгаа нь",
  },
  {
    id: "978",
    test_id: "305",
    answer: "Ачааны автомашин",
  },
  {
    id: "979",
    test_id: "305",
    answer: "Суудлын автомашин",
  },
  {
    id: "980",
    test_id: "306",
    answer: "Суудлын автомашин",
  },
  {
    id: "981",
    test_id: "306",
    answer: "Мотоцикл",
  },
  {
    id: "982",
    test_id: "307",
    answer: "Ачааны автомашин",
  },
  {
    id: "983",
    test_id: "307",
    answer: "Суудлын автомашин",
  },
  {
    id: "984",
    test_id: "308",
    answer: "Хоёр буюу түүнээс олон хүүхдийг үлдээх бол зөвшөөрнө",
  },
  {
    id: "985",
    test_id: "308",
    answer: "Насанд хүрсэн харгалзах хүнтэй үлдээх бол зөвшөөрнө",
  },
  {
    id: "986",
    test_id: "308",
    answer: "Дээрх хоёр тохиолдолд зөвшөөрнө",
  },
  {
    id: "987",
    test_id: "308",
    answer: "Хориглоно",
  },
  {
    id: "2165",
    test_id: "697",
    answer: "Гол замыг заана",
  },
  {
    id: "2166",
    test_id: "697",
    answer:
      "Хөдөлгөөн нь нэг чигт зохион байгуулагдсан зам буюу зорчих хэсгийг мэдээлнэ",
  },
  {
    id: "2163",
    test_id: "696",
    answer: "Хоёул",
  },
  {
    id: "2164",
    test_id: "697",
    answer: "Зөвхөн чигээрээ явахыг заана",
  },
  {
    id: "2162",
    test_id: "696",
    answer: "Зөвхөн суудлын автомашин",
  },
  {
    id: "2160",
    test_id: "695",
    answer: "Хоёул",
  },
  {
    id: "2161",
    test_id: "696",
    answer: "Зөвхөн ачааны автомашин",
  },
  {
    id: "2150",
    test_id: "692",
    answer: "Зөвхөн А, В",
  },
  {
    id: "2151",
    test_id: "692",
    answer: "А, Б, В",
  },
  {
    id: "2148",
    test_id: "692",
    answer: "Зөвхөн Б",
  },
  {
    id: "2149",
    test_id: "692",
    answer: "Зөвхөн А, Б",
  },
  {
    id: "2147",
    test_id: "692",
    answer: "Зөвхөн А",
  },
  {
    id: "996",
    test_id: "311",
    answer: "Б, А, В",
  },
  {
    id: "997",
    test_id: "311",
    answer: "В, Б, А",
  },
  {
    id: "998",
    test_id: "311",
    answer: "Б, В, А",
  },
  {
    id: "999",
    test_id: "311",
    answer: "А, Б, В",
  },
  {
    id: "1000",
    test_id: "312",
    answer: "Зөвхөн А",
  },
  {
    id: "1001",
    test_id: "312",
    answer: "Зөвхөн Б",
  },
  {
    id: "1002",
    test_id: "312",
    answer: "А, Б",
  },
  {
    id: "1003",
    test_id: "313",
    answer: "Зөвхөн А",
  },
  {
    id: "1004",
    test_id: "313",
    answer: "Зөвхөн Б",
  },
  {
    id: "1005",
    test_id: "313",
    answer: "А, Б",
  },
  {
    id: "1006",
    test_id: "314",
    answer: "Тийм",
  },
  {
    id: "1007",
    test_id: "314",
    answer: "Үгүй",
  },
  {
    id: "1008",
    test_id: "315",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1009",
    test_id: "315",
    answer: "Хориглоно",
  },
  {
    id: "1010",
    test_id: "315",
    answer:
      "Тээврийн хэрэгслийг байрнаасаа үл хөдлөх, өөрөөс нь бусад хүн хөдөлгөх боломжгүй болгох арга хэмжээ авсан бол зөвшөөрнө",
  },
  {
    id: "1011",
    test_id: "316",
    answer: "Зөвхөн  чигээрээ явахдаа",
  },
  {
    id: "1012",
    test_id: "316",
    answer: "Зөвхөн  баруун гар тийш эргэхдээ",
  },
  {
    id: "1013",
    test_id: "316",
    answer: "Дээрх хоёр тохиолдолд",
  },
  {
    id: "1014",
    test_id: "317",
    answer: "Зөвхөн ачааны автомашинд",
  },
  {
    id: "1015",
    test_id: "317",
    answer: "Зөвхөн суудлын автомашинд",
  },
  {
    id: "1016",
    test_id: "317",
    answer: "Хоёуланд нь",
  },
  {
    id: "1020",
    test_id: "319",
    answer: "Зөвхөн ачааны автомашины жолоочоос",
  },
  {
    id: "1021",
    test_id: "319",
    answer: "Зөвхөн суудлын автомашины жолоочоос",
  },
  {
    id: "1022",
    test_id: "319",
    answer: "Хоёулангаас нь",
  },
  {
    id: "1023",
    test_id: "320",
    answer: "Зорчих хэсгийн баруун гар талын захад ",
  },
  {
    id: "1024",
    test_id: "320",
    answer: "Зорчих хэсгийг чөлөөлж, хөвөөн дээр ",
  },
  {
    id: "1025",
    test_id: "320",
    answer: "Замаас зайдуу газарт ",
  },
  {
    id: "2158",
    test_id: "695",
    answer: "Зөвхөн ачааны автомашин",
  },
  {
    id: "2156",
    test_id: "694",
    answer: "Зөвхөн Б",
  },
  {
    id: "2157",
    test_id: "694",
    answer: "А, Б",
  },
  {
    id: "2155",
    test_id: "694",
    answer: "Зөвхөн А",
  },
  {
    id: "2154",
    test_id: "693",
    answer: "Гүүрний доогуур гарах замын хэсгийг",
  },
  {
    id: "2153",
    test_id: "693",
    answer: "Тууш замын эхлэлтийг",
  },
  {
    id: "2152",
    test_id: "693",
    answer: "Замын нарийсалтыг",
  },
  {
    id: "1032",
    test_id: "323",
    answer: "Зөвхөн ачааны автомашинд",
  },
  {
    id: "1033",
    test_id: "323",
    answer: "Зөвхөн мотоциклд",
  },
  {
    id: "1034",
    test_id: "323",
    answer: "Хоёуланд нь",
  },
  {
    id: "1035",
    test_id: "324",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1036",
    test_id: "324",
    answer: "Хориглоно",
  },
  {
    id: "1037",
    test_id: "324",
    answer: "Зөвхөн түр зогсохыг зөвшөөрнө",
  },
  {
    id: "1038",
    test_id: "325",
    answer: "Хориглоно",
  },
  {
    id: "1039",
    test_id: "325",
    answer: "Гэрэл дохио солигдохоос өмнө амжих бол зөвшөөрнө",
  },
  {
    id: "1040",
    test_id: "326",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1041",
    test_id: "326",
    answer: "Хориглоно",
  },
  {
    id: "1042",
    test_id: "326",
    answer: "Зөвхөн хүн буулгах, суулгахын тулд түр зогсохыг зөвшөөрнө",
  },
  {
    id: "1043",
    test_id: "327",
    answer: "Суудлын автомашинд зам тавьж өгнө",
  },
  {
    id: "1044",
    test_id: "327",
    answer:
      "Баруун гар талаас ойртон ирж яваа тээврийн хэрэгсэлгүй үед түрүүлж нэвтэрнэ",
  },
  {
    id: "1045",
    test_id: "328",
    answer: "Зөвхөн суудлын автомашин",
  },
  {
    id: "1046",
    test_id: "328",
    answer: "Зөвхөн ачааны автомашин",
  },
  {
    id: "1047",
    test_id: "328",
    answer: "Хоёуланг зөвшөөрнө",
  },
  {
    id: "1048",
    test_id: "328",
    answer: "Хоёуланг хориглоно",
  },
  {
    id: "1049",
    test_id: "329",
    answer: "Тийм",
  },
  {
    id: "1050",
    test_id: "329",
    answer: "Үгүй",
  },
  {
    id: "1051",
    test_id: "330",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1052",
    test_id: "330",
    answer: "Хориглоно",
  },
  {
    id: "1053",
    test_id: "331",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1054",
    test_id: "331",
    answer: "Хориглоно",
  },
  {
    id: "1055",
    test_id: "331",
    answer: "Уулзвараас 20 м-ээс хол зайд зогссон бол зөвшөөрнө",
  },
  {
    id: "1056",
    test_id: "332",
    answer: "Зөвхөн ачааны автомашинд зам тавьж өгөх үүрэгтэй",
  },
  {
    id: "1057",
    test_id: "332",
    answer: "Зөвхөн явган зорчигчид зам тавьж өгөх үүрэгтэй",
  },
  {
    id: "1058",
    test_id: "332",
    answer: "Бүгдэд нь зам тавьж өгөх үүрэгтэй",
  },
  {
    id: "1059",
    test_id: "333",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1060",
    test_id: "333",
    answer: "Хориглоно",
  },
  {
    id: "1061",
    test_id: "334",
    answer: "Зөвхөн явган зорчигчид зам тавьж өгнө",
  },
  {
    id: "1062",
    test_id: "334",
    answer: "Зөвхөн баруун гар талаас яваа ачааны автомашинд зам тавьж өгнө",
  },
  {
    id: "1063",
    test_id: "334",
    answer: "Явган зорчигч ба ачааны автомашинд зам тавьж өгнө",
  },
  {
    id: "1064",
    test_id: "334",
    answer: "Бүх оролцогчдод зам тавьж өгнө",
  },
  {
    id: "1065",
    test_id: "335",
    answer: "5 метр ",
  },
  {
    id: "1066",
    test_id: "335",
    answer: "10 метр",
  },
  {
    id: "1067",
    test_id: "335",
    answer: "15 метр ",
  },
  {
    id: "1068",
    test_id: "335",
    answer: "20 метр ",
  },
  {
    id: "1069",
    test_id: "336",
    answer: "Зөвхөн суудлын автомашин",
  },
  {
    id: "1070",
    test_id: "336",
    answer: "Зөвхөн ачааны автомашин",
  },
  {
    id: "1071",
    test_id: "336",
    answer: "Хоёуланг хориглоно",
  },
  {
    id: "1072",
    test_id: "337",
    answer: "Зөвхөн унадаг дугуйнд зам тавьж өгөх үүрэгтэй",
  },
  {
    id: "1073",
    test_id: "337",
    answer: "Зөвхөн явган зорчигчид зам тавьж өгөх үүрэгтэй",
  },
  {
    id: "1074",
    test_id: "337",
    answer: "Хоёуланд нь зам тавьж  өгөх үүрэгтэй",
  },
  {
    id: "1075",
    test_id: "338",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1076",
    test_id: "338",
    answer: "Зөвхөн хүн буулгах, суулгахын тулд түр зогсохыг зөвшөөрнө ",
  },
  {
    id: "1077",
    test_id: "338",
    answer: "Хориглоно",
  },
  {
    id: "1078",
    test_id: "339",
    answer: "Суудлын автомашин",
  },
  {
    id: "1079",
    test_id: "339",
    answer: "Мотоцикл",
  },
  {
    id: "1080",
    test_id: "340",
    answer: "Суудлын автомашин",
  },
  {
    id: "1081",
    test_id: "340",
    answer: "Ачааны автомашин",
  },
  {
    id: "1082",
    test_id: "341",
    answer: "Зам хөндлөн гарах зорчигч байхгүй үед зөвшөөрнө",
  },
  {
    id: "1083",
    test_id: "341",
    answer:
      "Зөвхөн 22 цагаас 06 цагийн хооронд хүн буулгах суулгахын тулд түр зогсохыг зөвшөөрнө ",
  },
  {
    id: "1084",
    test_id: "341",
    answer: "Дээрх хоёр тохиолдолд зөвшөөрнө",
  },
  {
    id: "1085",
    test_id: "341",
    answer: "Хориглоно",
  },
  {
    id: "1086",
    test_id: "342",
    answer: "Суудлын автомашин",
  },
  {
    id: "1087",
    test_id: "342",
    answer: "Ачааны автомашин",
  },
  {
    id: "1088",
    test_id: "343",
    answer: "5 метр ",
  },
  {
    id: "1089",
    test_id: "343",
    answer: "10 метр",
  },
  {
    id: "1090",
    test_id: "343",
    answer: "20 метр",
  },
  {
    id: "1091",
    test_id: "343",
    answer: "Зөвхөн явган хүний гарц дээр хориглоно",
  },
  {
    id: "1092",
    test_id: "344",
    answer: "Зөвхөн ачааны автомашинд",
  },
  {
    id: "1093",
    test_id: "344",
    answer: "Зөвхөн автобусанд",
  },
  {
    id: "1094",
    test_id: "344",
    answer: "Хоёуланд нь",
  },
  {
    id: "1095",
    test_id: "345",
    answer: "Зөвхөн А",
  },
  {
    id: "1096",
    test_id: "345",
    answer: "Зөвхөн А, Б",
  },
  {
    id: "1097",
    test_id: "345",
    answer: "Зөвхөн Б, В ",
  },
  {
    id: "1098",
    test_id: "345",
    answer: "А, Б, В ",
  },
  {
    id: "1099",
    test_id: "346",
    answer: "Зөвхөн А",
  },
  {
    id: "1100",
    test_id: "346",
    answer: "Зөвхөн Б",
  },
  {
    id: "1101",
    test_id: "346",
    answer: "А, Б",
  },
  {
    id: "1102",
    test_id: "347",
    answer: "Тийм",
  },
  {
    id: "1103",
    test_id: "347",
    answer: "Үгүй",
  },
  {
    id: "1104",
    test_id: "348",
    answer: "Тийм",
  },
  {
    id: "1105",
    test_id: "348",
    answer: "Үгүй",
  },
  {
    id: "1106",
    test_id: "349",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1107",
    test_id: "349",
    answer: "Өглөөний 06 цагаас оройн 22 цагийн хооронд хориглоно",
  },
  {
    id: "1108",
    test_id: "349",
    answer:
      "Чиглэлийн тээврийн хэрэгслийн хөдөлгөөнд саад учруулахгүйгээр хүн буулгах, суулгахын тулд түр зогсохыг зөвшөөрнө",
  },
  {
    id: "1109",
    test_id: "350",
    answer: "Зөвхөн чигээрээ явахдаа",
  },
  {
    id: "1110",
    test_id: "350",
    answer: "Зөвхөн буцаж эргэхдээ",
  },
  {
    id: "1111",
    test_id: "350",
    answer: "Дээрх хоёр тохиолдолд",
  },
  {
    id: "1112",
    test_id: "351",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1113",
    test_id: "351",
    answer: "Хориглоно",
  },
  {
    id: "1114",
    test_id: "351",
    answer: "Зөвхөн хүн буулгах, суулгахын тулд түр зогсохыг зөвшөөрнө",
  },
  {
    id: "1115",
    test_id: "352",
    answer: "Зөвхөн ердийн хөсөгт ",
  },
  {
    id: "1116",
    test_id: "352",
    answer: "Зөвхөн автобусанд",
  },
  {
    id: "1117",
    test_id: "352",
    answer: "Хоёуланд нь",
  },
  {
    id: "1118",
    test_id: "353",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1119",
    test_id: "353",
    answer: "Зөвхөн 06 цагаас 22 цагийн хооронд зөвшөөрнө",
  },
  {
    id: "1120",
    test_id: "353",
    answer: "Зөвхөн 22 цагаас 06 цагийн хооронд зөвшөөрнө",
  },
  {
    id: "1121",
    test_id: "353",
    answer: "Хориглоно",
  },
  {
    id: "1122",
    test_id: "354",
    answer: "Тийм",
  },
  {
    id: "1123",
    test_id: "354",
    answer: "Үгүй",
  },
  {
    id: "1124",
    test_id: "355",
    answer: "Тийм",
  },
  {
    id: "1125",
    test_id: "355",
    answer: "Үгүй",
  },
  {
    id: "1126",
    test_id: "356",
    answer: "Зөвхөн А",
  },
  {
    id: "1127",
    test_id: "356",
    answer: "Зөвхөн Б",
  },
  {
    id: "1128",
    test_id: "356",
    answer: "А, Б",
  },
  {
    id: "1129",
    test_id: "357",
    answer: "Захын үргэлжилсэн шугамд шахаж",
  },
  {
    id: "1130",
    test_id: "357",
    answer: "Хашлаганд шахаж",
  },
  {
    id: "1131",
    test_id: "358",
    answer: "Зүүн гар талын эгнээг",
  },
  {
    id: "1132",
    test_id: "358",
    answer: "Эзэлж яваа эгнээг",
  },
  {
    id: "1133",
    test_id: "359",
    answer: "Зөвхөн суудлын таксийг зөвшөөрнө",
  },
  {
    id: "1134",
    test_id: "359",
    answer:
      "Зөвхөн <Хүүхэд тээвэрлэж яваа тээврийн хэрэгсэл> таних тэмдэг бүхий автобусыг зөвшөөрнө",
  },
  {
    id: "1135",
    test_id: "359",
    answer:
      "Зөвхөн <Тулгуур эрхтний бэрхшээлтэй хүн> таних тэмдэг бүхий тээврийн хэрэгслийг зөвшөөрнө ",
  },
  {
    id: "1136",
    test_id: "359",
    answer: "Дээрх бүгдийг зөвшөөрнө",
  },
  {
    id: "1137",
    test_id: "359",
    answer: "Хориглоно",
  },
  {
    id: "1138",
    test_id: "360",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1139",
    test_id: "360",
    answer: "Таксийн хөдөлгөөнд саад учируулахгүй тохиолдолд зөвшөөрнө",
  },
  {
    id: "1140",
    test_id: "360",
    answer: "Өглөөний 06 цагаас орой 22 цагийн хооронд хориглоно ",
  },
  {
    id: "1141",
    test_id: "361",
    answer: "Зөвхөн А",
  },
  {
    id: "1142",
    test_id: "361",
    answer: "Зөвхөн Б",
  },
  {
    id: "1143",
    test_id: "362",
    answer: "Зөвхөн ачааны автомашин",
  },
  {
    id: "1144",
    test_id: "362",
    answer: "Зөвхөн суудлын автомашин",
  },
  {
    id: "1145",
    test_id: "362",
    answer: "Хоёуланг зөвшөөрнө",
  },
  {
    id: "1146",
    test_id: "363",
    answer: "Зөвхөн А",
  },
  {
    id: "1147",
    test_id: "363",
    answer: "Зөвхөн Б",
  },
  {
    id: "1148",
    test_id: "363",
    answer: "А,Б",
  },
  {
    id: "1149",
    test_id: "364",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1150",
    test_id: "364",
    answer: "Хориглоно",
  },
  {
    id: "1151",
    test_id: "365",
    answer: "Хориглоно",
  },
  {
    id: "1152",
    test_id: "365",
    answer: "Орой 22 цагаас өглөөний 06 цагийн хооронд зөвшөөрнө",
  },
  {
    id: "1153",
    test_id: "365",
    answer: "Өглөөний 06 цагаас орой 22 цагийн хооронд зөвшөөрнө",
  },
  {
    id: "1154",
    test_id: "366",
    answer: "Тийм",
  },
  {
    id: "1155",
    test_id: "366",
    answer: "Үгүй",
  },
  {
    id: "1156",
    test_id: "367",
    answer: "Зөвхөн  баруун гар тийш ",
  },
  {
    id: "1157",
    test_id: "367",
    answer: "Зөвхөн чигээрээ  буюу баруун гар тийш",
  },
  {
    id: "1158",
    test_id: "367",
    answer: "Буцаж эргэхээс бусад чигт",
  },
  {
    id: "1159",
    test_id: "367",
    answer: "Бүх чигт",
  },
  {
    id: "1160",
    test_id: "368",
    answer: "Хамгийн баруун гар талын эгнээнд зөвшөөрнө",
  },
  {
    id: "1161",
    test_id: "368",
    answer: "Баруун гар талаас хоёр дахь эгнээнд зөвшөөрнө",
  },
  {
    id: "1162",
    test_id: "368",
    answer: "Хамгийн зүүн гар талын эгнээнд зөвшөөрнө",
  },
  {
    id: "1163",
    test_id: "368",
    answer: "Хориглоно",
  },
  {
    id: "1164",
    test_id: "369",
    answer: "Суудлын автомашин",
  },
  {
    id: "1165",
    test_id: "369",
    answer: "Ачааны автомашин",
  },
  {
    id: "1166",
    test_id: "370",
    answer: "Зөвхөн А",
  },
  {
    id: "1167",
    test_id: "370",
    answer: "Зөвхөн Б",
  },
  {
    id: "1168",
    test_id: "370",
    answer: "А, Б",
  },
  {
    id: "1169",
    test_id: "371",
    answer: "Зөвхөн чигээрээ явахдаа",
  },
  {
    id: "1170",
    test_id: "371",
    answer: "Зөвхөн баруун гар тийш эргэхдээ",
  },
  {
    id: "1171",
    test_id: "371",
    answer: "Дээрх хоёр тохиолдолд",
  },
  {
    id: "1172",
    test_id: "372",
    answer: "Зөвхөн А",
  },
  {
    id: "1173",
    test_id: "372",
    answer: "Зөвхөн Б",
  },
  {
    id: "1174",
    test_id: "372",
    answer: "А, Б",
  },
  {
    id: "1175",
    test_id: "373",
    answer: "Хориглоно",
  },
  {
    id: "1176",
    test_id: "373",
    answer:
      "Чиглэлийн тээврийн хэрэгслийн хөдөлгөөнд саад учируулахгүй бол зөвшөөрнө",
  },
  {
    id: "1177",
    test_id: "373",
    answer: "Оройн 22 цагаас өглөөний 06 цагийн хооронд зөвшөөрнө ",
  },
  {
    id: "1178",
    test_id: "374",
    answer: "Зөвхөн А",
  },
  {
    id: "1179",
    test_id: "374",
    answer: "Зөвхөн Б",
  },
  {
    id: "1180",
    test_id: "374",
    answer: "А, Б",
  },
  {
    id: "1181",
    test_id: "375",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1182",
    test_id: "375",
    answer: "Хориглоно",
  },
  {
    id: "1183",
    test_id: "375",
    answer: "Зөвхөн хүн буулгах, суулгахын тулд түр зогсохыг зөвшөөрнө",
  },
  {
    id: "1184",
    test_id: "376",
    answer: "Зөвхөн Б",
  },
  {
    id: "1185",
    test_id: "376",
    answer: "Зөвхөн Б, В",
  },
  {
    id: "1186",
    test_id: "376",
    answer: "Зөвхөн Б, В, Г",
  },
  {
    id: "1187",
    test_id: "376",
    answer: "Зөвхөн В, Г",
  },
  {
    id: "1188",
    test_id: "376",
    answer: "Зөвхөн А, В, Г",
  },
  {
    id: "1189",
    test_id: "377",
    answer: "Унадаг дугуйн хөдөлгөөнд саад учируулахгүй бол зөвшөөрнө ",
  },
  {
    id: "1190",
    test_id: "377",
    answer: "Мотоциклын өргөн 1м-ээс илүүгүй бол зөвшөөрнө ",
  },
  {
    id: "1191",
    test_id: "377",
    answer: "Хориглоно",
  },
  {
    id: "1192",
    test_id: "378",
    answer: "Зөвхөн суудлын автомашин",
  },
  {
    id: "1193",
    test_id: "378",
    answer: "Зөвхөн мотоцикл",
  },
  {
    id: "1194",
    test_id: "378",
    answer: "Хоёуланг хориглоно",
  },
  {
    id: "1195",
    test_id: "378",
    answer: "Хоёуланг зөвшөөрнө",
  },
  {
    id: "1196",
    test_id: "379",
    answer: "Зөвхөн чигээрээ явахдаа",
  },
  {
    id: "1197",
    test_id: "379",
    answer: "Зөвхөн баруун гар тийш эргэхдээ",
  },
  {
    id: "1198",
    test_id: "379",
    answer: "Зөвхөн чигээрээ буюу баруун гар тийш эргэхдээ",
  },
  {
    id: "1199",
    test_id: "379",
    answer: "Зөвхөн баруун буюу зүүн гар тийш эргэхдээ",
  },
  {
    id: "1200",
    test_id: "379",
    answer: "Дээрх бүх чигт явахдаа",
  },
  {
    id: "1201",
    test_id: "380",
    answer: "Зөвхөн ачааны автомашин",
  },
  {
    id: "1202",
    test_id: "380",
    answer: "Зөвхөн суудлын автомашин",
  },
  {
    id: "1203",
    test_id: "380",
    answer: "Хоёул буруу",
  },
  {
    id: "1204",
    test_id: "380",
    answer: "Хоёул зөв",
  },
  {
    id: "1205",
    test_id: "381",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1206",
    test_id: "381",
    answer: "Зөвхөн хүн буулгах, суулгахын тулд түр зогсохыг зөвшөөрнө ",
  },
  {
    id: "1207",
    test_id: "381",
    answer: "Ажлын өдрийн 7.30-с 19.00 цагын хооронд хориглоно",
  },
  {
    id: "1208",
    test_id: "382",
    answer: "Зөвхөн А",
  },
  {
    id: "1209",
    test_id: "382",
    answer: "Зөвхөн Б",
  },
  {
    id: "1210",
    test_id: "382",
    answer: "А, Б",
  },
  {
    id: "1211",
    test_id: "383",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1212",
    test_id: "383",
    answer: "Ажлын өдрийн 7.30-с 19.00 цагийн хооронд хориглоно",
  },
  {
    id: "1213",
    test_id: "384",
    answer: "Зөвхөн явган зорчигчид",
  },
  {
    id: "1214",
    test_id: "384",
    answer: "Зөвхөн унадаг дугуйчинд ",
  },
  {
    id: "1215",
    test_id: "384",
    answer: "Хоёуланд нь",
  },
  {
    id: "1216",
    test_id: "385",
    answer: "Зөвхөн А",
  },
  {
    id: "1217",
    test_id: "385",
    answer: "Зөвхөн Б",
  },
  {
    id: "1218",
    test_id: "385",
    answer: "А, Б",
  },
  {
    id: "1219",
    test_id: "386",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1220",
    test_id: "386",
    answer: "Зөвхөн хүн буулгах, суулгахын тулд түр зогсохыг зөвшөөрнө ",
  },
  {
    id: "1221",
    test_id: "386",
    answer: "Ажлын өдрийн 7.30-с 19.00 цагийн хооронд хориглоно",
  },
  {
    id: "1222",
    test_id: "387",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1223",
    test_id: "387",
    answer: "Хориглоно",
  },
  {
    id: "1224",
    test_id: "387",
    answer: "Баруун гар талын эгнээ чөлөөтэй байгаа тохиолдолд  хориглоно",
  },
  {
    id: "1225",
    test_id: "388",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1226",
    test_id: "388",
    answer: "Хориглоно",
  },
  {
    id: "1227",
    test_id: "389",
    answer: "Зөвхөн А",
  },
  {
    id: "1228",
    test_id: "389",
    answer: "Зөвхөн Б",
  },
  {
    id: "1229",
    test_id: "389",
    answer: "Зөвхөн А, Б",
  },
  {
    id: "1230",
    test_id: "389",
    answer: "Зөвхөн В, Г",
  },
  {
    id: "1231",
    test_id: "389",
    answer: "А, Б, В",
  },
  {
    id: "1232",
    test_id: "390",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1233",
    test_id: "390",
    answer: "Хориглоно",
  },
  {
    id: "1234",
    test_id: "390",
    answer: "Зорчих хэсгийг чөлөөлж хөвөөн дээр зогсох бол зөвшөөрнө",
  },
  {
    id: "1235",
    test_id: "391",
    answer: "Хориглоно",
  },
  {
    id: "1236",
    test_id: "391",
    answer: "Бусдын хөдөлгөөнд саад учруулахгүй бол зөвшөөрнө",
  },
  {
    id: "1237",
    test_id: "392",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1238",
    test_id: "392",
    answer: "Хаалтын байрлалаас цааш зогсох бол зөвшөөрнө ",
  },
  {
    id: "1239",
    test_id: "392",
    answer: "Хаалтын байрлалаас цааш 20 м-ийн дотор зогсох бол хориглоно",
  },
  {
    id: "1240",
    test_id: "393",
    answer: "Зөвшөөрсөн гэрэл дохио ассан тул уулвар руу орно",
  },
  {
    id: "1241",
    test_id: "393",
    answer: "Уулзвар руу оролгүйгээр,түгжрэл арилахыг хүлээнэ",
  },
  {
    id: "1242",
    test_id: "393",
    answer:
      "Өөдөөс тээврийн хэрэгсэлгүй үед зүүн гар талын эгнээгээр хөдөлгөөгөө үргэлжлүүлнэ",
  },
  {
    id: "1243",
    test_id: "394",
    answer: "Тийм",
  },
  {
    id: "1244",
    test_id: "394",
    answer: "Үгүй",
  },
  {
    id: "1245",
    test_id: "395",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1246",
    test_id: "395",
    answer: "Хориглоно",
  },
  {
    id: "1247",
    test_id: "395",
    answer: "Зөвхөн түр зогсохыг зөвшөөрнө",
  },
  {
    id: "1248",
    test_id: "396",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1249",
    test_id: "396",
    answer: "Хориглоно",
  },
  {
    id: "1250",
    test_id: "396",
    answer: "Зөвхөн түр зогсохыг зөвшөөрнө",
  },
  {
    id: "1251",
    test_id: "397",
    answer: "Зөвхөн суудлын автомашин",
  },
  {
    id: "1252",
    test_id: "397",
    answer: "Зөвхөн ачааны автомашин",
  },
  {
    id: "1253",
    test_id: "397",
    answer: "Хоёуланг зөвшөөрнө",
  },
  {
    id: "1254",
    test_id: "398",
    answer: "Гол замаас яваа тул зөвшөөрнө",
  },
  {
    id: "1255",
    test_id: "398",
    answer: "Хориглоно",
  },
  {
    id: "1256",
    test_id: "399",
    answer: "20 метр",
  },
  {
    id: "1257",
    test_id: "399",
    answer: "50 метр",
  },
  {
    id: "1258",
    test_id: "399",
    answer: "100 метр",
  },
  {
    id: "1259",
    test_id: "399",
    answer: "150 метр",
  },
  {
    id: "1260",
    test_id: "400",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1261",
    test_id: "400",
    answer: "Хориглоно",
  },
  {
    id: "1262",
    test_id: "401",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1263",
    test_id: "401",
    answer: "Хориглоно",
  },
  {
    id: "1264",
    test_id: "401",
    answer: "Тээврийн хэрэгслийн бодит жин 7 тонноос бага бол зөвшөөрнө",
  },
  {
    id: "1265",
    test_id: "402",
    answer: "Зөвхөн суудлын автомашин",
  },
  {
    id: "1266",
    test_id: "402",
    answer: "Зөвхөн ачааны автомашин",
  },
  {
    id: "1267",
    test_id: "402",
    answer: "Хоёуланг зөвшөөрнө",
  },
  {
    id: "1268",
    test_id: "403",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1269",
    test_id: "403",
    answer: "Хориглоно",
  },
  {
    id: "1270",
    test_id: "403",
    answer:
      "Замын дагуух үзэгдэлт 100 метрийн дотор хязгаарлагдаагүй бол зөвшөөрнө",
  },
  {
    id: "1271",
    test_id: "404",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1272",
    test_id: "404",
    answer: "Хориглоно",
  },
  {
    id: "1273",
    test_id: "404",
    answer: "Оврын гэрлээ асаасан бол зөвшөөрнө",
  },
  {
    id: "1274",
    test_id: "405",
    answer: "Зөвхөн А",
  },
  {
    id: "1275",
    test_id: "405",
    answer: "Зөвхөн В",
  },
  {
    id: "1276",
    test_id: "405",
    answer: "Зөвхөн А, Б",
  },
  {
    id: "1277",
    test_id: "405",
    answer: "Зөвхөн А, В",
  },
  {
    id: "1278",
    test_id: "405",
    answer: "А, Б, В",
  },
  {
    id: "1279",
    test_id: "406",
    answer: "Зорчих хэсгийг чөлөөлсөн учир зөвшөөрнө",
  },
  {
    id: "1280",
    test_id: "406",
    answer: "Замын тэмдэг халхалж зогссон учир хориглоно",
  },
  {
    id: "1281",
    test_id: "407",
    answer: "Зохицуулдаг уулзвар нэвтрэх журам баримтална",
  },
  {
    id: "1282",
    test_id: "407",
    answer: "Адил замын уулзвар нэвтрэх журам баримтална",
  },
  {
    id: "1283",
    test_id: "407",
    answer: "Гол ба туслах замын уулзвар нэвтрэх журам баримтална",
  },
  {
    id: "1284",
    test_id: "407",
    answer: "Уулзвар нэвтэрхийг хориглоно",
  },
  {
    id: "1285",
    test_id: "408",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1286",
    test_id: "408",
    answer: "Хориглоно",
  },
  {
    id: "1287",
    test_id: "409",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1288",
    test_id: "409",
    answer: "Хориглоно",
  },
  {
    id: "1289",
    test_id: "410",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1290",
    test_id: "410",
    answer: "Хориглоно",
  },
  {
    id: "1291",
    test_id: "410",
    answer: "Зөвхөн хүн буулгах, суулгахын тулд түр зогсохыг зөвшөөрнө",
  },
  {
    id: "1292",
    test_id: "411",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1293",
    test_id: "411",
    answer: "Зөвхөн түр зогсохыг зөвшөөрнө",
  },
  {
    id: "1294",
    test_id: "411",
    answer: "Хашлагыг давж гарч зогсох бол зөвшөөрнө",
  },
  {
    id: "1295",
    test_id: "411",
    answer: "Хориглоно",
  },
  {
    id: "1296",
    test_id: "412",
    answer: "Зөвхөн А",
  },
  {
    id: "1297",
    test_id: "412",
    answer: "Зөвхөн В",
  },
  {
    id: "1298",
    test_id: "412",
    answer: "Зөвхөн А, Б",
  },
  {
    id: "1299",
    test_id: "412",
    answer: "Зөвхөн Б, ",
  },
  {
    id: "1300",
    test_id: "412",
    answer: "А, Б, В",
  },
  {
    id: "1301",
    test_id: "413",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1302",
    test_id: "413",
    answer: "Хориглоно",
  },
  {
    id: "1303",
    test_id: "413",
    answer: "Автомашины хөдөлгүүрийг унтраасан бол зөвшөөрнө",
  },
  {
    id: "1304",
    test_id: "414",
    answer: "Өөрийгөө туслах замаар яваад тооцож зам тавьж өгнө",
  },
  {
    id: "1305",
    test_id: "414",
    answer:
      "Баруун гар талаас ойртон ирж яваа тээврийн хэрэгсэлгүй үед түрүүлж нэвтэрнэ",
  },
  {
    id: "1306",
    test_id: "415",
    answer: "Бусдын хөдөлгөөнд саад учруулахгүй бол зөвшөөрнө",
  },
  {
    id: "1307",
    test_id: "415",
    answer: "Хориглоно",
  },
  {
    id: "1308",
    test_id: "416",
    answer: "Уулзвар дээр зогссон учир хориглоно",
  },
  {
    id: "1309",
    test_id: "416",
    answer: "Хөдөлгөөн огтлолцохгүй хэсэгт зогссон учир зөвшөөрнө",
  },
  {
    id: "1310",
    test_id: "416",
    answer:
      "Тээврийн хэрэгслээс тэнхлэгийн үргэлжилсэн шугам хүртэл 3метрээс бага зайтай бол хориглоно",
  },
  {
    id: "1311",
    test_id: "417",
    answer: "Зөвхөн А",
  },
  {
    id: "1312",
    test_id: "417",
    answer: "Зөвхөн Б",
  },
  {
    id: "1313",
    test_id: "417",
    answer: "А, Б",
  },
  {
    id: "1314",
    test_id: "418",
    answer: "Зөвхөн А",
  },
  {
    id: "1315",
    test_id: "418",
    answer: "Зөвхөн Б",
  },
  {
    id: "1316",
    test_id: "418",
    answer: "А, Б",
  },
  {
    id: "1317",
    test_id: "419",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1318",
    test_id: "419",
    answer: "Хориглоно",
  },
  {
    id: "1319",
    test_id: "419",
    answer:
      "Явган хүний гарц хүртэл 5 метрээс багагүй зайд зогсох бол зөвшөөрнө",
  },
  {
    id: "1320",
    test_id: "420",
    answer: "Тийм",
  },
  {
    id: "1321",
    test_id: "420",
    answer: "Үгүй",
  },
  {
    id: "1322",
    test_id: "421",
    answer: "Зөвхөн ачааны автомашин",
  },
  {
    id: "1323",
    test_id: "421",
    answer: "Зөвхөн суудлын автомашин",
  },
  {
    id: "1324",
    test_id: "421",
    answer: "Хоёуланг хориглоно",
  },
  {
    id: "1325",
    test_id: "422",
    answer: "Зөвхөн А",
  },
  {
    id: "1326",
    test_id: "422",
    answer: "Зөвхөн Б",
  },
  {
    id: "1327",
    test_id: "422",
    answer: "А, Б",
  },
  {
    id: "1328",
    test_id: "423",
    answer: "Тийм",
  },
  {
    id: "1329",
    test_id: "423",
    answer: "Үгүй",
  },
  {
    id: "1330",
    test_id: "424",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1331",
    test_id: "424",
    answer: "Хориглоно",
  },
  {
    id: "1332",
    test_id: "424",
    answer: "Төмөр замын гарам хүртэл 20метрээс хол зайд зогссон бол зөвшөөрнө",
  },
  {
    id: "1333",
    test_id: "425",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1334",
    test_id: "425",
    answer: "Хориглоно",
  },
  {
    id: "1335",
    test_id: "425",
    answer: "Зөвхөн түр зогсохыг зөвшөөрнө",
  },
  {
    id: "1336",
    test_id: "426",
    answer: "Тийм",
  },
  {
    id: "1337",
    test_id: "426",
    answer: "Үгүй",
  },
  {
    id: "1338",
    test_id: "427",
    answer: "Зөвхөн А",
  },
  {
    id: "1339",
    test_id: "427",
    answer: "Зөвхөн Б",
  },
  {
    id: "1340",
    test_id: "427",
    answer: "А, Б",
  },
  {
    id: "1341",
    test_id: "428",
    answer:
      "Тээврийн хэрэгслийг байрнаасаа өнхрөхгүй болгох арга хэмжээ авсан бол зөвшөөрнө",
  },
  {
    id: "1342",
    test_id: "428",
    answer: "Өгсүүрийн төгсгөлд 100метрээс ойр зайд зогссон бол хориглоно",
  },
  {
    id: "2340",
    test_id: "750",
    answer: "Зөвхөн А, В",
  },
  {
    id: "2341",
    test_id: "750",
    answer: "А, Б, В",
  },
  {
    id: "2348",
    test_id: "752",
    answer: "Зөвхөн Б",
  },
  {
    id: "2349",
    test_id: "752",
    answer: "Зөвхөн А, Б",
  },
  {
    id: "2337",
    test_id: "750",
    answer: "Зөвхөн А",
  },
  {
    id: "2338",
    test_id: "750",
    answer: "Зөвхөн Б",
  },
  {
    id: "2339",
    test_id: "750",
    answer: "Зөвхөн А, Б",
  },
  {
    id: "1345",
    test_id: "430",
    answer: "Тийм",
  },
  {
    id: "1346",
    test_id: "430",
    answer: "Үгүй",
  },
  {
    id: "1347",
    test_id: "431",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1348",
    test_id: "431",
    answer: "Зөвхөн түр зогсохыг зөвшөөрнө",
  },
  {
    id: "1349",
    test_id: "431",
    answer:
      "Замын дагуух үзэгдэлт 100метрийн дотор хязгаарлагдмал нөхцөлд хориглоно",
  },
  {
    id: "2347",
    test_id: "752",
    answer: "Зөвхөн А",
  },
  {
    id: "2345",
    test_id: "751",
    answer: "А, В",
  },
  {
    id: "2346",
    test_id: "751",
    answer: "Б, В",
  },
  {
    id: "2342",
    test_id: "751",
    answer: "Зөвхөн А",
  },
  {
    id: "2343",
    test_id: "751",
    answer: "Зөвхөн Б",
  },
  {
    id: "2344",
    test_id: "751",
    answer: "А, Б",
  },
  {
    id: "1353",
    test_id: "433",
    answer: "Тийм",
  },
  {
    id: "1354",
    test_id: "433",
    answer: "Үгүй",
  },
  {
    id: "1355",
    test_id: "434",
    answer: "Дугуйг солих арга хэмжээ авна",
  },
  {
    id: "1356",
    test_id: "434",
    answer: "Уулзварыг чөлөөлөх арга хэмжээ авна",
  },
  {
    id: "1357",
    test_id: "435",
    answer: "Үндсэн ногоон гэрэл дохио асахыг хүлээнэ",
  },
  {
    id: "1358",
    test_id: "435",
    answer:
      "Уулзвар руу зүүн гар талын эгнээний харалдаа шилжиж, араасаа ирсэн жолоочид зай гаргаж өгнө",
  },
  {
    id: "1359",
    test_id: "435",
    answer: "Өөрийн явах чигийг үл харгалзан баруун гар тийш дохио өгч эргэнэ",
  },
  {
    id: "1360",
    test_id: "436",
    answer: "Зөвхөн зүүн гар тийш эргэхдээ",
  },
  {
    id: "1361",
    test_id: "436",
    answer: "Зөвхөн буцаж эргэхдээ",
  },
  {
    id: "1362",
    test_id: "436",
    answer: "Дээрх хоёр тохиолдолд",
  },
  {
    id: "1363",
    test_id: "436",
    answer: "Зам тавьж өгөх шаардлагагүй",
  },
  {
    id: "1364",
    test_id: "437",
    answer: "Тийм",
  },
  {
    id: "1365",
    test_id: "437",
    answer: "Үгүй",
  },
  {
    id: "1366",
    test_id: "438",
    answer: "Чигээрээ явах зорилготой бол шаардлагагүй",
  },
  {
    id: "1367",
    test_id: "438",
    answer:
      "Араас нь ирсэн жолооч зүүн гар тийш эргэхээр дохио өгсөн тохиолдолд шаардлагатай",
  },
  {
    id: "1368",
    test_id: "439",
    answer: "Тийм",
  },
  {
    id: "1369",
    test_id: "439",
    answer: "Үгүй",
  },
  {
    id: "1370",
    test_id: "440",
    answer: "Тийм",
  },
  {
    id: "1371",
    test_id: "440",
    answer: "Үгүй",
  },
  {
    id: "1372",
    test_id: "441",
    answer: "40 км/цаг",
  },
  {
    id: "1373",
    test_id: "441",
    answer: "50 км/цаг",
  },
  {
    id: "1374",
    test_id: "441",
    answer: "60 км/цаг",
  },
  {
    id: "1375",
    test_id: "441",
    answer: "80 км/цаг",
  },
  {
    id: "1376",
    test_id: "442",
    answer: "50 км/цаг",
  },
  {
    id: "1377",
    test_id: "442",
    answer: "60 км/цаг",
  },
  {
    id: "1378",
    test_id: "442",
    answer: "80 км/цаг",
  },
  {
    id: "1379",
    test_id: "442",
    answer: "100 км/цаг",
  },
  {
    id: "1380",
    test_id: "443",
    answer: "Зөвхөн А",
  },
  {
    id: "1381",
    test_id: "443",
    answer: "Зөвхөн Б",
  },
  {
    id: "1382",
    test_id: "443",
    answer: "А, Б",
  },
  {
    id: "1383",
    test_id: "444",
    answer: "Тууш зам болон суурин газрын гаднах замд зөвшөөрнө",
  },
  {
    id: "1384",
    test_id: "444",
    answer:
      "Хөдөлгөөний эрчим, тээж яваа ачааны онцлог, замын болон цаг агаарын тухайн нөхцөлд тохирох бол зөавшөөрнө",
  },
  {
    id: "1385",
    test_id: "444",
    answer:
      "Автомашины бүрэн зогсолтын зам жолоочын үзэгдэх хүрээнээс давах тул хориглоно",
  },
  {
    id: "1386",
    test_id: "445",
    answer: "50 км/цаг",
  },
  {
    id: "1387",
    test_id: "445",
    answer: "60 км/цаг",
  },
  {
    id: "1388",
    test_id: "445",
    answer: "80 км/цаг",
  },
  {
    id: "1389",
    test_id: "445",
    answer: "100 км/цаг",
  },
  {
    id: "1390",
    test_id: "446",
    answer: "Зөвхөн А",
  },
  {
    id: "1391",
    test_id: "446",
    answer: "Зөвхөн Б",
  },
  {
    id: "1392",
    test_id: "446",
    answer: "А, Б",
  },
  {
    id: "1393",
    test_id: "447",
    answer: "20 км/цаг",
  },
  {
    id: "1394",
    test_id: "447",
    answer: "40 км/цаг",
  },
  {
    id: "1395",
    test_id: "447",
    answer: "50 км/цаг",
  },
  {
    id: "1396",
    test_id: "447",
    answer: "60 км/цаг",
  },
  {
    id: "1397",
    test_id: "448",
    answer: "Хүн тээвэрлэсэн тохиолдолд",
  },
  {
    id: "1398",
    test_id: "448",
    answer: "Чиргүүлтэй явах тохиолдолд",
  },
  {
    id: "1399",
    test_id: "448",
    answer: "Мехианикжсан тээврийн хэрэгслийг чирэх тохиолдолд",
  },
  {
    id: "1400",
    test_id: "448",
    answer: "Дээрх бүх тохиолдолд",
  },
  {
    id: "1401",
    test_id: "449",
    answer: "60 км/цаг",
  },
  {
    id: "1402",
    test_id: "449",
    answer: "70 км/цаг",
  },
  {
    id: "1403",
    test_id: "449",
    answer: "80 км/цаг",
  },
  {
    id: "1404",
    test_id: "449",
    answer: "100 км/цаг",
  },
  {
    id: "1405",
    test_id: "450",
    answer: "40 км/цаг",
  },
  {
    id: "1406",
    test_id: "450",
    answer: "60 км/цаг",
  },
  {
    id: "1407",
    test_id: "450",
    answer: "80 км/цаг",
  },
  {
    id: "1408",
    test_id: "450",
    answer: "100 км/цаг",
  },
  {
    id: "1409",
    test_id: "451",
    answer: "60 км/цаг",
  },
  {
    id: "1410",
    test_id: "451",
    answer: "80 км/цаг",
  },
  {
    id: "1411",
    test_id: "451",
    answer: "100 км/цаг",
  },
  {
    id: "1412",
    test_id: "451",
    answer: "Тууш замд мотоциклын хөдөлгөөнийг хориглоно",
  },
  {
    id: "1413",
    test_id: "452",
    answer: "50 км/цаг",
  },
  {
    id: "1414",
    test_id: "452",
    answer: "60 км/цаг",
  },
  {
    id: "1415",
    test_id: "452",
    answer: "70 км/цаг",
  },
  {
    id: "1416",
    test_id: "452",
    answer: "80 км/цаг",
  },
  {
    id: "1417",
    test_id: "453",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1418",
    test_id: "453",
    answer: "Хориглоно",
  },
  {
    id: "1419",
    test_id: "453",
    answer: "Зөвхөн бүх жин нь 3,5 тонноос бага бол зөвшөөрнө",
  },
  {
    id: "1420",
    test_id: "454",
    answer: "20 км/цаг",
  },
  {
    id: "1421",
    test_id: "454",
    answer: "40 км/цаг",
  },
  {
    id: "1422",
    test_id: "454",
    answer: "50 км/цаг",
  },
  {
    id: "1423",
    test_id: "454",
    answer: "60 км/цаг",
  },
  {
    id: "1424",
    test_id: "455",
    answer: "Чиргүүлтэй явах тохиолдолд",
  },
  {
    id: "1425",
    test_id: "455",
    answer: "Хүүхдийг зохион байгуулалттай тээвэрлэх үед",
  },
  {
    id: "1426",
    test_id: "455",
    answer: "Мехианикжсан тээврийн хэрэгслийг чирэх тохиолдолд",
  },
  {
    id: "1427",
    test_id: "455",
    answer: "Дээрх бүх тохиолдолд",
  },
  {
    id: "1428",
    test_id: "456",
    answer: "20 км/цаг",
  },
  {
    id: "1429",
    test_id: "456",
    answer: "40 км/цаг",
  },
  {
    id: "1430",
    test_id: "456",
    answer: "60 км/цаг",
  },
  {
    id: "1431",
    test_id: "457",
    answer: "Зөвхөн хорооллын дотор",
  },
  {
    id: "1432",
    test_id: "457",
    answer: "Зөвхөн сургууль орчмын бүс дотор",
  },
  {
    id: "1433",
    test_id: "457",
    answer: "Зөвхөн замын зэргэлдээх нутаг дэвсгэр дотор",
  },
  {
    id: "1434",
    test_id: "457",
    answer: "Дээрх бүх газарт",
  },
  {
    id: "1435",
    test_id: "458",
    answer: "Хориглоно",
  },
  {
    id: "1436",
    test_id: "458",
    answer: "Дүрэмд тогтоосон хурдны хязгаараас хэтрээгүй бол зөвшөөрнө",
  },
  {
    id: "1437",
    test_id: "459",
    answer: "30 км/цаг",
  },
  {
    id: "1438",
    test_id: "459",
    answer: "50 км/цаг",
  },
  {
    id: "1439",
    test_id: "459",
    answer: "80 км/цаг",
  },
  {
    id: "1440",
    test_id: "460",
    answer: "Бусдын хөдөлгөөнийг саатуулахгүй бол зөвшөөрнө",
  },
  {
    id: "1441",
    test_id: "460",
    answer: "Хориглоно",
  },
  {
    id: "1442",
    test_id: "461",
    answer:
      "Зохицуулагч дохиураа өргөх үед уулзвар буюу явган хүний гарцын өмнө тээврийн хэрэгслээ зогсоохын тулд",
  },
  {
    id: "1443",
    test_id: "461",
    answer: "Зөвхөн зам тээврийн ослоос урьдчилан сэргийлэхийн тулд",
  },
  {
    id: "1444",
    test_id: "461",
    answer: "Дээрх хоёр тохиолдолд",
  },
  {
    id: "1445",
    test_id: "462",
    answer: "20 км/цаг",
  },
  {
    id: "1446",
    test_id: "462",
    answer: "40 км/цаг",
  },
  {
    id: "1447",
    test_id: "462",
    answer: "50 км/цаг",
  },
  {
    id: "1448",
    test_id: "462",
    answer: "60 км/цаг",
  },
  {
    id: "1449",
    test_id: "463",
    answer: "Бусдын хөдөлгөөнд саад учруулахгүй бол зөвшөөрнө",
  },
  {
    id: "1450",
    test_id: "463",
    answer: "Хориглоно",
  },
  {
    id: "1451",
    test_id: "464",
    answer: "Хориглоно",
  },
  {
    id: "1452",
    test_id: "464",
    answer:
      "Өөдөөсөө болон араасаа яваа тээврийн хэрэгсэлд зам тавьж өгсний дараа эргэхийг зөвшөөрнө",
  },
  {
    id: "1453",
    test_id: "465",
    answer: "Зөвхөн уулзвар дээр",
  },
  {
    id: "1454",
    test_id: "465",
    answer: "Зөвхөн явган хүний гарц дээр",
  },
  {
    id: "1455",
    test_id: "465",
    answer: "Хоёуланд  хориглоно",
  },
  {
    id: "1456",
    test_id: "465",
    answer: "Хоёуланд зөвшөөрнө",
  },
  {
    id: "1457",
    test_id: "466",
    answer: "Зөвхөн А",
  },
  {
    id: "1458",
    test_id: "466",
    answer: "Зөвхөн Б",
  },
  {
    id: "1459",
    test_id: "466",
    answer: "Хоёуланг хориглоно",
  },
  {
    id: "1460",
    test_id: "466",
    answer: "Хоёуланг зөвшөөрнө",
  },
  {
    id: "1461",
    test_id: "467",
    answer: "Хориглоно",
  },
  {
    id: "1462",
    test_id: "467",
    answer:
      "Буцаж эргэхэд зорчих хэсгийн өргөн хүрэлцэхгүй тохиолдолд зөвшөөрнө",
  },
  {
    id: "1463",
    test_id: "468",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1464",
    test_id: "468",
    answer: "Хориглоно",
  },
  {
    id: "1465",
    test_id: "469",
    answer: "Зөвхөн А",
  },
  {
    id: "1466",
    test_id: "469",
    answer: "Зөвхөн Б",
  },
  {
    id: "1467",
    test_id: "469",
    answer: "Зөвхөн А, Б",
  },
  {
    id: "1468",
    test_id: "469",
    answer: "Зөвхөн Б, В",
  },
  {
    id: "1469",
    test_id: "469",
    answer: "А, Б, В",
  },
  {
    id: "1470",
    test_id: "470",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1471",
    test_id: "470",
    answer: "Хориглоно",
  },
  {
    id: "1472",
    test_id: "470",
    answer:
      "Өөдөөс яваа тээврийн хэрэгслийг урьдчилан өнгөрүүлсэн тохиолдолд зөвшөөрнө",
  },
  {
    id: "1473",
    test_id: "471",
    answer: "Зорчих хэсгийн өргөн хүрэлцэх бол зөвшөөрнө",
  },
  {
    id: "1474",
    test_id: "471",
    answer: "Хориглоно",
  },
  {
    id: "1475",
    test_id: "472",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1476",
    test_id: "472",
    answer: "Хориглоно",
  },
  {
    id: "1477",
    test_id: "473",
    answer: "Бусдад саад учруулахгүй бол зөвшөөрнө",
  },
  {
    id: "1478",
    test_id: "473",
    answer: "Хориглоно",
  },
  {
    id: "1479",
    test_id: "474",
    answer: "Бусдад саад учруулахгүй бол зөвшөөрнө",
  },
  {
    id: "1480",
    test_id: "474",
    answer: "Хориглоно",
  },
  {
    id: "1481",
    test_id: "475",
    answer: "Аюулгүй байдлыг хангасан нөхцөлд зөвшөөрнө",
  },
  {
    id: "1482",
    test_id: "475",
    answer: "Хориглоно",
  },
  {
    id: "1483",
    test_id: "476",
    answer: "Зам хөндлөн гарах явган зорчигчгүй үед зөвшөөрнө ",
  },
  {
    id: "1484",
    test_id: "476",
    answer: "Зөвхөн явган хүний гарц хүртэл ухрахыг зөвшөөрнө",
  },
  {
    id: "1485",
    test_id: "476",
    answer: "Нэг чигийн хөдөлгөөнтэй замд хориглоно",
  },
  {
    id: "1486",
    test_id: "477",
    answer: "Аюулгүй байдлыг хангасан нөхцөлд зөвшөөрнө",
  },
  {
    id: "1487",
    test_id: "477",
    answer: "Ажилын өдрийн 7.30-аас 19.00 цагийн хооронд зөвшөөрнө",
  },
  {
    id: "1488",
    test_id: "478",
    answer: "Хориглоно",
  },
  {
    id: "1489",
    test_id: "478",
    answer:
      "Чиглэлийн тээврийн хэрэгслийн хөдөлгөөнд саад учруулахгүй бол зөвшөөрнө",
  },
  {
    id: "1490",
    test_id: "478",
    answer: "Зөвхөн 22-оос 06 цагийн хооронд зөвшөөрнө",
  },
  {
    id: "1491",
    test_id: "479",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1492",
    test_id: "479",
    answer: "Хориглоно",
  },
  {
    id: "1493",
    test_id: "480",
    answer: "Гармын хөдөлгөөн нээлттэй үед зөвшөөрнө",
  },
  {
    id: "1494",
    test_id: "480",
    answer: "Хориглоно",
  },
  {
    id: "1495",
    test_id: "481",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1496",
    test_id: "481",
    answer: "Хориглоно",
  },
  {
    id: "1497",
    test_id: "482",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1498",
    test_id: "482",
    answer: "Хориглоно",
  },
  {
    id: "1499",
    test_id: "482",
    answer: "Ухрах үйлдлийг бусдын тусламжтайгаар гүйцэтгэх бол зөвшөөрнө",
  },
  {
    id: "1500",
    test_id: "483",
    answer: "Хурдаа нэмж гүйцэж түрүүлэх үйлдлийг шуурхайлна",
  },
  {
    id: "1501",
    test_id: "483",
    answer: "Гэрэл шилжүүлэх дохио өгч гүйцэж түрүүлж байгаагаа анхааруулна",
  },
  {
    id: "1502",
    test_id: "483",
    answer: " Хурдаа хасаж, буцаж эгнээндээ орно",
  },
  {
    id: "1503",
    test_id: "484",
    answer: "Ачааны автомашиныг гүйцмэгцээ",
  },
  {
    id: "1504",
    test_id: "484",
    answer:
      "Ачааны автомашины хөдөлгөөнд саад болохооргүй хоорондын зай авсны дараа",
  },
  {
    id: "1505",
    test_id: "484",
    answer: "Зөвхөн өөдөөс тээврийн хэрэгсэл гарч ирэх үед",
  },
  {
    id: "1506",
    test_id: "485",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1507",
    test_id: "485",
    answer: "Хориглоно",
  },
  {
    id: "1508",
    test_id: "485",
    answer:
      "Ачааны автомашинаас урьтаж зүүн гар талын эгнээг эзлэх бол зөвшөөрнө",
  },
  {
    id: "1509",
    test_id: "486",
    answer: "Хориглоно",
  },
  {
    id: "1510",
    test_id: "486",
    answer: "Өөдөөс ойртон ирж яваа тээврийн хэрэгсэлгүй үед зөвшөөрнө",
  },
  {
    id: "1511",
    test_id: "487",
    answer: "Хурдаа хасах",
  },
  {
    id: "1512",
    test_id: "487",
    answer: "Баруун гар тал руугаа шилжиж зай тавьж өгөх",
  },
  {
    id: "1513",
    test_id: "487",
    answer:
      "Хурдаа нэмэхгүй, гүйцэж түрүүлэхэд нь ямар нэгэн байдлаар саад хийхгүй байх ",
  },
  {
    id: "1514",
    test_id: "487",
    answer: "Дээрх бүх үүргийг хүлээнэ",
  },
  {
    id: "1515",
    test_id: "487",
    answer: "Ямар нэг үүрэг хүлээхгүй",
  },
  {
    id: "1516",
    test_id: "488",
    answer: "Зүүн гар тийш дохио өгнө",
  },
  {
    id: "1517",
    test_id: "488",
    answer: "Зүүн гар тийш шилжиж гүйцэж түрүүлэхэд нь саад хийнэ",
  },
  {
    id: "1518",
    test_id: "488",
    answer: "Ослын дохионы гэрлээ асаана",
  },
  {
    id: "1519",
    test_id: "488",
    answer: "Дуут дохио өгнө",
  },
  {
    id: "1520",
    test_id: "489",
    answer: "Хориглоно",
  },
  {
    id: "1521",
    test_id: "489",
    answer: "Гол замаас яваа тохиолдолд зөвшөөрнө",
  },
  {
    id: "1522",
    test_id: "490",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1523",
    test_id: "490",
    answer: "Хориглоно",
  },
  {
    id: "1524",
    test_id: "491",
    answer: "Хориглоно",
  },
  {
    id: "1525",
    test_id: "491",
    answer: "Өөдөөс ойртон ирж яваа тээврийн хэрэгсэлгүй үед зөвшөөрнө",
  },
  {
    id: "1526",
    test_id: "492",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1527",
    test_id: "492",
    answer: "Хориглоно",
  },
  {
    id: "1528",
    test_id: "492",
    answer:
      "Ачааны автомашины урдуур зам хөндлөн гарч байгаа явган зорчигч байхгүйг бүрэн мэдсэн тохиолдолд зөвшөөрнө",
  },
  {
    id: "1529",
    test_id: "493",
    answer: "Хурдыг цагт 20 км-ээс хэтрүүлэхгүй бол зөвшөөрнө",
  },
  {
    id: "1530",
    test_id: "493",
    answer: "Ажлын өдрийн 7.30-аас 19.00 цагийн хооронд хориглоно",
  },
  {
    id: "1531",
    test_id: "494",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1532",
    test_id: "494",
    answer: "Хориглоно",
  },
  {
    id: "1533",
    test_id: "494",
    answer:
      "Ачааны автомашины урдуур явган зорчигч байхгүйг бүрэн мэдсэн тохиолдолд зөвшөөрнө",
  },
  {
    id: "1534",
    test_id: "495",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1535",
    test_id: "495",
    answer: "Хориглоно",
  },
  {
    id: "1536",
    test_id: "496",
    answer: "Гүүрэн дээр мопедыг гүйцэж түрүүлж байгаа ",
  },
  {
    id: "1537",
    test_id: "496",
    answer: "Гүүрэн доор ачааны автомашиныг гүйцэж байгаа",
  },
  {
    id: "1538",
    test_id: "496",
    answer: "Хоёуланг хориглоно",
  },
  {
    id: "1539",
    test_id: "496",
    answer: "Хоёуланг зөвшөөрнө",
  },
  {
    id: "1540",
    test_id: "497",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1541",
    test_id: "497",
    answer: "Хориглоно",
  },
  {
    id: "1542",
    test_id: "497",
    answer: "Гарам хүрэхээс өмнө үйлдлээ дуусгах бол зөвшөөрнө",
  },
  {
    id: "1543",
    test_id: "498",
    answer: "Зам хөндлөн гарч яваа ",
  },
  {
    id: "1544",
    test_id: "498",
    answer: "Зам хөндлөн гарахаар завдаж байгаа",
  },
  {
    id: "1545",
    test_id: "498",
    answer: "Хоёуланд нь",
  },
  {
    id: "1546",
    test_id: "499",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1547",
    test_id: "499",
    answer: "Гармаас 100 м холдож амжаагүй тохиолдолд хориглоно",
  },
  {
    id: "1548",
    test_id: "500",
    answer:
      "Гарцын өмнө зогсож,явган зорчигчид зам тавьж өгсний дараа нэвтэрнэ",
  },
  {
    id: "1549",
    test_id: "500",
    answer: "Явган зорчигчоос түрүүлж нэвтэрнэ",
  },
  {
    id: "1550",
    test_id: "500",
    answer: "Явган хүний гарц нэвтэрхийг хориглоно ",
  },
  {
    id: "1551",
    test_id: "501",
    answer: "Тийм ",
  },
  {
    id: "1552",
    test_id: "501",
    answer: "Үгүй",
  },
  {
    id: "1553",
    test_id: "502",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1554",
    test_id: "502",
    answer: "Хориглоно",
  },
  {
    id: "1555",
    test_id: "502",
    answer: "Зөвхөн өдрийн цагт зөвшөөрнө",
  },
  {
    id: "1556",
    test_id: "503",
    answer: "Зөвхөн А",
  },
  {
    id: "1557",
    test_id: "503",
    answer: "А, Б",
  },
  {
    id: "1558",
    test_id: "503",
    answer: "Хоёулангаас нь түрүүлж нэвтэрнэ",
  },
  {
    id: "1559",
    test_id: "504",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1560",
    test_id: "504",
    answer: "Хориглоно",
  },
  {
    id: "1561",
    test_id: "504",
    answer:
      "Өгсүүрийн төгсгөлд хүрэхээс өмнө үйлдлээ дуусгаж буцаж эгнээндээ орж амжих бол зөвшөөрнө",
  },
  {
    id: "1562",
    test_id: "505",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1563",
    test_id: "505",
    answer: "Замын өгсүүр хэсгийн төгсгөлд хориглоно",
  },
  {
    id: "1564",
    test_id: "506",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1565",
    test_id: "506",
    answer: "Хориглоно",
  },
  {
    id: "1566",
    test_id: "507",
    answer: "Хурдаа хасаж гарцын өмнө зэрэгцэж зогсоно",
  },
  {
    id: "1567",
    test_id: "507",
    answer: "Хурдаа хасахгүйгээр гүйцэж нэвтэрнэ",
  },
  {
    id: "1568",
    test_id: "507",
    answer: "Дуут дохио өгсний дараа нэвтэрнэ",
  },
  {
    id: "1569",
    test_id: "508",
    answer: "Зорчих хэсгийн зүүн гар талын захад",
  },
  {
    id: "1570",
    test_id: "508",
    answer: "Зорчих хэсгийн барун гар талын захад",
  },
  {
    id: "1571",
    test_id: "508",
    answer: "Зорчих хэсгийн тэн хагасыг зүүн гар талдаа үлдээж",
  },
  {
    id: "1572",
    test_id: "508",
    answer: "Зорчих хэсгийг голлож",
  },
  {
    id: "1573",
    test_id: "509",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1574",
    test_id: "509",
    answer: "Хориглоно",
  },
  {
    id: "1575",
    test_id: "509",
    answer:
      "Гүйцэж байгаа тээврийн хэрэгслийн урдуур явган зорчигч зам хөнлдлөн гарч байгаа эсэхийг мэдээгүй тохиолдолд хориглоно ",
  },
  {
    id: "1576",
    test_id: "510",
    answer: "Зорчих хэсгийн зүүн гар талын захад",
  },
  {
    id: "1577",
    test_id: "510",
    answer: "Зорчих хэсгийн барун гар талын захад",
  },
  {
    id: "1578",
    test_id: "510",
    answer: "Зорчих хэсгийн тэн хагасыг зүүн гар талдаа үлдээж",
  },
  {
    id: "1579",
    test_id: "510",
    answer: "Зорчих хэсгийг голлож",
  },
  {
    id: "1580",
    test_id: "511",
    answer: "Тийм ",
  },
  {
    id: "1581",
    test_id: "511",
    answer: "Явган хүний гарцгүй хэсэгт зам тавьж өгөх үүрэг хүлээхгүй ",
  },
  {
    id: "1582",
    test_id: "512",
    answer: "Хажуугийн аюулгүйн зайг хангасан тохиолдолд зөвшөөрнө",
  },
  {
    id: "1583",
    test_id: "512",
    answer: "Хориглоно",
  },
  {
    id: "1584",
    test_id: "513",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1585",
    test_id: "513",
    answer: "Хориглоно",
  },
  {
    id: "1586",
    test_id: "514",
    answer: "Зөвхөн баруун гар талын эгнээгээр",
  },
  {
    id: "1587",
    test_id: "514",
    answer: "Аль дурын эгнээгээр ",
  },
  {
    id: "1588",
    test_id: "515",
    answer: "Зогсож ,бололцоотой тусламж үзүүлнэ ",
  },
  {
    id: "1589",
    test_id: "515",
    answer: "Автобусыг хөдөлгөөнөө эхэлтэл түр зогсож хүлээнэ",
  },
  {
    id: "1590",
    test_id: "515",
    answer: "Хурдаа хасаж анхаарал болгоомжтой явна ",
  },
  {
    id: "1591",
    test_id: "516",
    answer: "Өөдөөс ирж яваа тээврийн хэрэгсэлгүй үед зөвшөөрнө",
  },
  {
    id: "1592",
    test_id: "516",
    answer: "Хориглоно",
  },
  {
    id: "1593",
    test_id: "517",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1594",
    test_id: "517",
    answer: "Хориглоно",
  },
  {
    id: "1595",
    test_id: "518",
    answer: "Тийм ",
  },
  {
    id: "1596",
    test_id: "518",
    answer: "Явган хүний гарцгүй хэсэг учир үгүй",
  },
  {
    id: "1597",
    test_id: "519",
    answer: "Өөдөөс ирж яваа тээврийн хэрэгсэлгүй үед зөвшөөрнө",
  },
  {
    id: "1598",
    test_id: "519",
    answer:
      "Баруун гар талын хөвөөгөөр тойрон гарах боломжтой тохиолдолд хориглоно",
  },
  {
    id: "1599",
    test_id: "520",
    answer: "Хориглоно",
  },
  {
    id: "1600",
    test_id: "520",
    answer: "Зам хөндлөн гарах явган зорчигч байхгүй тохиолдолд зөвшөөрнө",
  },
  {
    id: "1601",
    test_id: "521",
    answer:
      "Зөвхөн зүүн гар тийш эргэхийн тулд байр эзлэх тохиолдолд зөвшөөрнө ",
  },
  {
    id: "1602",
    test_id: "521",
    answer:
      "Зөвхөн гүйцэж түрүүлэх буюу саадыг тойрон гарах тохиолдолд зөвшөөрнө",
  },
  {
    id: "1603",
    test_id: "521",
    answer: "Дээрх бүх тохиолдолд зөвшөөрнө",
  },
  {
    id: "1604",
    test_id: "521",
    answer: "Хориглоно",
  },
  {
    id: "1605",
    test_id: "522",
    answer: "Шаардлагатай",
  },
  {
    id: "2159",
    test_id: "695",
    answer: "Зөвхөн суудлын автомашин",
  },
  {
    id: "1606",
    test_id: "522",
    answer: "Шаардлагагүй",
  },
  {
    id: "1607",
    test_id: "523",
    answer:
      "Баруун гар талын эгнээнд хөдөлгөөний түгжрэл, саатал бий болсон тохиолдолд зөвшөөрнө",
  },
  {
    id: "1608",
    test_id: "523",
    answer: "Хориглоно",
  },
  {
    id: "1609",
    test_id: "524",
    answer: "Хориглоно",
  },
  {
    id: "1610",
    test_id: "524",
    answer: "Хөдөлгөөний аюулгүй байдлыг бүрэн хангасан нөхцөлд зөвшөөрнө",
  },
  {
    id: "1611",
    test_id: "524",
    answer:
      "Төмөр замын гарам хариуцсан суурь бүтэц эзэмшигчээс зөвшөөрөл авч нэвтэрнэ",
  },
  {
    id: "1612",
    test_id: "525",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1613",
    test_id: "525",
    answer: "Хориглоно",
  },
  {
    id: "1614",
    test_id: "525",
    answer:
      "Замын дагуух үзэгдэлт 10 м-ийн дотор хязгаарлагдаагүй бол зөвшөөрнө",
  },
  {
    id: "1615",
    test_id: "526",
    answer: "Нэг чигийн хөдөлгөөнтэй",
  },
  {
    id: "1616",
    test_id: "526",
    answer: "Сөрөг хөдөлгөөнтэй",
  },
  {
    id: "1617",
    test_id: "527",
    answer: "Зөвхөн баруун гар талын эгнээгээр",
  },
  {
    id: "1618",
    test_id: "527",
    answer: "Баруун гар талын буюу дунд эгнээгээр",
  },
  {
    id: "1619",
    test_id: "527",
    answer: "Аль дурын эгнээгээр",
  },
  {
    id: "1620",
    test_id: "528",
    answer: "Галт тэргээс урьтаж амжихаар бол гармаар нэвтэрнэ ",
  },
  {
    id: "1621",
    test_id: "528",
    answer: "Зогсож,галт тэргийг урьдчилан өнгөрүүлнэ",
  },
  {
    id: "1622",
    test_id: "529",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1623",
    test_id: "529",
    answer: "Баруун гар талын эгнээ чөлөөгүй үед зөвшөөрнө",
  },
  {
    id: "1624",
    test_id: "529",
    answer: "Хориглоно",
  },
  {
    id: "1625",
    test_id: "530",
    answer: "Гарам руу орохыг хориглоно",
  },
  {
    id: "1626",
    test_id: "530",
    answer:
      "Гарам руу орохыг зөвшөөрөх бөгөөд болгоомжтой нэвтэрхийг анхааруулна ",
  },
  {
    id: "1627",
    test_id: "530",
    answer: "Гарам зохицуулгагүй болсныг мэдээлнэ",
  },
  {
    id: "1628",
    test_id: "531",
    answer: "Зөвхөн гүйцэж түрүүлэх буюу саадыг тойрон гарах тохиолдолд",
  },
  {
    id: "1629",
    test_id: "531",
    answer:
      "Зөвхөн зүүн гар тийш буюу буцаж эргэхийн тулд байр эзлэх тохиолдолд",
  },
  {
    id: "1630",
    test_id: "531",
    answer: "Дээрх бүх тохиолдолд",
  },
  {
    id: "1631",
    test_id: "532",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1632",
    test_id: "532",
    answer: "Хориглоно",
  },
  {
    id: "1633",
    test_id: "533",
    answer: "Гарам руу орохыг зөвшөөрнө",
  },
  {
    id: "1634",
    test_id: "533",
    answer: "Гарам руу орохыг хориглоно",
  },
  {
    id: "1635",
    test_id: "533",
    answer: "Гармаар болгоомжтой нэвтэрхийг анхааруулна",
  },
  {
    id: "1636",
    test_id: "534",
    answer: "Гүйцэд хаагдахаас өмнө амжихаар бол гармыг нэвтэрнэ",
  },
  {
    id: "1637",
    test_id: "534",
    answer:
      "Галт тэрэг ирж яваа эсэхийг харгалзан гармаар нэвтрэх эсэхээ шийднэ",
  },
  {
    id: "1638",
    test_id: "534",
    answer: "Гармын өмнө зогсоно",
  },
  {
    id: "1639",
    test_id: "535",
    answer: "Гармын өмнө зогсож, хаалт нээгдэхийг хүлээнэ",
  },
  {
    id: "1640",
    test_id: "535",
    answer:
      "Үзэгдэх хүрээнд ойртон ирж яваа галт тэрэг байхгүй бол хаалтыг тойрон гарч нэвтэрнэ",
  },
  {
    id: "1641",
    test_id: "535",
    answer:
      "Гармын дуут болон гэрлэн дохио ажиллахгүй байвал хаалтыг нээж нэвтэрнэ",
  },
  {
    id: "1642",
    test_id: "536",
    answer: "Хориглоно",
  },
  {
    id: "1643",
    test_id: "536",
    answer: "Гармын хаалт нээлттэй, улаан гэрэл асаагүй тохиолдолд зөвшөөрнө",
  },
  {
    id: "1644",
    test_id: "536",
    answer: "Ойртон ирж яваа галт тэрэггүй үед зөвшөөрнө",
  },
  {
    id: "1645",
    test_id: "537",
    answer: "Төмөр зам хүртэл 10 м-ээс багагүй зайд",
  },
  {
    id: "1646",
    test_id: "537",
    answer: "Зогс шугам тэмдэглэлийн өмнө",
  },
  {
    id: "1647",
    test_id: "537",
    answer: "Хаалтад 5 м-ээс ойргүй зайд",
  },
  {
    id: "1648",
    test_id: "538",
    answer: "'Зогсохгүй явах хориотой' тэмдэгийн өмнө",
  },
  {
    id: "1649",
    test_id: "538",
    answer: "'Төмөр замын гарам' тэмдэгийн өмнө",
  },
  {
    id: "1650",
    test_id: "538",
    answer: "Төмөр зам хүртэл 10 м-ээс багагүй зайд",
  },
  {
    id: "1651",
    test_id: "539",
    answer: "Төмөр зам хүртэл 20 м-ээс багагүй зайд",
  },
  {
    id: "1652",
    test_id: "539",
    answer: "Гэрлэн дохио хүртэл 5 м-ээс багагүй зайд",
  },
  {
    id: "1653",
    test_id: "539",
    answer: "Гэрлэн дохионы өмнө",
  },
  {
    id: "1654",
    test_id: "540",
    answer: "1 м-ээс ойргүй зайд ",
  },
  {
    id: "1655",
    test_id: "540",
    answer: "5 м-ээс ойргүй  зайд",
  },
  {
    id: "1656",
    test_id: "540",
    answer: "10 м-ээс ойргүй зайд",
  },
  {
    id: "1657",
    test_id: "541",
    answer: "20 метр",
  },
  {
    id: "1658",
    test_id: "541",
    answer: "15 метр",
  },
  {
    id: "1659",
    test_id: "541",
    answer: "10 метр",
  },
  {
    id: "1660",
    test_id: "541",
    answer: "5 метр",
  },
  {
    id: "1661",
    test_id: "542",
    answer: "Ойртон ирж яваа галт тэрэггүй үед зөвшөөрнө",
  },
  {
    id: "1662",
    test_id: "542",
    answer: "Өөдөөс ирж яваа тээврийн хэрэгсэлгүй үед зөвшөөрнө",
  },
  {
    id: "1663",
    test_id: "542",
    answer: "Дээрх хоёр тохиолдолд зөвшөөрнө",
  },
  {
    id: "1664",
    test_id: "542",
    answer: "Хориглоно",
  },
  {
    id: "1665",
    test_id: "543",
    answer: "Гарам нээлттэй байгаа тохиолдолд зөвшөөрнө",
  },
  {
    id: "1666",
    test_id: "543",
    answer: "Ойртон ирж яваа галт тэрэггүй үед зөвшөөрнө",
  },
  {
    id: "1667",
    test_id: "543",
    answer: "Дээрх хоёр тохиолдолд зөвшөөрнө",
  },
  {
    id: "1668",
    test_id: "543",
    answer: "Хориглоно",
  },
  {
    id: "1669",
    test_id: "544",
    answer: "Зорчигчдыг буулгах ",
  },
  {
    id: "1670",
    test_id: "544",
    answer: "Тээврийн хэрэгслийнхээ гэмтлийг засах",
  },
  {
    id: "1671",
    test_id: "544",
    answer: "Төмөр замын гарам хариуцсан байгууллага, ажилтанд мэдэгдэх",
  },
  {
    id: "1672",
    test_id: "545",
    answer:
      "Ослын зогсолтын тэмдгийг галт тэрэг ирэх зүгт төмөр зам дээр тавина",
  },
  {
    id: "1673",
    test_id: "545",
    answer:
      "Ослын зогсолтын тэмдэгийг тээврийн хэрэгсэлээс 15-30 метрийн зайд зорчих хэсэг дээр байрлуулна",
  },
  {
    id: "1674",
    test_id: "545",
    answer: "Ослын дохионы гэрлээ асааж, түгшүүрийн дуут дохио өгнө",
  },
  {
    id: "1675",
    test_id: "546",
    answer: "Тээврийн хэрэгслийнхээ дуут дохиог өгнө",
  },
  {
    id: "1676",
    test_id: "546",
    answer:
      "Галт тэргийг угтан гүйж ,сайн харагдах зүйлээр тойруулан даллаж дохио өгнө",
  },
  {
    id: "1677",
    test_id: "546",
    answer:
      "Төмөр зам дээр галт тэрэгний өөдөөс харж зогсон баруун гараа дээш өргөнө",
  },
  {
    id: "1678",
    test_id: "547",
    answer: "20 метр",
  },
  {
    id: "1679",
    test_id: "547",
    answer: "100 метр",
  },
  {
    id: "1680",
    test_id: "547",
    answer: "300 метр",
  },
  {
    id: "1681",
    test_id: "547",
    answer: "1000 метр",
  },
  {
    id: "1682",
    test_id: "548",
    answer: "Нэг урт, гурван богино хэмнэлээр ",
  },
  {
    id: "1683",
    test_id: "548",
    answer: "Гурван урт, нэг богино хэмнэлээр",
  },
  {
    id: "1684",
    test_id: "548",
    answer: "Жигд тасалдалтай хэмнэлээр ",
  },
  {
    id: "1685",
    test_id: "549",
    answer: "Галт тэрэгний өөдөөс гэрэлтүүлүүр асааж тусгана",
  },
  {
    id: "1686",
    test_id: "549",
    answer: "Гэрэл буюу галаар тойруулан даллаж дохио өгнө ",
  },
  {
    id: "1687",
    test_id: "549",
    answer:
      "Тээврийн хэрэгслийн холын ба ойрын гэрлийг ээлжлэн шилжүүлэх байдлаар дохио өгнө",
  },
  {
    id: "1688",
    test_id: "550",
    answer: "Зөвхөн хүүхдэд ",
  },
  {
    id: "1689",
    test_id: "550",
    answer: "Зөвхөн цагаан таяг барьсан хүнд ",
  },
  {
    id: "1690",
    test_id: "550",
    answer: "Зөвхөн дээрх хоёрт ",
  },
  {
    id: "1691",
    test_id: "550",
    answer: "Бүгдэд",
  },
  {
    id: "1692",
    test_id: "551",
    answer: "10 км/цаг",
  },
  {
    id: "1693",
    test_id: "551",
    answer: "20 км/ цаг ",
  },
  {
    id: "1694",
    test_id: "551",
    answer: "40 км/ цаг",
  },
  {
    id: "1695",
    test_id: "551",
    answer: "60 км/ цаг",
  },
  {
    id: "1696",
    test_id: "552",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1697",
    test_id: "552",
    answer: "Хориглоно",
  },
  {
    id: "1698",
    test_id: "552",
    answer:
      "Гүйцэгдэж байгаа тээврийн хэрэгслийн урдуур зам хөндлөн гарч байгаа явган зорчигч байхгүйг бүрэн мэдсэн тохиолдолд зөвшөөрнө",
  },
  {
    id: "1699",
    test_id: "553",
    answer: "Хориглоно",
  },
  {
    id: "1700",
    test_id: "553",
    answer:
      "Хөдөлгүүрийн утааны найрлага дахь хорт хийн хэмжээ стандартад зааснаас хэтрэхгүй бол зөвшөөрнө ",
  },
  {
    id: "1701",
    test_id: "553",
    answer: "Удаан хугацаагаар зогсох бол хориглоно",
  },
  {
    id: "1702",
    test_id: "554",
    answer: "Хөдөлгүүрийг унтраасан бол зөвшөөрнө",
  },
  {
    id: "1703",
    test_id: "554",
    answer: "Зорчих хэсэг дээр зогсоосон тохиолдолд хориглоно",
  },
  {
    id: "1704",
    test_id: "554",
    answer: "Зөвхөн 22 цагаас 06 цагийн хооронд зөвшөөрнө",
  },
  {
    id: "1705",
    test_id: "555",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1706",
    test_id: "555",
    answer: "Бүх жин нь 3.5 тонноос илүүгүй бол зөвшөөрнө ",
  },
  {
    id: "1707",
    test_id: "555",
    answer: "Нэмэлт тэмдгээр тусгайлан заагаагүй зогсоолд хориглоно",
  },
  {
    id: "1708",
    test_id: "556",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1709",
    test_id: "556",
    answer: "Хориглоно",
  },
  {
    id: "1710",
    test_id: "556",
    answer: "Зөвхөн жолоодлогын дадлага хийх тохиолдолд хориглоно",
  },
  {
    id: "1711",
    test_id: "557",
    answer: "Явган зорчигчид зам тавьж өгөх",
  },
  {
    id: "1712",
    test_id: "557",
    answer: "Хурдыг цагт 20 км-ээс хэтрүүлэхгүй явах",
  },
  {
    id: "1713",
    test_id: "557",
    answer: "Дамжин өнгөрөх хөдөлгөөн хийхгүй байх ",
  },
  {
    id: "1714",
    test_id: "557",
    answer: "Дээрх бүх үүргийг хүлээнэ",
  },
  {
    id: "1715",
    test_id: "558",
    answer: "Зөвхөн ачааны автомашинд",
  },
  {
    id: "1716",
    test_id: "558",
    answer: "Зөвхөн суудлын автомашинд",
  },
  {
    id: "1717",
    test_id: "558",
    answer: "Хоёуланд нь",
  },
  {
    id: "1718",
    test_id: "559",
    answer: "Зөвхөн наана (хорооллын дотор) яваа",
  },
  {
    id: "1719",
    test_id: "559",
    answer: "Зөвхөн цаана (хорооллын гадна) яваа",
  },
  {
    id: "1720",
    test_id: "559",
    answer: "Хоёуланд нь зам тавьж өгөх үүрэгтэй",
  },
  {
    id: "1721",
    test_id: "559",
    answer: "Явган хүний гарцгүй хэсэгт зам тавьж өгөх үүрэг хүлээхгүй",
  },
  {
    id: "1722",
    test_id: "560",
    answer: "Зөвхөн мотоциклд",
  },
  {
    id: "1723",
    test_id: "560",
    answer: "Зөвхөн суудлын автомашинд",
  },
  {
    id: "1724",
    test_id: "560",
    answer: "Хоёуланд нь",
  },
  {
    id: "1725",
    test_id: "561",
    answer: "Тийм ",
  },
  {
    id: "1726",
    test_id: "561",
    answer: "Үгүй",
  },
  {
    id: "1727",
    test_id: "562",
    answer: "Зөвхөн ачааны автомашинд зам тавьж өгнө",
  },
  {
    id: "1728",
    test_id: "562",
    answer: "Зөвхөн суудлын автомашинд зам тавьж өгнө",
  },
  {
    id: "1729",
    test_id: "562",
    answer: "Хоёуланд нь зам тавьж өгнө",
  },
  {
    id: "1730",
    test_id: "562",
    answer: "Түрүүлж нэвтэрнэ",
  },
  {
    id: "1731",
    test_id: "563",
    answer: "Тийм ",
  },
  {
    id: "1732",
    test_id: "563",
    answer: "Үгүй",
  },
  {
    id: "1733",
    test_id: "564",
    answer: "Зөвхөн ачааны автомашинд",
  },
  {
    id: "1734",
    test_id: "564",
    answer: "Зөвхөн цагдаагийн автомашинд",
  },
  {
    id: "1735",
    test_id: "564",
    answer: "Хоёуланд нь",
  },
  {
    id: "1736",
    test_id: "565",
    answer: "Тийм ",
  },
  {
    id: "1737",
    test_id: "565",
    answer: "Үгүй",
  },
  {
    id: "1738",
    test_id: "566",
    answer:
      "Тоормосны идэвхжил нь холбогдох стандартын үзүүлэлтийг хангаж чадахгүй болсон",
  },
  {
    id: "1739",
    test_id: "566",
    answer: "Шингэн дамжуулах эд ангиудын битүүмж алдагдсан",
  },
  {
    id: "1740",
    test_id: "566",
    answer: "Эд ангиудын хийцийг өөрчилсөн",
  },
  {
    id: "1741",
    test_id: "566",
    answer: "Дээрх бүх тохиолдолд хориглоно",
  },
  {
    id: "1742",
    test_id: "567",
    answer: "Тийм ",
  },
  {
    id: "1743",
    test_id: "567",
    answer: "Үгүй",
  },
  {
    id: "1744",
    test_id: "568",
    answer: "Хориглоно",
  },
  {
    id: "1745",
    test_id: "568",
    answer: "Ажлын тоормос ажиллаж байгаа тохиолдолд зөвшөөрнө",
  },
  {
    id: "1746",
    test_id: "568",
    answer: "Хоёроос цөөнгүй ивүүр байгаа тохиолдолд зөвшөөрнө",
  },
  {
    id: "1747",
    test_id: "568",
    answer: "Зөвхөн ойр байгаа зогсоол буюу засварын газарт очих бол зөвшөөрнө",
  },
  {
    id: "1748",
    test_id: "569",
    answer: "Жолооны механизмын эд ангиудын бэхэлгээ эвдэрсэн",
  },
  {
    id: "1749",
    test_id: "569",
    answer: "Жолооны хүрдний цоожлогч гэмтсэн",
  },
  {
    id: "1750",
    test_id: "569",
    answer: "Жолооны хүрдний бүрээс гэмтсэн",
  },
  {
    id: "1751",
    test_id: "569",
    answer: "Дээрх бүх тохиолдолд хориглоно",
  },
  {
    id: "1752",
    test_id: "570",
    answer: "Хориглоно",
  },
  {
    id: "1753",
    test_id: "570",
    answer: "Огцом эргэлт хийхгүйгээр хөдөлгөөнд оролцох бол зөвшөөрнө",
  },
  {
    id: "1754",
    test_id: "570",
    answer:
      "Жолооны хүрдний сул эргэлт тогтоосон хэмжээнээс хэтрээгүй бол зөвшөөрнө",
  },
  {
    id: "1755",
    test_id: "571",
    answer: "Суудлын автомашин",
  },
  {
    id: "1756",
    test_id: "571",
    answer: "Мотоцикл",
  },
  {
    id: "1757",
    test_id: "572",
    answer: null,
  },
  {
    id: "1758",
    test_id: "572",
    answer: null,
  },
  {
    id: "1759",
    test_id: "572",
    answer: null,
  },
  {
    id: "1760",
    test_id: "572",
    answer: null,
  },
  {
    id: "1761",
    test_id: "572",
    answer: null,
  },
  {
    id: "1762",
    test_id: "573",
    answer: "0.8 мм",
  },
  {
    id: "1763",
    test_id: "573",
    answer: "1 мм",
  },
  {
    id: "1764",
    test_id: "573",
    answer: "1.6 мм",
  },
  {
    id: "1765",
    test_id: "573",
    answer: "2 мм",
  },
  {
    id: "1766",
    test_id: "574",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1767",
    test_id: "574",
    answer:
      "Хээний гүн нь газарт тулах хэсгээрээ 1.6 мм-ээс багагүй бол зөвшөөрнө",
  },
  {
    id: "1768",
    test_id: "574",
    answer: "Хориглоно",
  },
  {
    id: "1769",
    test_id: "575",
    answer:
      "Дугуйн даац нь тухайн тээврийн хэрэгслийн төрөлд тохирох бол зөвшөөрнө",
  },
  {
    id: "1770",
    test_id: "575",
    answer: "Нэг тэнхлэгт ижил хэмжээтэй дугуйнууд тавих бол зөвшөөрнө",
  },
  {
    id: "1771",
    test_id: "575",
    answer: "Дээрх хоёр шаардлагыг хангасан бол зөвшөөрнө",
  },
  {
    id: "1772",
    test_id: "575",
    answer: "Хориглоно",
  },
  {
    id: "1773",
    test_id: "576",
    answer: "А ба Б",
  },
  {
    id: "1774",
    test_id: "576",
    answer: "А ба В",
  },
  {
    id: "1775",
    test_id: "576",
    answer: "Б ба В",
  },
  {
    id: "1776",
    test_id: "576",
    answer: "Бүх дугуй ",
  },
  {
    id: "1777",
    test_id: "577",
    answer: "Хөдөлгүүрийн утааны хорт хийн хэмжээ",
  },
  {
    id: "1778",
    test_id: "577",
    answer: "Хөдөлгүүрийн шатахуун зарцуулалт",
  },
  {
    id: "1779",
    test_id: "577",
    answer: "Хөдөлгүүрийн тосны даралт ",
  },
  {
    id: "1780",
    test_id: "577",
    answer: "Дээрх бүгд",
  },
  {
    id: "1781",
    test_id: "578",
    answer: "Дээд чадалдаа хүрч ажиллаж чадахгүй болсон",
  },
  {
    id: "1782",
    test_id: "578",
    answer: "Сул эргэлтийн үед тогтвортой ажиллахгүй болсон",
  },
  {
    id: "1783",
    test_id: "578",
    answer: "Дуу намсгуур нь гэмтсэн",
  },
  {
    id: "1784",
    test_id: "578",
    answer: "Дээрх бүх тохиолдолд хориглоно",
  },
  {
    id: "1785",
    test_id: "579",
    answer: "Тэжээлийн системээс түлш гоожсон",
  },
  {
    id: "1786",
    test_id: "579",
    answer: "Тосолгооны системийн битүүмж алдагдсан",
  },
  {
    id: "1787",
    test_id: "579",
    answer: "Яндангаас гарах дуу чимээний түвшин тогтоосон хэмжээнээс хэтэрсэн",
  },
  {
    id: "1788",
    test_id: "579",
    answer: "Дээрх бүх тохиолдолд хориглоно",
  },
  {
    id: "1789",
    test_id: "580",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1790",
    test_id: "580",
    answer: "Хориглоно",
  },
  {
    id: "1791",
    test_id: "580",
    answer: "Зөвхөн харанхуй буюу үзэгдэлт хангалтгүй үед ашиглахыг хориглоно",
  },
  {
    id: "1792",
    test_id: "581",
    answer: "Хөдөлгүүрийн гэрэл",
  },
  {
    id: "1793",
    test_id: "581",
    answer: "Бүхээгний доторх гэрэл",
  },
  {
    id: "1794",
    test_id: "581",
    answer: "Ухрах арааны гэрэл",
  },
  {
    id: "1795",
    test_id: "581",
    answer: "Тээшний гэрэл",
  },
  {
    id: "1796",
    test_id: "581",
    answer: "Дээрх бүх тохиолдолд хориглоно",
  },
  {
    id: "1797",
    test_id: "582",
    answer:
      "Дуут болон гэрэл шилжүүлэх дохио хэвийн ажиллаж байгаа тохиолдолд зөвшөөрнө",
  },
  {
    id: "1798",
    test_id: "582",
    answer:
      "Чиг өөрчлөх үедээ гараар дохио  өгөх байдлаар  ашиглахыг зөвшөөрнө",
  },
  {
    id: "1799",
    test_id: "582",
    answer: "Хориглоно",
  },
  {
    id: "1800",
    test_id: "583",
    answer: "Хурд хэмжүүр",
  },
  {
    id: "1801",
    test_id: "583",
    answer: "Дуут дохио",
  },
  {
    id: "1802",
    test_id: "583",
    answer: "Шил алчуур",
  },
  {
    id: "1803",
    test_id: "583",
    answer: "Дээрх бүгд",
  },
  {
    id: "1804",
    test_id: "584",
    answer: "Гүйдэл хэмжүүр",
  },
  {
    id: "1805",
    test_id: "584",
    answer: "Түлшний түвшин заагуур",
  },
  {
    id: "1806",
    test_id: "584",
    answer: "Температур заагуур",
  },
  {
    id: "1807",
    test_id: "584",
    answer: "Дээрх бүгд",
  },
  {
    id: "1808",
    test_id: "585",
    answer: "Цан үлээгүүр",
  },
  {
    id: "1809",
    test_id: "585",
    answer: "Шил өргүүр",
  },
  {
    id: "1810",
    test_id: "585",
    answer: "Шил алчуур",
  },
  {
    id: "1811",
    test_id: "585",
    answer: "Дээрх бүх тохиолдол зөвшөөрнө",
  },
  {
    id: "1812",
    test_id: "585",
    answer: "Дээрх бүх тохиолдолд хориглоно",
  },
  {
    id: "1813",
    test_id: "586",
    answer: "Нарны хаалт",
  },
  {
    id: "1814",
    test_id: "586",
    answer: "Суудлын дэр",
  },
  {
    id: "1815",
    test_id: "586",
    answer: "Шаврын хаалт",
  },
  {
    id: "1816",
    test_id: "586",
    answer: "Хажуугийн шил",
  },
  {
    id: "1817",
    test_id: "586",
    answer: "Дээрх бүх тохиолдолд зөвшөөрнө",
  },
  {
    id: "1818",
    test_id: "587",
    answer: "Эмийн сан",
  },
  {
    id: "1819",
    test_id: "587",
    answer: "Гал унтраагуур",
  },
  {
    id: "1820",
    test_id: "587",
    answer: "Ослын зогсолтын тэмдэг",
  },
  {
    id: "1821",
    test_id: "587",
    answer: "Оврын гэрлийн нөөц чийдэн",
  },
  {
    id: "1822",
    test_id: "587",
    answer: "Ивүүр",
  },
  {
    id: "1823",
    test_id: "588",
    answer: "Хамгаалах малгай",
  },
  {
    id: "1824",
    test_id: "588",
    answer: "Зорчигчийн бариул",
  },
  {
    id: "1825",
    test_id: "588",
    answer: "Гал унтраагуур",
  },
  {
    id: "1826",
    test_id: "588",
    answer: "Ослын  зогсолтын тэмдэг",
  },
  {
    id: "1827",
    test_id: "589",
    answer: "Хориглоно",
  },
  {
    id: "1828",
    test_id: "589",
    answer:
      "Зөвхөн хот хооронд болон аялал, жуулчлалаар явах тохиололд хориглоно",
  },
  {
    id: "1829",
    test_id: "589",
    answer:
      "10 хүртэлх насны хүүхдийг өвөр дээрээ авч явах тохиолдолд зөвшөөрнө",
  },
  {
    id: "1830",
    test_id: "589",
    answer: "Зорчигчдод тав тухтай зорчих нөхцөл хангагдсан бол зөвшөөрнө",
  },
  {
    id: "1831",
    test_id: "590",
    answer: "3 нас",
  },
  {
    id: "1832",
    test_id: "590",
    answer: "7 нас",
  },
  {
    id: "1833",
    test_id: "590",
    answer: "10 нас",
  },
  {
    id: "1834",
    test_id: "590",
    answer: "12 нас",
  },
  {
    id: "1835",
    test_id: "591",
    answer: "3 нас",
  },
  {
    id: "1836",
    test_id: "591",
    answer: "7 нас",
  },
  {
    id: "1837",
    test_id: "591",
    answer: "10 нас",
  },
  {
    id: "1838",
    test_id: "591",
    answer: "12 нас",
  },
  {
    id: "1839",
    test_id: "592",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1840",
    test_id: "592",
    answer: "Хориглоно",
  },
  {
    id: "1841",
    test_id: "592",
    answer: "Үйлдвэрлэгчээс тогтоосон зааварт нийцэх бол зөвшөөрнө",
  },
  {
    id: "1842",
    test_id: "593",
    answer:
      "Зөвхөн 140 см -ээс өндөр хүүхдийг зорчигчийн хамгаалах бүс зүүлгэн тээвэрлэх тохиолдолд зөвшөөрнө",
  },
  {
    id: "1843",
    test_id: "593",
    answer:
      "Зөвхөн насанд хүрсэн хүн өвөр дээрээ авч явах тохиолдолд зөвшөөрнө ",
  },
  {
    id: "1844",
    test_id: "593",
    answer:
      "Зөвхөн суурин газарт суудлын таксигаар тээвэрлэх тохиолдолд зөвшөөрнө",
  },
  {
    id: "1845",
    test_id: "593",
    answer: "Дээрх бүх тохиолдол зөвшөөрнө",
  },
  {
    id: "1846",
    test_id: "593",
    answer: "Хориглоно",
  },
  {
    id: "1847",
    test_id: "594",
    answer: "Насанд хүрсэн  хүн өвөр дээрээ авч явах бол зөвшөөрнө",
  },
  {
    id: "1848",
    test_id: "594",
    answer:
      "Зөвхөн 140 см -ээс өндөр хүүхдийг зорчигчийн хамгаалах бүс зүүлгэн тээвэрлэх тохиолдолд зөвшөөрнө",
  },
  {
    id: "1849",
    test_id: "594",
    answer: "Дээрх хоёр тохиолдолд зөвшөөрнө",
  },
  {
    id: "1850",
    test_id: "594",
    answer: "Хориглоно",
  },
  {
    id: "1851",
    test_id: "595",
    answer: "Шаардлагатай",
  },
  {
    id: "1852",
    test_id: "595",
    answer: "Шаардлагагүй ",
  },
  {
    id: "1853",
    test_id: "596",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1854",
    test_id: "596",
    answer: "Хориглоно",
  },
  {
    id: "1855",
    test_id: "597",
    answer:
      "Хүүхдийн нэмэгдэл суудал болон хамгаалах хэрэгсэл байхгүй  тохиолдолд",
  },
  {
    id: "1856",
    test_id: "597",
    answer: "Хоёр буюу түүнээс олон хүүхэд тээвэрлэх тохиолдолд ",
  },
  {
    id: "1857",
    test_id: "597",
    answer: "Хүүхдийн өндөр 140 см -ээс дээш тохиолдолд ",
  },
  {
    id: "1858",
    test_id: "597",
    answer: "Дээрх бүх тохиолдолд зөвшөөрнө",
  },
  {
    id: "1859",
    test_id: "598",
    answer: "Зөвхөн суудлын автомашин",
  },
  {
    id: "1860",
    test_id: "598",
    answer: "Зөвхөн ачааны автомашин",
  },
  {
    id: "1861",
    test_id: "598",
    answer: "Суудлын болон ачааны автомашин",
  },
  {
    id: "1862",
    test_id: "599",
    answer: "Зөвхөн баруун гар талын эгнээг",
  },
  {
    id: "1863",
    test_id: "599",
    answer: "Зөвхөн дунд эгнээг",
  },
  {
    id: "1864",
    test_id: "599",
    answer: "Баруун болон дунд эгнээний аль тохиромжтойг ",
  },
  {
    id: "1865",
    test_id: "600",
    answer: "Баруун гар талын эгнээнээс",
  },
  {
    id: "1866",
    test_id: "600",
    answer: "Дунд эгнээнээс",
  },
  {
    id: "1867",
    test_id: "600",
    answer: "Зүүн гар талын эгнээнээс",
  },
  {
    id: "1868",
    test_id: "601",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1869",
    test_id: "601",
    answer: "Хориглоно",
  },
  {
    id: "1870",
    test_id: "601",
    answer: "Зөвхөн арын суудалд зөвшөөрнө",
  },
  {
    id: "1871",
    test_id: "601",
    answer: "Зөвхөн суурин газарт, арын суудалд зөвшөөрнө",
  },
  {
    id: "1872",
    test_id: "602",
    answer: "Зөвхөн В",
  },
  {
    id: "1873",
    test_id: "602",
    answer: "Зөвхөн Б, В",
  },
  {
    id: "1874",
    test_id: "602",
    answer: "Зөвхөн А, Б",
  },
  {
    id: "1875",
    test_id: "602",
    answer: "Зөвхөн А, Б, В",
  },
  {
    id: "1876",
    test_id: "602",
    answer: "Бүх чигт",
  },
  {
    id: "1877",
    test_id: "603",
    answer: "Зөвхөн А",
  },
  {
    id: "1878",
    test_id: "603",
    answer: "Зөвхөн Б",
  },
  {
    id: "1879",
    test_id: "603",
    answer: "Зөвхөн В, ",
  },
  {
    id: "1880",
    test_id: "603",
    answer: "Зөвхөн Б, В",
  },
  {
    id: "1881",
    test_id: "603",
    answer: "А, Б, В",
  },
  {
    id: "1882",
    test_id: "604",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1883",
    test_id: "604",
    answer: "Хориглоно",
  },
  {
    id: "1884",
    test_id: "604",
    answer: "Зөвхөн арын суудалд авч явахыг зөвшөөрнө",
  },
  {
    id: "1885",
    test_id: "605",
    answer: "Хориглоно",
  },
  {
    id: "1886",
    test_id: "605",
    answer: "Автобусны хөдөлгөөнд саад учруулахгүй бол зөвшөөрнө",
  },
  {
    id: "1887",
    test_id: "606",
    answer: "Зөвхөн В",
  },
  {
    id: "1888",
    test_id: "606",
    answer: "Зөвхөн Б, В",
  },
  {
    id: "1889",
    test_id: "606",
    answer: "Зөвхөн А, Б",
  },
  {
    id: "1890",
    test_id: "606",
    answer: "Зөвхөн А, Б, В",
  },
  {
    id: "1891",
    test_id: "606",
    answer: "Бүх чигт",
  },
  {
    id: "1892",
    test_id: "607",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1893",
    test_id: "607",
    answer: "Хориглоно",
  },
  {
    id: "1894",
    test_id: "608",
    answer: "Зөвхөн А",
  },
  {
    id: "1895",
    test_id: "608",
    answer: "Зөвхөн Б",
  },
  {
    id: "1896",
    test_id: "608",
    answer: "Зөвхөн Б, В",
  },
  {
    id: "1897",
    test_id: "608",
    answer: "А, Б, В",
  },
  {
    id: "1898",
    test_id: "609",
    answer: "Насанд хүрсэн хүн өвөр дээрээ авч явах бол зөвшөөрнө",
  },
  {
    id: "1899",
    test_id: "609",
    answer:
      "140 см -ээс өндөр хүүхдийг зорчигчийн хамгаалах бүс зүүлгэн тээвэрлэх тохиолдолд зөвшөөрнө",
  },
  {
    id: "1900",
    test_id: "609",
    answer: "Дээрх хоёр тохиолдолд зөвшөөрнө",
  },
  {
    id: "1901",
    test_id: "609",
    answer: "Хориглоно",
  },
  {
    id: "1902",
    test_id: "610",
    answer: "Зөвхөн гүйцэж түрүүлэх  тохиолдолд зөвшөөрнө",
  },
  {
    id: "1903",
    test_id: "610",
    answer: "Зөвхөн хөдөлгөөний нягтрал ихэссэн, эгнээ чөлөөгүй үед зөвшөөрнө",
  },
  {
    id: "1904",
    test_id: "610",
    answer: "Дээрх хоёр тохиолдолд зөвшөөрнө",
  },
  {
    id: "1905",
    test_id: "610",
    answer: "Хориглоно",
  },
  {
    id: "1906",
    test_id: "611",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1907",
    test_id: "611",
    answer: "Хориглоно",
  },
  {
    id: "1908",
    test_id: "612",
    answer: "Хамгийн баруун гар талын эгнээг чөлөөтэй байлгахаар сонгоно",
  },
  {
    id: "1909",
    test_id: "612",
    answer:
      "Чөлөөтэй байгаа эгнээнүүдийн аль болох зүүн гар талын эгнээг сонгоно",
  },
  {
    id: "1910",
    test_id: "612",
    answer:
      "Аль болох баруун гар талын чөлөөтэй байгаа зөвшөөрөгдсөн эгнээг сонгоно",
  },
  {
    id: "1911",
    test_id: "612",
    answer: "Аль тохиромжтой дурын эгнээг сонгоно",
  },
  {
    id: "1912",
    test_id: "613",
    answer: "Хориглоно",
  },
  {
    id: "1913",
    test_id: "613",
    answer: "Зөвхөн арын суудалд зөвшөөрнө",
  },
  {
    id: "1914",
    test_id: "613",
    answer:
      "Суудлын тоо хүрэлцэхгүй байгаа тохиолдолд зөвхөн арын суудалд зөвшөөрнө",
  },
  {
    id: "1915",
    test_id: "614",
    answer: "Зөвхөн  баруун гар талын эгнээгээр",
  },
  {
    id: "1916",
    test_id: "614",
    answer: "Аль тохиромжтой  дурын эгнээгээр ",
  },
  {
    id: "1917",
    test_id: "615",
    answer: "Баруун гар талын эгнээ чөлөөтэй байвал шаардлагатай",
  },
  {
    id: "1918",
    test_id: "615",
    answer: "Шаардлагагүй ",
  },
  {
    id: "1919",
    test_id: "616",
    answer: "Хориглоно",
  },
  {
    id: "1920",
    test_id: "616",
    answer: "Автомашины бүх жин 3.5 тонноос илүүгүй бол зөвшөөрнө",
  },
  {
    id: "1921",
    test_id: "616",
    answer: "Зорчигч ачааг дагалдаж яваа бол зөвшөөрнө",
  },
  {
    id: "1922",
    test_id: "616",
    answer: "Зөвхөн суурин газарт зөвшөөрнө",
  },
  {
    id: "1923",
    test_id: "617",
    answer: "Зөвхөн  баруун гар талын эгнээгээр",
  },
  {
    id: "1924",
    test_id: "617",
    answer: "Зөвхөн баруун гар талын нэг ба хоёр дахь эгнээгээр",
  },
  {
    id: "1925",
    test_id: "617",
    answer: "Аль тохиромжтой дурын эгнээгээр",
  },
  {
    id: "1926",
    test_id: "618",
    answer: "Хамгаалах бүсээр тоноглосон суудалтай бол зөвшөөрнө",
  },
  {
    id: "1927",
    test_id: "618",
    answer: "Хориглоно",
  },
  {
    id: "1928",
    test_id: "619",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1929",
    test_id: "619",
    answer:
      "Зөвхөн зүүн  гар тийш буюу буцаж эргэхийн тулд байр эзэлсэн бол зөвшөөрнө",
  },
  {
    id: "1930",
    test_id: "619",
    answer: "Хориглоно",
  },
  {
    id: "1931",
    test_id: "620",
    answer: "Хориглоно",
  },
  {
    id: "1932",
    test_id: "620",
    answer: "Зөвхөн суурин газрын гаднах замд хориглоно",
  },
  {
    id: "1933",
    test_id: "620",
    answer: "Хамгаалах малгай, нэмэгдэл суудал ашигласан бол зөвшөөрнө",
  },
  {
    id: "1934",
    test_id: "621",
    answer: "Зөвхөн Б",
  },
  {
    id: "1935",
    test_id: "621",
    answer: "Зөвхөн А, Б",
  },
  {
    id: "1936",
    test_id: "621",
    answer: "Зөвхөн А, Б, В",
  },
  {
    id: "1937",
    test_id: "621",
    answer: "Зөвхөн В",
  },
  {
    id: "1938",
    test_id: "621",
    answer: "Бүх чигт",
  },
  {
    id: "1939",
    test_id: "622",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1940",
    test_id: "622",
    answer: "Хориглоно",
  },
  {
    id: "1941",
    test_id: "622",
    answer:
      "Ачааг дагалдан буюу хүлээж авахаар явах хүнийг тэвшний дээд ирмэгээс нам зассан суудалд суулгаж тээвэрлэхийг зөвшөөрнө",
  },
  {
    id: "1942",
    test_id: "623",
    answer: "Хориглоно",
  },
  {
    id: "1943",
    test_id: "623",
    answer: "Бүх жин нь 3.5 тонноос бага бол зөвшөөрнө",
  },
  {
    id: "1944",
    test_id: "624",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1945",
    test_id: "624",
    answer: "Хориглоно",
  },
  {
    id: "1946",
    test_id: "624",
    answer: "Жолоочоос өөр харгалзаж хамгаалах хүн хамт яваа бол зөвшөөрнө",
  },
  {
    id: "1947",
    test_id: "625",
    answer: "Хамгийн баруун гар талын эгнээгээр",
  },
  {
    id: "1948",
    test_id: "625",
    answer:
      "Хамгийн баруун гар талын эгнээнээс бусад аль дурын тохиромжтой эгнээгээр",
  },
  {
    id: "1949",
    test_id: "625",
    answer:
      "Хамгийн зүүн гар талын эгнээнээс бусад аль дурын тохиромжтой эгнээгээр",
  },
  {
    id: "1950",
    test_id: "626",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1951",
    test_id: "626",
    answer: "Хориглоно",
  },
  {
    id: "1952",
    test_id: "626",
    answer: "Жолоочоос өөр харгалзаж хамгаалах хүн байхгүй бол хориглоно",
  },
  {
    id: "1953",
    test_id: "627",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1954",
    test_id: "627",
    answer: "Баруун гар талын эгнээ чөлөөтэй байгаа тохиолдолд хориглоно",
  },
  {
    id: "1955",
    test_id: "628",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1956",
    test_id: "628",
    answer:
      "Ачааны илүү гарсан хэсэгт 'Овор ихтэй ачаа' таних тэмдэг байрлуулсан тохиолдолд зөвшөөрнө",
  },
  {
    id: "1957",
    test_id: "628",
    answer: "Тусгай журам, стандарт баримтлах бол зөвшөөрнө",
  },
  {
    id: "1958",
    test_id: "628",
    answer: "Хориглоно",
  },
  {
    id: "1959",
    test_id: "629",
    answer: "Баруун гар талын эгнээ чөлөөтэй байвал шаардлагатай",
  },
  {
    id: "1960",
    test_id: "629",
    answer: "Шаардлагагүй",
  },
  {
    id: "1961",
    test_id: "630",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1962",
    test_id: "630",
    answer: "Баруун гар талын эгнээнүүд чөлөөтэй байгаа тохиолдолд хориглоно",
  },
  {
    id: "1963",
    test_id: "631",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1964",
    test_id: "631",
    answer:
      "Баруун гар талын зөвшөөрөгдсөн эгнээ чөлөөтэй байгаа тохиолдолд хориглоно",
  },
  {
    id: "1965",
    test_id: "632",
    answer: "1 м-ээс илүү гараагүй тохиолдолд зөвшөөрнө",
  },
  {
    id: "1966",
    test_id: "632",
    answer:
      "1 м-ээс илүү гарсан тохиолдолд 'Овор ихтэй ачаа' таних тэмдэг байрлуулсан бол зөвшөөрнө",
  },
  {
    id: "1967",
    test_id: "632",
    answer: "0.4 м-ээс илүү гараагүй тохиолдолд зөвшөөрнө",
  },
  {
    id: "1968",
    test_id: "632",
    answer:
      "0.4 м-ээс илүү гарсан тохиолдолд 'Овор ихтэй ачаа' таних тэмдэг байрлуулсан бол зөвшөөрнө",
  },
  {
    id: "1969",
    test_id: "632",
    answer: "Хориглоно",
  },
  {
    id: "1970",
    test_id: "633",
    answer: "Тийм",
  },
  {
    id: "1971",
    test_id: "633",
    answer: "Үгүй",
  },
  {
    id: "1972",
    test_id: "634",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1973",
    test_id: "634",
    answer: "Хөдөлгөөний эрчим ихтэй үед хориглоно",
  },
  {
    id: "1974",
    test_id: "635",
    answer: "Зөвхөн  баруун гар талын эгнээгээр",
  },
  {
    id: "1975",
    test_id: "635",
    answer: "Хамгийн зүүн гар талын эгнээнээс бусад аль тохиромжтой эгнээгээр",
  },
  {
    id: "1976",
    test_id: "635",
    answer: "Аль дурын эгнээгээр",
  },
  {
    id: "1977",
    test_id: "636",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1978",
    test_id: "636",
    answer: "Хориглоно",
  },
  {
    id: "1979",
    test_id: "636",
    answer:
      "Зөвхөн суудлын автомашин буюу бүх жин нь 3.5 т-оос бага ачааны автомашин жолоодож яваа тохиолдолд зөвшөөрнө",
  },
  {
    id: "1980",
    test_id: "637",
    answer:
      "Ачааны илүү гарсан хэсэгт 'Овор ихтэй ачаа' таних тэмдэг байрлуулсан бол зөвшөөрнө",
  },
  {
    id: "1981",
    test_id: "637",
    answer:
      "Эрх бүхий байгууллагаас баталсан тусгай журам, стандартын баримтлах бол зөвшөөрнө",
  },
  {
    id: "1982",
    test_id: "637",
    answer: "Дээрх хоёр арга хэмжээг авсан тохиолдолд зөвшөөрнө",
  },
  {
    id: "1983",
    test_id: "637",
    answer: "Хориглоно",
  },
  {
    id: "1984",
    test_id: "638",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1985",
    test_id: "638",
    answer: "Хориглоно",
  },
  {
    id: "1986",
    test_id: "638",
    answer:
      "Зөвхөн зүүн гар тийш буюу буцаж эргэхийн тулд байр эзэлсэн тохиолдолд зөвшөөрнө",
  },
  {
    id: "1987",
    test_id: "639",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1988",
    test_id: "639",
    answer: "Хориглоно",
  },
  {
    id: "1989",
    test_id: "639",
    answer: "Ачааны автомашины бүх жин 3.5 тонноос бага бол зөвшөөрнө",
  },
  {
    id: "1990",
    test_id: "640",
    answer: "Хориглоно",
  },
  {
    id: "1991",
    test_id: "640",
    answer:
      "Мотоциклын овроос уртаашаа буюу өргөөшөө 0.4 м-ээс илүү гараагүй бол зөвшөөрнө",
  },
  {
    id: "1992",
    test_id: "640",
    answer: "Зөвхөн ачааны мотоциклоор тээвэрлэхийг зөвшөөрнө",
  },
  {
    id: "1993",
    test_id: "641",
    answer: "Зөвшөөрнө",
  },
  {
    id: "1994",
    test_id: "641",
    answer: "Хориглоно",
  },
  {
    id: "1995",
    test_id: "642",
    answer: "Зөвхөн А",
  },
  {
    id: "1996",
    test_id: "642",
    answer: "Зөвхөн Б",
  },
  {
    id: "1997",
    test_id: "642",
    answer: "А, Б",
  },
  {
    id: "1998",
    test_id: "643",
    answer: "Зөвхөн зүүн гар тийш",
  },
  {
    id: "1999",
    test_id: "643",
    answer: "Зөвхөн зүүн гар тийш болон буцаж эргэх чигт",
  },
  {
    id: "2000",
    test_id: "643",
    answer: "Чигээрээ буюу зүүн гар тийш, мөн буцаж эргэх чигт",
  },
  {
    id: "2001",
    test_id: "644",
    answer: "Хөдөлгөөний эрчим ихтэй, бусад эгнээ чөлөөгүй үед зөвшөөрнө",
  },
  {
    id: "2002",
    test_id: "644",
    answer: "Хориглоно",
  },
  {
    id: "2003",
    test_id: "645",
    answer: "Баруун гар талын эгнээ чөлөөтэй байгаа тохиолдолд хориглоно",
  },
  {
    id: "2004",
    test_id: "645",
    answer: "Ачааны автомашины бүх жин нь 3.5 тоннос бага бол зөвшөөрнө",
  },
  {
    id: "2005",
    test_id: "646",
    answer: "Зөвшөөрнө",
  },
  {
    id: "2006",
    test_id: "646",
    answer: "Зөвхөн жин нь 3.5 тонноос бага бол зөвшөөрнө",
  },
  {
    id: "2007",
    test_id: "646",
    answer:
      "Баруун гар талын зөвшөөрөгдсөн эгнээнүүд чөлөөтэй байгаа тохиолдолд хориглоно",
  },
  {
    id: "2008",
    test_id: "647",
    answer: "Зөвхөн  хамгийн баруун гар талын эгнээнд",
  },
  {
    id: "2009",
    test_id: "647",
    answer: "Зөвхөн баруун гар талаас хоёр дахь эгнээнд",
  },
  {
    id: "2010",
    test_id: "647",
    answer: "Хамгийн баруун гар талын эгнээнээс бусад эгнээнд",
  },
  {
    id: "2011",
    test_id: "647",
    answer:
      "Хамгийн баруун болон хамгийн зүүн гар талын эгнээнээс бусад эгнээнд",
  },
  {
    id: "2012",
    test_id: "648",
    answer: "Хориглоно",
  },
  {
    id: "2013",
    test_id: "648",
    answer:
      "Чиглэлийн тээврийн хэрэгслийн хөдөлгөөнд саад учруулахгүй бол зөвшөөрнө",
  },
  {
    id: "2014",
    test_id: "648",
    answer: "Хөдөлгөөний эрчим ихтэй, бусад эгнээ чөлөөгүй үед зөвшөөрнө",
  },
  {
    id: "2015",
    test_id: "649",
    answer: "Зөвхөн А",
  },
  {
    id: "2016",
    test_id: "649",
    answer:
      "Чиглэлийн тээврийн хэрэгслээс бусад тээврийн хэрэгслийн хувьд зөвхөн Б",
  },
  {
    id: "2017",
    test_id: "649",
    answer: "А, Б",
  },
  {
    id: "2018",
    test_id: "650",
    answer: "Зөвшөөрнө",
  },
  {
    id: "2019",
    test_id: "650",
    answer: "Хориглоно",
  },
  {
    id: "2020",
    test_id: "651",
    answer: "Зөвхөн А",
  },
  {
    id: "2021",
    test_id: "651",
    answer: "Зөвхөн Б",
  },
  {
    id: "2022",
    test_id: "651",
    answer: "А, Б",
  },
  {
    id: "2023",
    test_id: "651",
    answer: "Уг эгнээнд байр эзлэхийг хориглоно",
  },
  {
    id: "2024",
    test_id: "652",
    answer: "Зөвшөөрнө",
  },
  {
    id: "2025",
    test_id: "652",
    answer: "Бусад эгнээ чөлөөтэй үед хориглоно",
  },
  {
    id: "2026",
    test_id: "653",
    answer: "Зохицуулдаггүй уулзвар нэвтрэхэд давуу эрх олгоно",
  },
  {
    id: "2027",
    test_id: "653",
    answer:
      "Хөндлөн замаар яваа тээврийн хэрэгслүүдэд зам тавьж өгөхийг шаардана",
  },
  {
    id: "2028",
    test_id: "654",
    answer: "Адил замын уулзвар нэвтрэх журмыг баримтлана",
  },
  {
    id: "2029",
    test_id: "654",
    answer:
      "Хөндлөн замаас ойртон ирж яваа тээврийн хэрэгслүүдэд зам тавьж өгөх үүрэг хүлээнэ",
  },
  {
    id: "2030",
    test_id: "654",
    answer: "Давуу эрхтэй нэвтрэнэ",
  },
  {
    id: "2031",
    test_id: "655",
    answer:
      "Хөндлөн замаар яваа тээврийн хэрэгслүүдэд зам тавьж өгөхийг шаардана",
  },
  {
    id: "2032",
    test_id: "655",
    answer: "Өөдөөс яваа тээврийн хэрэгсэлд зам тавьж өгөхийг шаардана",
  },
  {
    id: "2033",
    test_id: "655",
    answer: "Бүх тээврийн хэрэгсэлд зам тавьж өгөхийг шаардана",
  },
  {
    id: "2034",
    test_id: "655",
    answer: "Давуу эрх олгоно",
  },
  {
    id: "2035",
    test_id: "656",
    answer:
      "Зүүн гар талаас ойртон ирж яваа тээврийн хэрэгсэлгүй тохиолдолд зөвшөөрнө",
  },
  {
    id: "2036",
    test_id: "656",
    answer:
      "Уг үйлдлийг 'Зам тавьж өгнө' тэмдгийн цаана гарч гүйцэтгэхийг хориглоно",
  },
  {
    id: "2037",
    test_id: "657",
    answer: "Зөвхөн А",
  },
  {
    id: "2038",
    test_id: "657",
    answer: "Зөвхөн Б",
  },
  {
    id: "2039",
    test_id: "657",
    answer: "А, Б",
  },
  {
    id: "2040",
    test_id: "658",
    answer:
      "'Зогсохгүй явах хориотой' тэмдгийн өмнө зогсолт хийсний дараа нэвтэрнэ",
  },
  {
    id: "2041",
    test_id: "658",
    answer:
      "Зорчих хэсгийн огтлолцлын өмнө зогсож аюулгүй байдал хангагдсан эсэхийг мэдсэний дараа нэвтрэнэ",
  },
  {
    id: "2042",
    test_id: "658",
    answer: "Уулзвар нэвтрэхийг хориглоно",
  },
  {
    id: "2043",
    test_id: "659",
    answer: "Шаардлагатай",
  },
  {
    id: "2044",
    test_id: "659",
    answer:
      "Гол замаас яваа ачааны автомашинтай хөдөлгөөн огтлолцохгүй тул шаардлагагүй",
  },
  {
    id: "2045",
    test_id: "660",
    answer: "Тийм",
  },
  {
    id: "2046",
    test_id: "660",
    answer: "Үгүй",
  },
  {
    id: "2047",
    test_id: "661",
    answer:
      "Гүүрээр нэвтрэхийн өмнө өөдөөс яваа тээврийн хэрэгсэлд зам тавьж өгөхийг шаардана",
  },
  {
    id: "2048",
    test_id: "661",
    answer: "Гүүрээр нэвтрэхэд давуу эрх олгоно",
  },
  {
    id: "2049",
    test_id: "661",
    answer: "Гүүрээр нэвтрэн гарахыг хориглоно",
  },
  {
    id: "2050",
    test_id: "662",
    answer: "Хориглоно",
  },
  {
    id: "2051",
    test_id: "662",
    answer: "Мотоциклын хөдөлгөөнд саад учруулахгүй бол зөвшөөрнө",
  },
  {
    id: "2056",
    test_id: "663",
    answer: "А, В",
  },
  {
    id: "2057",
    test_id: "664",
    answer: "Энэ уулзвар дээр",
  },
  {
    id: "2058",
    test_id: "664",
    answer: "Энэ уулзварыг чигээрээ нэвтэрч гарсны дараа",
  },
  {
    id: "2059",
    test_id: "664",
    answer: "Энэ уулзварыг чигээрээ нэвтэрч зөвхөн дараагийн уулзвар дээр",
  },
  {
    id: "2060",
    test_id: "665",
    answer: "Зөвшөөрнө",
  },
  {
    id: "2061",
    test_id: "665",
    answer: "Хориглоно",
  },
  {
    id: "2066",
    test_id: "667",
    answer: "Хориглоно",
  },
  {
    id: "2067",
    test_id: "668",
    answer: "Зөвхөн суудлын автомашин",
  },
  {
    id: "2068",
    test_id: "668",
    answer: "Зөвхөн ачааны автомашин",
  },
  {
    id: "2069",
    test_id: "668",
    answer: "Хоёуланг хориглоно",
  },
  {
    id: "2070",
    test_id: "668",
    answer: "Хоёуланг зөвшөөрнө",
  },
  {
    id: "2071",
    test_id: "669",
    answer: "А, Б, В",
  },
  {
    id: "2072",
    test_id: "669",
    answer: "Зөвхөн В",
  },
  {
    id: "2073",
    test_id: "669",
    answer: "Зөвхөн Б",
  },
  {
    id: "2074",
    test_id: "669",
    answer: "Зөвхөн А, Б",
  },
  {
    id: "2075",
    test_id: "669",
    answer: "Зөвхөн Б, В",
  },
  {
    id: "2076",
    test_id: "670",
    answer: "Зөвхөн суудлын автомашиныг зөвшөөрнө",
  },
  {
    id: "2077",
    test_id: "670",
    answer: "Зөвхөн ачааны автомашиныг зөвшөөрнө",
  },
  {
    id: "2078",
    test_id: "670",
    answer: "Хоёуланг зөвшөөрнө",
  },
  {
    id: "2079",
    test_id: "670",
    answer: "Хоёуланг хориглоно",
  },
  {
    id: "2080",
    test_id: "671",
    answer: "Зөвхөн А",
  },
  {
    id: "2081",
    test_id: "671",
    answer: "Зөвхөн А, Г",
  },
  {
    id: "2082",
    test_id: "671",
    answer: "Зөвхөн А, Б",
  },
  {
    id: "2083",
    test_id: "671",
    answer: "Б, В, Г",
  },
  {
    id: "2084",
    test_id: "672",
    answer: "Зөвшөөрнө",
  },
  {
    id: "2085",
    test_id: "672",
    answer: "Хориглоно",
  },
  {
    id: "2086",
    test_id: "673",
    answer: "Зөвхөн В",
  },
  {
    id: "2087",
    test_id: "673",
    answer: "Зөвхөн В, Г",
  },
  {
    id: "2088",
    test_id: "673",
    answer: "Зөвхөн А, Б",
  },
  {
    id: "2089",
    test_id: "673",
    answer: "Б, В, Г",
  },
  {
    id: "2090",
    test_id: "674",
    answer: "Зөвшөөрнө",
  },
  {
    id: "2091",
    test_id: "674",
    answer: "Хориглоно",
  },
  {
    id: "2092",
    test_id: "675",
    answer: "Зөвхөн Б",
  },
  {
    id: "2093",
    test_id: "675",
    answer: "Зөвхөн В, Г",
  },
  {
    id: "2094",
    test_id: "675",
    answer: "Зөвхөн А, Б",
  },
  {
    id: "2095",
    test_id: "675",
    answer: "А, Б, Г",
  },
  {
    id: "2100",
    test_id: "677",
    answer: "Зөвшөөрнө",
  },
  {
    id: "2101",
    test_id: "677",
    answer: "Хориглоно",
  },
  {
    id: "2108",
    test_id: "679",
    answer: "Хоёуланд хориглоно",
  },
  {
    id: "2109",
    test_id: "679",
    answer: "Хоёуланд зөвшөөрнө",
  },
  {
    id: "2110",
    test_id: "680",
    answer: "Зөвхөн А",
  },
  {
    id: "2111",
    test_id: "680",
    answer: "Зөвхөн Б",
  },
  {
    id: "2112",
    test_id: "680",
    answer: "А, Б",
  },
  {
    id: "2113",
    test_id: "681",
    answer: "Зөвшөөрнө",
  },
  {
    id: "2114",
    test_id: "681",
    answer: "Хориглоно",
  },
  {
    id: "2115",
    test_id: "682",
    answer: "Зөвхөн А",
  },
  {
    id: "2116",
    test_id: "682",
    answer: "Зөвхөн Б",
  },
  {
    id: "2117",
    test_id: "682",
    answer: "А, Б",
  },
  {
    id: "2118",
    test_id: "683",
    answer: "Зөвхөн А",
  },
  {
    id: "2119",
    test_id: "683",
    answer: "Зөвхөн Б",
  },
  {
    id: "2120",
    test_id: "683",
    answer: "А, Б",
  },
  {
    id: "2121",
    test_id: "684",
    answer: "Зөвхөн В",
  },
  {
    id: "2122",
    test_id: "684",
    answer: "Зөвхөн А, Б",
  },
  {
    id: "2123",
    test_id: "684",
    answer: "Зөвхөн Б, В",
  },
  {
    id: "2124",
    test_id: "684",
    answer: "А, Б, В",
  },
  {
    id: "2125",
    test_id: "685",
    answer: "Зөвшөөрнө",
  },
  {
    id: "2126",
    test_id: "685",
    answer: "Хориглоно",
  },
  {
    id: "2127",
    test_id: "686",
    answer: "Зөвхөн А",
  },
  {
    id: "2128",
    test_id: "686",
    answer: "Зөвхөн Б",
  },
  {
    id: "2129",
    test_id: "686",
    answer: "А, Б",
  },
  {
    id: "2130",
    test_id: "687",
    answer: "Зөвшөөрнө",
  },
  {
    id: "2131",
    test_id: "687",
    answer: "Хориглоно",
  },
  {
    id: "2132",
    test_id: "687",
    answer: "Цагт 20 км-ээс бага хурдтай явах бол зөвшөөрнө",
  },
  {
    id: "2136",
    test_id: "689",
    answer: "Зөвшөөрнө",
  },
  {
    id: "2137",
    test_id: "689",
    answer: "Баруун гар талын эгнээ чөлөөгүй тохиолдолд зөвшөөрнө",
  },
  {
    id: "2138",
    test_id: "689",
    answer: "Хориглоно",
  },
  {
    id: "2168",
    test_id: "698",
    answer: "Зөвшөөрнө",
  },
  {
    id: "2169",
    test_id: "698",
    answer: "Хориглоно",
  },
  {
    id: "2170",
    test_id: "699",
    answer: "Чигээрээ явахыг хориглоно",
  },
  {
    id: "2171",
    test_id: "699",
    answer: "Гол замын төгсгөлийг мэдээлнэ",
  },
  {
    id: "2172",
    test_id: "699",
    answer: "Тууш замын төгсгөлийг мэдээлнэ",
  },
  {
    id: "2173",
    test_id: "699",
    answer: "Нэг чигийн хөдөлгөөний төгсгөлийг мэдээлнэ",
  },
  {
    id: "2174",
    test_id: "700",
    answer: "Зөвхөн А сумны дагуу эргэхийг зөвшөөрнө",
  },
  {
    id: "2175",
    test_id: "700",
    answer: "Зөвхөн Б сумны дагуу эргэхийг зөвшөөрнө",
  },
  {
    id: "2176",
    test_id: "700",
    answer: "Хоёуланд зөвшөөрнө",
  },
  {
    id: "2177",
    test_id: "700",
    answer: "Хоёуланд хориглоно",
  },
  {
    id: "2178",
    test_id: "701",
    answer: "Зөвхөн А",
  },
  {
    id: "2179",
    test_id: "701",
    answer: "Зөвхөн Б",
  },
  {
    id: "2180",
    test_id: "701",
    answer: "А, Б",
  },
  {
    id: "2181",
    test_id: "702",
    answer: "Зөвхөн А",
  },
  {
    id: "2182",
    test_id: "702",
    answer: "Зөвхөн А, Б",
  },
  {
    id: "2183",
    test_id: "702",
    answer: "А, Б, Г",
  },
  {
    id: "2184",
    test_id: "702",
    answer: "А, Б, В",
  },
  {
    id: "2185",
    test_id: "703",
    answer: "Зөвшөөрнө",
  },
  {
    id: "2186",
    test_id: "703",
    answer: "Хориглоно",
  },
  {
    id: "2187",
    test_id: "703",
    answer:
      "Техникийн шалтгаанаар цагт 40 км-ээс илүү хурдтай явах боломжгүй бол зөвшөөрнө",
  },
  {
    id: "2188",
    test_id: "704",
    answer: "Зөвшөөрнө",
  },
  {
    id: "2189",
    test_id: "704",
    answer: "Хориглоно",
  },
  {
    id: "2190",
    test_id: "705",
    answer: "Зөвшөөрнө",
  },
  {
    id: "2191",
    test_id: "705",
    answer: "Хориглоно",
  },
  {
    id: "2192",
    test_id: "706",
    answer: "Зөвхөн В",
  },
  {
    id: "2193",
    test_id: "706",
    answer: "Зөвхөн Б, В",
  },
  {
    id: "2194",
    test_id: "706",
    answer: "Зөвхөн В, Г",
  },
  {
    id: "2195",
    test_id: "706",
    answer: "Зөвхөн Б, В, Г",
  },
  {
    id: "2196",
    test_id: "706",
    answer: "А, Б, В, Г",
  },
  {
    id: "2197",
    test_id: "707",
    answer: "Байрлан явах",
  },
  {
    id: "2198",
    test_id: "707",
    answer: "Түр буюу удаан зогсох",
  },
  {
    id: "2199",
    test_id: "707",
    answer: "Дээрх бүх үйлдлийг хориглоно",
  },
  {
    id: "2200",
    test_id: "708",
    answer: "Зөвхөн суудлын автомашин",
  },
  {
    id: "2201",
    test_id: "708",
    answer: "Зөвхөн ачааны автомашин",
  },
  {
    id: "2202",
    test_id: "708",
    answer: "Хоёуланг хориглоно",
  },
  {
    id: "2203",
    test_id: "708",
    answer: "Хоёуланг зөвшөөрнө",
  },
  {
    id: "2204",
    test_id: "709",
    answer: "Зөвхөн чигээрээ",
  },
  {
    id: "2205",
    test_id: "709",
    answer: "Зөвхөн чигээрээ буюу зүүн гар тийш",
  },
  {
    id: "2206",
    test_id: "709",
    answer: "Чигээрээ буюу зүүн гар тийш, мөн буцаж эргэх чигт",
  },
  {
    id: "2207",
    test_id: "710",
    answer: "Зөвшөөрнө",
  },
  {
    id: "2208",
    test_id: "710",
    answer: "Хориглоно",
  },
  {
    id: "2209",
    test_id: "711",
    answer: "Зөвхөн суудлын таксыг зөвшөөрнө",
  },
  {
    id: "2210",
    test_id: "711",
    answer:
      "Зөвхөн <<Тулгуур эрхтний бэрхшээлтэй хүн>> таних тэмдэг бүхий тээврийн хэрэгслийг зөвшөөрнө",
  },
  {
    id: "2211",
    test_id: "711",
    answer:
      "Зөвхөн << Хүүхэд тээвэрлэж яваа тээврийн хэрэгсэл>> таних тэмдэг бүхий автобусыг зөвшөөрнө",
  },
  {
    id: "2212",
    test_id: "711",
    answer: "Дээрх бүгдийг зөвшөөрнө",
  },
  {
    id: "2213",
    test_id: "711",
    answer: "Хориглоно",
  },
  {
    id: "2214",
    test_id: "712",
    answer: "Зөвшөөрнө",
  },
  {
    id: "2215",
    test_id: "712",
    answer: "Хориглоно",
  },
  {
    id: "2216",
    test_id: "713",
    answer: "Зөвхөн баруун гар тийш эргэх бол зөвшөөрнө",
  },
  {
    id: "2217",
    test_id: "713",
    answer: "Зөвхөн чигээрээ явах бол зөвшөөрнө",
  },
  {
    id: "2218",
    test_id: "713",
    answer: "Дээрх хоёр тохиолдолд зөвшөөрнө",
  },
  {
    id: "2219",
    test_id: "713",
    answer: "Хориглоно",
  },
  {
    id: "2220",
    test_id: "714",
    answer: "Зөвшөөрнө",
  },
  {
    id: "2221",
    test_id: "714",
    answer: "Хориглоно",
  },
  {
    id: "2222",
    test_id: "715",
    answer: "Зөвхөн А",
  },
  {
    id: "2223",
    test_id: "715",
    answer: "Зөвхөн В",
  },
  {
    id: "2224",
    test_id: "715",
    answer: "Зөвхөн А, Б",
  },
  {
    id: "2225",
    test_id: "715",
    answer: "Зөвхөн А, В",
  },
  {
    id: "2226",
    test_id: "715",
    answer: "А, Б, В",
  },
  {
    id: "2227",
    test_id: "716",
    answer: "Хөдөлгөөний эрчим ихтэй, бусад эгнээ чөлөөгүй үед зөвшөөрнө",
  },
  {
    id: "2228",
    test_id: "716",
    answer: "Хориглоно",
  },
  {
    id: "2229",
    test_id: "717",
    answer: "Зөвхөн А",
  },
  {
    id: "2230",
    test_id: "717",
    answer: "Зөвхөн Б",
  },
  {
    id: "2231",
    test_id: "717",
    answer: "А, Б",
  },
  {
    id: "2232",
    test_id: "718",
    answer: "Зөвхөн А",
  },
  {
    id: "2233",
    test_id: "718",
    answer: "Зөвхөн Б",
  },
  {
    id: "2234",
    test_id: "718",
    answer: "А, Б",
  },
  {
    id: "2235",
    test_id: "719",
    answer: "Хурдны зөвшөөрөгдөх дээд хязгаарлалыг",
  },
  {
    id: "2236",
    test_id: "719",
    answer: "Хурдны зөвшөөрөгдөх доод хязгаарлалыг",
  },
  {
    id: "2237",
    test_id: "719",
    answer: "Замын энэ хэсгээр явахад тохиромжтой хурдны хэмжээг",
  },
  {
    id: "2238",
    test_id: "720",
    answer: "Ослын зогсолтын зурвасыг",
  },
  {
    id: "2239",
    test_id: "720",
    answer: "Мухар замыг",
  },
  {
    id: "2240",
    test_id: "720",
    answer: "Зогсоолын талбайг",
  },
  {
    id: "2241",
    test_id: "721",
    answer: "Зөвшөөрнө",
  },
  {
    id: "2242",
    test_id: "721",
    answer: "Хориглоно",
  },
  {
    id: "2243",
    test_id: "722",
    answer: "Зөвхөн А",
  },
  {
    id: "2244",
    test_id: "722",
    answer: "Зөвхөн Б",
  },
  {
    id: "2245",
    test_id: "722",
    answer: "А, Б",
  },
  {
    id: "2246",
    test_id: "723",
    answer: "Зөвхөн хамгийн баруун гар талын зөвшөөрөгдсөн эгнээгээр",
  },
  {
    id: "2247",
    test_id: "723",
    answer:
      "Хамгийн зүүн гар талын эгнээнээс бусад аль тохиромжтой дурын эгнээгээр",
  },
  {
    id: "2248",
    test_id: "723",
    answer: "Баруун гар талын хөвөөгөөр",
  },
  {
    id: "2249",
    test_id: "724",
    answer: "350 метрийн цаанаас тахир зам эхлэхийг анхааруулна",
  },
  {
    id: "2250",
    test_id: "724",
    answer: "Тахир зам 350 метр үргэлжлэхийг анхааруулна",
  },
  {
    id: "2251",
    test_id: "724",
    answer:
      "150-300 метрийн цаанаас тахир зам 350 метр үргэлжлэхийг анхааруулна",
  },
  {
    id: "2252",
    test_id: "725",
    answer: "Зөвхөн  хамгийн баруун гар талын эгнээгээр",
  },
  {
    id: "2253",
    test_id: "725",
    answer: "Зөвхөн баруун гар талаас хоёр дахь эгнээгээр",
  },
  {
    id: "2254",
    test_id: "725",
    answer:
      "Хамгийн баруун болон хамгийн зүүн гар талын эгнээнээс бусад эгнээгээр",
  },
  {
    id: "2255",
    test_id: "726",
    answer: "250 метрийн цаана зогсоол байгааг анхааруулна",
  },
  {
    id: "2256",
    test_id: "726",
    answer: "Тэмдгээс цааш 250 метрийн туршид зогсохыг хориглоно",
  },
  {
    id: "2257",
    test_id: "726",
    answer:
      "250 метрийн цаана 'Зогсохгүй явах хориотой' тэмдэг бүхий уулзвар байгааг анхааруулна",
  },
  {
    id: "2258",
    test_id: "727",
    answer: "Зөвшөөрнө",
  },
  {
    id: "2259",
    test_id: "727",
    answer: "Хориглоно",
  },
  {
    id: "2260",
    test_id: "727",
    answer:
      "Баруун гар талын эгнээнд тээврийн хэрэгсэл  яваа тохиолдолд зөвшөөрнө",
  },
  {
    id: "2261",
    test_id: "728",
    answer: "Зөвшөөрнө",
  },
  {
    id: "2262",
    test_id: "728",
    answer: "Баруун гар талын эгнээ чөлөөтэй байгаа тохиолдолд хориглоно",
  },
  {
    id: "2263",
    test_id: "729",
    answer: "Тэмдгээс цааш 800 метр үргэлжилнэ",
  },
  {
    id: "2264",
    test_id: "729",
    answer: "Тэмдгээс цааш эхний уулзвар хүртэл үргэлжилнэ",
  },
  {
    id: "2265",
    test_id: "729",
    answer: "800 метрийн цаанаас эхэлнэ",
  },
  {
    id: "2266",
    test_id: "730",
    answer: "Зөвхөн ачааны автомашин",
  },
  {
    id: "2267",
    test_id: "730",
    answer: "Зөвхөн суудлын автомашин",
  },
  {
    id: "2268",
    test_id: "730",
    answer: "Хоёуланг хориглоно",
  },
  {
    id: "2269",
    test_id: "731",
    answer: "Шаардлагатай",
  },
  {
    id: "2270",
    test_id: "731",
    answer: "Шаардлагагүй",
  },
  {
    id: "2271",
    test_id: "731",
    answer: "Ачааны автомашины бүх жин 3.5 тонноос бага бол шаардлагагүй",
  },
  {
    id: "2272",
    test_id: "732",
    answer: "Тийм",
  },
  {
    id: "2273",
    test_id: "732",
    answer: "Үгүй",
  },
  {
    id: "2274",
    test_id: "733",
    answer: "Зөвхөн суудлын автомашин",
  },
  {
    id: "2275",
    test_id: "733",
    answer: "Зөвхөн мотоцикл",
  },
  {
    id: "2276",
    test_id: "733",
    answer: "Мотоцикл болон суудлын автомашин",
  },
  {
    id: "2277",
    test_id: "733",
    answer: "Суудлын болон ачааны автомашин",
  },
  {
    id: "2278",
    test_id: "734",
    answer: "Зөвхөн ажлын өдрүүдэд",
  },
  {
    id: "2279",
    test_id: "734",
    answer: "Зөвхөн ажлын цагаар",
  },
  {
    id: "2280",
    test_id: "734",
    answer: "Ажлын өдрүүдэд зөвхөн ажлын цагаар",
  },
  {
    id: "2281",
    test_id: "734",
    answer: "Ажлын бус өдрүүдэд",
  },
  {
    id: "2282",
    test_id: "735",
    answer: "Зөвхөн автобус",
  },
  {
    id: "2283",
    test_id: "735",
    answer: "Зөвхөн суудлын автомашин",
  },
  {
    id: "2284",
    test_id: "735",
    answer: "Автобус болон ачааны автомашин",
  },
  {
    id: "2285",
    test_id: "735",
    answer: "Бүгд",
  },
  {
    id: "2286",
    test_id: "736",
    answer: "Хамгийн баруун гар талын эгнээгээр явах",
  },
  {
    id: "2287",
    test_id: "736",
    answer:
      "Араас нь яваа тээврийн хэрэгсэл өөрийг нь  аюулгүй гүйцэж  урд нь орох боломжтой байх хоорондын зайг урд яваа  тээврийн хэрэгслээс барьж явах",
  },
  {
    id: "2288",
    test_id: "736",
    answer: "Дээрх хоёр шаардлагыг биелүүлэх",
  },
  {
    id: "2289",
    test_id: "737",
    answer:
      "Тухайн зогсоолд тээврийн хэрэгслийг 30 минутаас илүү хугацаагаар байлгах хориотойг",
  },
  {
    id: "2290",
    test_id: "737",
    answer:
      "Уг зогсоол нь 30 минутаас илүү хугацаагаар зогсолт хийх тээврийн хэрэгслүүдэд зориулагдсан болохыг",
  },
  {
    id: "2291",
    test_id: "738",
    answer: "Зөвшөөрнө",
  },
  {
    id: "2292",
    test_id: "738",
    answer: "Хориглоно",
  },
  {
    id: "2293",
    test_id: "738",
    answer: "Зөвхөн зүүн гар талын эгнээгээр явах тохиолдолд зөвшөөрнө",
  },
  {
    id: "2294",
    test_id: "739",
    answer: "Хоорондын зайг 10 метр байхаар ",
  },
  {
    id: "2295",
    test_id: "739",
    answer:
      "Араас нь гүйцэж түрүүлсэн тээврийн хэрэгсэл урд нь аюулгүй орж байр эзлэх боломжтой байхаар",
  },
  {
    id: "2296",
    test_id: "739",
    answer: "Бусад тээврийн хэрэгсэл дунд нь орж байр эзлэх боломжгүй байхаар",
  },
  {
    id: "2297",
    test_id: "740",
    answer: "Үүлэрхэг үед",
  },
  {
    id: "2298",
    test_id: "740",
    answer: "Үзэгдэлт хангалтгүй үед",
  },
  {
    id: "2299",
    test_id: "740",
    answer: "Зорчих хэсгийн гадаргуу нойтон үед",
  },
  {
    id: "2300",
    test_id: "741",
    answer: "1",
  },
  {
    id: "2301",
    test_id: "741",
    answer: "2",
  },
  {
    id: "2302",
    test_id: "741",
    answer: "3",
  },
  {
    id: "2303",
    test_id: "742",
    answer:
      "Урд яваа тээврийн хэрэгсэл хурдаа нэмэхэд түүнээс хоцрохгүй байхаар",
  },
  {
    id: "2304",
    test_id: "742",
    answer:
      "Араас яваа тээврийн хэрэгсэл хурдаа нэмэхэд түүнд мөргүүлэхгүй байхаар",
  },
  {
    id: "2305",
    test_id: "742",
    answer:
      "Урд яваа тээврийн хэрэгсэл хурдаа хасах буюу зогсоход түүнийг мөргөхгүй байхаар",
  },
  {
    id: "2306",
    test_id: "743",
    answer: "Зөвхөн А",
  },
  {
    id: "2307",
    test_id: "743",
    answer: "Зөвхөн Б",
  },
  {
    id: "2308",
    test_id: "743",
    answer: "Зөвхөн Б, В",
  },
  {
    id: "2309",
    test_id: "743",
    answer: "Зөвхөн А, Б",
  },
  {
    id: "2310",
    test_id: "743",
    answer: "А, Б, В",
  },
  {
    id: "2311",
    test_id: "744",
    answer: "Зөвхөн А",
  },
  {
    id: "2312",
    test_id: "744",
    answer: "Зөвхөн Б",
  },
  {
    id: "2313",
    test_id: "744",
    answer: "Хоёуланг хориглоно",
  },
  {
    id: "2314",
    test_id: "744",
    answer: "Хоёуланг зөвшөөрнө",
  },
  {
    id: "2315",
    test_id: "745",
    answer: "Хурд их бол хажуугийн зайг их байхаар",
  },
  {
    id: "2316",
    test_id: "745",
    answer: "Хурд их бол хажуугийн зайг бага байхаар",
  },
  {
    id: "2317",
    test_id: "745",
    answer: "Хажуугийн зайг сонгох нь тээврийн хэрэгслийн хурдаас хамаарахгүй",
  },
  {
    id: "2318",
    test_id: "746",
    answer: "Зөвхөн А",
  },
  {
    id: "2319",
    test_id: "746",
    answer: "Зөвхөн Б",
  },
  {
    id: "2320",
    test_id: "746",
    answer: "Хоёуланд зөвшөөрнө",
  },
  {
    id: "2321",
    test_id: "746",
    answer: "Хоёуланд хориглоно",
  },
  {
    id: "2322",
    test_id: "747",
    answer: "Зөвхөн А",
  },
  {
    id: "2323",
    test_id: "747",
    answer: "Зөвхөн Б",
  },
  {
    id: "2324",
    test_id: "747",
    answer: "Зөвхөн А, В",
  },
  {
    id: "2325",
    test_id: "747",
    answer: "Зөвхөн А, Б",
  },
  {
    id: "2326",
    test_id: "747",
    answer: "А, Б, В",
  },
  {
    id: "2327",
    test_id: "748",
    answer: "Зөвхөн А",
  },
  {
    id: "2328",
    test_id: "748",
    answer: "Зөвхөн Б",
  },
  {
    id: "2329",
    test_id: "748",
    answer: "Зөвхөн В",
  },
  {
    id: "2330",
    test_id: "748",
    answer: "Зөвхөн Б, В",
  },
  {
    id: "2331",
    test_id: "748",
    answer: "А, Б, В",
  },
  {
    id: "2332",
    test_id: "749",
    answer: "Зөвхөн А",
  },
  {
    id: "2333",
    test_id: "749",
    answer: "Зөвхөн Б",
  },
  {
    id: "2334",
    test_id: "749",
    answer: "Зөвхөн Б, В",
  },
  {
    id: "2335",
    test_id: "749",
    answer: "Зөвхөн А, Б",
  },
  {
    id: "2336",
    test_id: "749",
    answer: "А, Б, В",
  },
  {
    id: "2350",
    test_id: "752",
    answer: "Зөвхөн Б, В",
  },
  {
    id: "2351",
    test_id: "752",
    answer: "А, Б, В",
  },
  {
    id: "2354",
    test_id: "753",
    answer: "Уулзвар нэвтэрч амжаагүй яваа ачааны автомашинд зам тавьж өгнө",
  },
  {
    id: "2355",
    test_id: "753",
    answer: "Түрүүлж нэвтэрнэ",
  },
  {
    id: "2356",
    test_id: "754",
    answer: "Баруун гар талаас зам хөндлөн гархаар завдаж байгаа",
  },
  {
    id: "2357",
    test_id: "754",
    answer: "Зүүн гар талаас зам хөндлөн гарч яваа",
  },
  {
    id: "2358",
    test_id: "754",
    answer: "Хоёуланд нь зам тавьж өгөх үүрэг хүлээнэ",
  },
  {
    id: "2359",
    test_id: "754",
    answer: "Зам тавьж өгөх үүрэг хүлээхгүй",
  },
  {
    id: "2360",
    test_id: "755",
    answer: "Тийм ",
  },
  {
    id: "2361",
    test_id: "755",
    answer: "Үгүй",
  },
  {
    id: "2362",
    test_id: "756",
    answer: "Уулзварыг түрүүлж нэвтэрнэ",
  },
  {
    id: "2363",
    test_id: "756",
    answer: "Ачааны автомашинд зам тавьж өгнө",
  },
  {
    id: "2364",
    test_id: "757",
    answer: "Тийм ",
  },
  {
    id: "2365",
    test_id: "757",
    answer: "Үгүй",
  },
  {
    id: "2366",
    test_id: "758",
    answer: "Уулзварыг түрүүлж нэвтэрнэ",
  },
  {
    id: "2367",
    test_id: "758",
    answer: "Суудлын автомашинд зам тавьж өгнө",
  },
  {
    id: "2368",
    test_id: "759",
    answer: "Зөвхөн ачааны автомашинд",
  },
  {
    id: "2369",
    test_id: "759",
    answer: "Зөвхөн суудлын автомашинд",
  },
  {
    id: "2370",
    test_id: "759",
    answer: "Хоёуланд нь",
  },
  {
    id: "2371",
    test_id: "760",
    answer: "Зөвхөн автобусанд",
  },
  {
    id: "2372",
    test_id: "760",
    answer: "Зөвхөн суудлын автомашинд",
  },
  {
    id: "2373",
    test_id: "760",
    answer: "Хоёуланд нь",
  },
  {
    id: "2374",
    test_id: "761",
    answer: "Зөвхөн ачааны автомашинд",
  },
  {
    id: "2375",
    test_id: "761",
    answer: "Зөвхөн суудлын автомашинд",
  },
  {
    id: "2376",
    test_id: "761",
    answer: "Хоёуланд нь",
  },
  {
    id: "2377",
    test_id: "762",
    answer: "Зөвхөн мотоциклд",
  },
  {
    id: "2378",
    test_id: "762",
    answer: "Зөвхөн суудлын автомашинд",
  },
  {
    id: "2379",
    test_id: "762",
    answer: "Хоёуланд нь",
  },
  {
    id: "2380",
    test_id: "763",
    answer: "Түрүүлж нэвтэрнэ",
  },
  {
    id: "2381",
    test_id: "763",
    answer: "Суудлын автомашины дараа нэвтэрнэ",
  },
  {
    id: "2382",
    test_id: "763",
    answer: "Уулзварт түрүүлж ороод, мотоциклийг өнгөрөөсний дараа нэвтэрнэ",
  },
  {
    id: "2383",
    test_id: "764",
    answer: "Мотоциклыг уулзварт орсны дараа, түрүүлж нэвтэрнэ",
  },
  {
    id: "2384",
    test_id: "764",
    answer: "Ачааны автомашины дараа нэвтэрнэ",
  },
  {
    id: "2385",
    test_id: "764",
    answer: "Мотоциклыг уулзвар нэвтэрсний дараа нэвтэрнэ",
  },
  {
    id: "2386",
    test_id: "764",
    answer: "Хамгийн сүүлд нэвтэрнэ",
  },
  {
    id: "2387",
    test_id: "765",
    answer: "А,Б,В",
  },
  {
    id: "2388",
    test_id: "765",
    answer: "А,В,Б",
  },
  {
    id: "2389",
    test_id: "765",
    answer: "В,А,Б",
  },
  {
    id: "2390",
    test_id: "765",
    answer: "Б,В,А",
  },
  {
    id: "2391",
    test_id: "766",
    answer: "Зөвхөн баруун гар талаас яваа",
  },
  {
    id: "2392",
    test_id: "766",
    answer: "Зөвхөн зүүн гар талаас яваа",
  },
  {
    id: "2393",
    test_id: "766",
    answer: "Хоёуланд нь зам тавьж өгөх үүрэгтэй",
  },
  {
    id: "2394",
    test_id: "766",
    answer: "Зам тавьж өгөх үүрэг хүлээхгүй",
  },
  {
    id: "2395",
    test_id: "767",
    answer: "Тийм ",
  },
  {
    id: "2396",
    test_id: "767",
    answer: "Үгүй",
  },
  {
    id: "2397",
    test_id: "768",
    answer: "Зөвхөн суудлын автомашинд",
  },
  {
    id: "2398",
    test_id: "768",
    answer: "Зөвхөн мотоциклд",
  },
  {
    id: "2399",
    test_id: "768",
    answer: "Хоёуланд нь",
  },
  {
    id: "2400",
    test_id: "769",
    answer: "Зөвхөн суудлын автомашинд",
  },
  {
    id: "2401",
    test_id: "769",
    answer: "Зөвхөн автобусанд",
  },
  {
    id: "2402",
    test_id: "769",
    answer: "Хоёуланд нь",
  },
  {
    id: "2403",
    test_id: "770",
    answer: "Зөвхөн суудлын автомашинд",
  },
  {
    id: "2404",
    test_id: "770",
    answer: "Зөвхөн ачааны автомашинд",
  },
  {
    id: "2405",
    test_id: "770",
    answer: "Хоёуланд нь",
  },
  {
    id: "2406",
    test_id: "770",
    answer: "Зам тавьж өгөх шаардлагагүй",
  },
  {
    id: "2407",
    test_id: "771",
    answer: "Зөвхөн суудлын автомашинд",
  },
  {
    id: "2408",
    test_id: "771",
    answer: "Зөвхөн ачааны автомашинд",
  },
  {
    id: "2409",
    test_id: "771",
    answer: "Хоёуланд нь",
  },
  {
    id: "2410",
    test_id: "772",
    answer: "Зөвхөн суудлын автомашиныг",
  },
  {
    id: "2411",
    test_id: "772",
    answer: "Мотоцикл болон ачааны автомашиныг",
  },
  {
    id: "2412",
    test_id: "772",
    answer: "Суудлын болон ачааны автомашиныг",
  },
  {
    id: "2413",
    test_id: "772",
    answer: "Бүгдийг",
  },
  {
    id: "2414",
    test_id: "773",
    answer: "Тийм ",
  },
  {
    id: "2415",
    test_id: "773",
    answer: "Үгүй",
  },
  {
    id: "2416",
    test_id: "774",
    answer: "Зөвхөн ачааны автомашинд",
  },
  {
    id: "2417",
    test_id: "774",
    answer: "Зөвхөн суудлын автомашинд",
  },
  {
    id: "2418",
    test_id: "774",
    answer: "Хоёуланд нь",
  },
  {
    id: "2419",
    test_id: "775",
    answer: "Зөвхөн суудлын автомашинд",
  },
  {
    id: "2420",
    test_id: "775",
    answer: "Зөвхөн ачааны автомашинд",
  },
  {
    id: "2421",
    test_id: "775",
    answer: "Хоёуланд нь",
  },
  {
    id: "2422",
    test_id: "776",
    answer: "Зөвхөн А",
  },
  {
    id: "2423",
    test_id: "776",
    answer: "Зөвхөн Б",
  },
  {
    id: "2424",
    test_id: "776",
    answer: "А, Б",
  },
  {
    id: "2425",
    test_id: "777",
    answer: "Зөвхөн суудлын автомашинаас",
  },
  {
    id: "2426",
    test_id: "777",
    answer: "Зөвхөн ачааны автомашинаас",
  },
  {
    id: "2427",
    test_id: "777",
    answer: "Хоёулангаас нь",
  },
  {
    id: "2428",
    test_id: "778",
    answer: "Эмнэлгийн автомашинтай хамт эхний ээлжинд",
  },
  {
    id: "2429",
    test_id: "778",
    answer: "Эмнэлгийн автомашины дараа хоёрдугаар ээлжинд",
  },
  {
    id: "2430",
    test_id: "778",
    answer: "Ачааны автомашиныг өнгөрөөсний дараа хамгийн сүүлд",
  },
  {
    id: "2431",
    test_id: "779",
    answer: "Тийм ",
  },
  {
    id: "2432",
    test_id: "779",
    answer: "Үгүй",
  },
  {
    id: "2433",
    test_id: "780",
    answer: "Тийм ",
  },
  {
    id: "2434",
    test_id: "780",
    answer: "Үгүй",
  },
  {
    id: "2435",
    test_id: "781",
    answer: "Зөвхөн суудлын автомашинд",
  },
  {
    id: "2436",
    test_id: "781",
    answer: "Зөвхөн автобусанд",
  },
  {
    id: "2437",
    test_id: "781",
    answer: "Хоёуланд нь",
  },
  {
    id: "2438",
    test_id: "782",
    answer: "Зөвхөн суудлын автомашинд",
  },
  {
    id: "2439",
    test_id: "782",
    answer: "Зөвхөн автобусанд",
  },
  {
    id: "2440",
    test_id: "782",
    answer: "Хоёуланд нь",
  },
  {
    id: "2441",
    test_id: "782",
    answer: "Зөвхөн суудлын автомашинд",
  },
  {
    id: "2442",
    test_id: "782",
    answer: "Зөвхөн автобусанд",
  },
  {
    id: "2443",
    test_id: "782",
    answer: "Хоёуланд нь",
  },
  {
    id: "2444",
    test_id: "784",
    answer: "Зөвхөн баруун гар талаас яваа суудлын автомашинд",
  },
  {
    id: "2445",
    test_id: "784",
    answer: "Зөвхөн зүүн гар талаас яваа унадаг дугуйнд",
  },
  {
    id: "2446",
    test_id: "784",
    answer: "Хоёуланд нь",
  },
  {
    id: "2447",
    test_id: "785",
    answer: "Автобусанд зам тавьж өгөх үүрэгтэй",
  },
  {
    id: "2448",
    test_id: "785",
    answer: "Ачааны автомашинд зам тавьж өгөх үүрэгтэй",
  },
  {
    id: "2449",
    test_id: "785",
    answer: "Түрүүлж нэвтрэх эрхтэй",
  },
  {
    id: "2450",
    test_id: "786",
    answer: "Ачааны автомашинд зам тавьж өгөх үүрэгтэй",
  },
  {
    id: "2451",
    test_id: "786",
    answer: "Суудлын автомашинд зам тавьж өгөх үүрэгтэй",
  },
  {
    id: "2452",
    test_id: "786",
    answer: "Түрүүлж нэвтрэх эрхтэй",
  },
  {
    id: "2453",
    test_id: "787",
    answer: "Зөвхөн суудлын автомашинд",
  },
  {
    id: "2454",
    test_id: "787",
    answer: "Зөвхөн ачааны автомашинд",
  },
  {
    id: "2455",
    test_id: "787",
    answer: "Хоёуланд нь",
  },
  {
    id: "2456",
    test_id: "787",
    answer: "Зам тавьж өгөх шаардлагагүй",
  },
  {
    id: "2457",
    test_id: "788",
    answer: "Зөвхөн суудлын автомашинд",
  },
  {
    id: "2458",
    test_id: "788",
    answer: "Зөвхөн мотоциклд",
  },
  {
    id: "2459",
    test_id: "788",
    answer: "Хоёуланд нь",
  },
  {
    id: "2460",
    test_id: "789",
    answer: "Зөвхөн ачааны автомашинд зам тавьж өгөх үүрэгтэй",
  },
  {
    id: "2461",
    test_id: "789",
    answer: "Зөвхөн суудлын автомашинд зам тавьж өгөх үүрэгтэй",
  },
  {
    id: "2462",
    test_id: "789",
    answer: "Хоёуланд нь зам тавьж өгөх үүрэгтэй",
  },
  {
    id: "2463",
    test_id: "789",
    answer: "Түрүүлж нэвтрэх эрхтэй",
  },
  {
    id: "2464",
    test_id: "790",
    answer: "Мотоциклыг уулзвар нэвтэрсний дараа нэвтэрнэ",
  },
  {
    id: "2465",
    test_id: "790",
    answer: "Мотоциклыг уулзварт орсны дараа түрүүлж нэвтэрнэ",
  },
  {
    id: "2466",
    test_id: "790",
    answer: "Мотоциклыг уулзварт орохоос өмнө түрүүлж нэвтэрнэ",
  },
  {
    id: "2467",
    test_id: "791",
    answer: "Зөвхөн суудлын автомашинд",
  },
  {
    id: "2468",
    test_id: "791",
    answer: "Зөвхөн ачааны автомашинд",
  },
  {
    id: "2469",
    test_id: "791",
    answer: "Зөвхөн ачааны болон суудлын автомашинд",
  },
  {
    id: "2470",
    test_id: "791",
    answer: "Бүгдэд нь",
  },
  {
    id: "2471",
    test_id: "792",
    answer: "Зөвхөн автобусанд зам тавьж өгөх үүрэгтэй",
  },
  {
    id: "2472",
    test_id: "792",
    answer: "Зөвхөн суудлын автомашинд зам тавьж өгөх үүрэгтэй",
  },
  {
    id: "2473",
    test_id: "792",
    answer: "Хоёуланд нь зам тавьж өгөх үүрэгтэй",
  },
  {
    id: "2474",
    test_id: "792",
    answer: "Түрүүлж нэвтрэх эрхтэй",
  },
  {
    id: "2475",
    test_id: "793",
    answer: "Зөвшөөрнө",
  },
  {
    id: "2476",
    test_id: "793",
    answer: "Богино зайд, алгуурлахгүй гүйцэтгэх бол зөвшөөрнө",
  },
  {
    id: "2477",
    test_id: "793",
    answer: "Хориглоно",
  },
  {
    id: "2478",
    test_id: "794",
    answer: "Зөвхөн автобусанд",
  },
  {
    id: "2479",
    test_id: "794",
    answer: "Зөвхөн ачааны автомашинд",
  },
  {
    id: "2480",
    test_id: "794",
    answer: "Хоёуланд нь",
  },
  {
    id: "2481",
    test_id: "795",
    answer: "Зөвшөөрнө",
  },
  {
    id: "2482",
    test_id: "795",
    answer: "Хориглоно",
  },
  {
    id: "2483",
    test_id: "795",
    answer:
      "Зөвхөн зүүн гар тийш буюу буцаж эргэхийн тулд байр эзлэх тохиолдолд зөвшөөрнө",
  },
  {
    id: "2484",
    test_id: "796",
    answer: "Зөвхөн автобусанд зам тавьж өгөх үүрэгтэй",
  },
  {
    id: "2485",
    test_id: "796",
    answer: "Зөвхөн явган зорчигчдод  зам тавьж өгөх үүрэгтэй",
  },
  {
    id: "2486",
    test_id: "796",
    answer: "Дээрх бүгдэд зам тавьж өгөх үүрэгтэй",
  },
  {
    id: "2487",
    test_id: "797",
    answer: "Үргэлжилсэн шугаман тэмдэглэлийг давсан",
  },
  {
    id: "2488",
    test_id: "797",
    answer: "Явган хүний гарц дээр буцаж эргэсэн",
  },
  {
    id: "2489",
    test_id: "797",
    answer: "Дээрх хоёр зөрчлийг гаргасан",
  },
  {
    id: "2490",
    test_id: "798",
    answer: "А,Б,В",
  },
  {
    id: "2491",
    test_id: "798",
    answer: "А,В,Б",
  },
  {
    id: "2492",
    test_id: "798",
    answer: "В,А,Б",
  },
  {
    id: "2493",
    test_id: "798",
    answer: "Б,В,А",
  },
  {
    id: "2494",
    test_id: "799",
    answer: null,
  },
  {
    id: "2495",
    test_id: "799",
    answer: null,
  },
  {
    id: "2496",
    test_id: "799",
    answer: null,
  },
  {
    id: "2497",
    test_id: "799",
    answer: null,
  },
  {
    id: "2498",
    test_id: "799",
    answer: null,
  },
  {
    id: "2499",
    test_id: "800",
    answer: null,
  },
  {
    id: "2500",
    test_id: "800",
    answer: null,
  },
  {
    id: "2501",
    test_id: "800",
    answer: null,
  },
  {
    id: "2502",
    test_id: "800",
    answer: null,
  },
  {
    id: "2503",
    test_id: "800",
    answer: null,
  },
  {
    id: "2504",
    test_id: "800",
    answer: "А,Б,В",
  },
  {
    id: "2505",
    test_id: "800",
    answer: "А,В,Б",
  },
  {
    id: "2506",
    test_id: "800",
    answer: "В,А,Б",
  },
  {
    id: "2507",
    test_id: "800",
    answer: "Б,В,А",
  },
  {
    id: "2508",
    test_id: "802",
    answer: "Зөвшөөрнө",
  },
  {
    id: "2509",
    test_id: "802",
    answer: "Хориглоно",
  },
  {
    id: "2510",
    test_id: "802",
    answer: "Таксийн үйлчилгээнд яваа тохиолдолд зөвшөөрнө",
  },
  {
    id: "2511",
    test_id: "801",
    answer: "А,Б,В",
  },
  {
    id: "2512",
    test_id: "801",
    answer: "А,В,Б",
  },
  {
    id: "2513",
    test_id: "801",
    answer: "В,А,Б",
  },
  {
    id: "2514",
    test_id: "801",
    answer: "Б,В,А",
  },
  {
    id: "2515",
    test_id: "803",
    answer: "Хориглоно",
  },
  {
    id: "2516",
    test_id: "803",
    answer:
      "Гүйцэж түрүүлэх үйлдэл хийж дуусах үед үргэлжилсэн шугамыг давахаар бол зөвшөөрнө",
  },
  {
    id: "2517",
    test_id: "804",
    answer: "Зөвхөн саадыг тойрон гарах тохиолдолд",
  },
  {
    id: "2518",
    test_id: "804",
    answer: "Зөвхөн буцаж эргэх тохиолдолд",
  },
  {
    id: "2519",
    test_id: "804",
    answer: "Дээрх хоёр тохиолдолд",
  },
  {
    id: "2520",
    test_id: "805",
    answer: "Зөвшөөрнө",
  },
  {
    id: "2521",
    test_id: "805",
    answer: "Хориглоно",
  },
  {
    id: "2522",
    test_id: "805",
    answer: "Зөвхөн зайлшгүй зогсолт хийх тохиолдолд зөвшөөрнө",
  },
  {
    id: "2523",
    test_id: "806",
    answer: "Зөвшөөрнө",
  },
  {
    id: "2524",
    test_id: "806",
    answer: "Хориглоно",
  },
  {
    id: "2525",
    test_id: "807",
    answer:
      "Эгнээний хилийг заагласан тэмдэглэл үргэлжилсэн шугамаар солигдох гэж байгааг",
  },
  {
    id: "2526",
    test_id: "807",
    answer: "Эзэлж яваа эгнээ эсрэг хөдөлгөөнтэй болох гэж байгааг",
  },
  {
    id: "2527",
    test_id: "808",
    answer: "Зүүн гар тийш эргэх үед давуу эрхтэй болохыг",
  },
  {
    id: "2528",
    test_id: "808",
    answer: "Тухайн эгнээнээс зөвхөн зүүн гар тийш эргэхийг",
  },
  {
    id: "2529",
    test_id: "808",
    answer: "Уулзвар дээрх хөдөлгөөний эгнээний хилийг",
  },
  {
    id: "2530",
    test_id: "809",
    answer: "Зөвшөөрнө",
  },
  {
    id: "2531",
    test_id: "809",
    answer: "Хориглоно",
  },
  {
    id: "2532",
    test_id: "810",
    answer: "Зөвхөн ачааны автомашин",
  },
  {
    id: "2533",
    test_id: "810",
    answer: "Зөвхөн суудлын автомашин",
  },
  {
    id: "2534",
    test_id: "810",
    answer: "Хоёул",
  },
  {
    id: "2535",
    test_id: "811",
    answer: "Зөвшөөрнө",
  },
  {
    id: "2536",
    test_id: "811",
    answer: "Хориглоно",
  },
  {
    id: "2537",
    test_id: "812",
    answer: "Зөвшөөрнө",
  },
  {
    id: "2538",
    test_id: "812",
    answer: "Хориглоно",
  },
  {
    id: "2539",
    test_id: "813",
    answer: "Зөвшөөрнө",
  },
  {
    id: "2540",
    test_id: "813",
    answer: "Хориглоно",
  },
  {
    id: "2541",
    test_id: "813",
    answer: "Зөвхөн түр зогсохыг зөвшөөрнө",
  },
  {
    id: "2542",
    test_id: "814",
    answer: "Зөвхөн суудлын автомашин",
  },
  {
    id: "2543",
    test_id: "814",
    answer: "Зөвхөн ачааны автомашин",
  },
  {
    id: "2544",
    test_id: "814",
    answer: "Хоёуланг хориглоно",
  },
  {
    id: "2545",
    test_id: "815",
    answer: "Зөвшөөрнө",
  },
  {
    id: "2546",
    test_id: "815",
    answer: "Хориглоно",
  },
  {
    id: "2547",
    test_id: "815",
    answer: "Зөвхөн хүн буулгах буюу суулгахын тулд түр зогсохыг зөвшөөрнө",
  },
  {
    id: "2548",
    test_id: "816",
    answer: "Зөвшөөрнө",
  },
  {
    id: "2549",
    test_id: "816",
    answer: "Хориглоно",
  },
  {
    id: "2550",
    test_id: "816",
    answer: "Зөвхөн хашлагыг унуулж буюу давж гарч зогсох тохиолдолд хориглоно",
  },
  {
    id: "2551",
    test_id: "817",
    answer: "Унадаг дугуйн зогсоолыг",
  },
  {
    id: "2552",
    test_id: "817",
    answer: "Жолоочийн амрах газрыг",
  },
  {
    id: "2553",
    test_id: "817",
    answer: "Чиглэлийн тээврийн хэрэгслийн буудал буюу таксийн зогсоолыг",
  },
  {
    id: "2554",
    test_id: "818",
    answer: "Зөвшөөрнө",
  },
  {
    id: "2555",
    test_id: "818",
    answer: "Хориглоно",
  },
  {
    id: "2556",
    test_id: "819",
    answer: "Замын энэ хэсэгт зогсох шаардлагатайг",
  },
  {
    id: "2557",
    test_id: "819",
    answer: "'Зогс-шугам' тэмдэглэлд ойртож байгааг",
  },
  {
    id: "2558",
    test_id: "819",
    answer: "Замын энэ хэсгээс цааш хөдөлгөөнөө үргэлжлүүлэх хориотойг",
  },
  {
    id: "2559",
    test_id: "820",
    answer: "'Зогсохгүй явах хориотой' тэмдэгт ойртож байгааг анхааруулна",
  },
  {
    id: "2560",
    test_id: "820",
    answer: "'Зам тавьж өгнө' тэмдэгт ойртож байгааг анхааруулна",
  },
  {
    id: "2561",
    test_id: "820",
    answer: "Дээрх хоёр утгыг агуулна",
  },
  {
    id: "2562",
    test_id: "821",
    answer: "Замын өгсүүр хэсэг ойртож байгааг",
  },
  {
    id: "2563",
    test_id: "821",
    answer: "Өөдөөс тээврийн хэрэгсэл гарч ирж болзошгүйг",
  },
  {
    id: "2564",
    test_id: "821",
    answer: "Зам тавьж өгөхийн тулд зогсох газар ойртож байгааг",
  },
  {
    id: "2565",
    test_id: "822",
    answer: "1",
  },
  {
    id: "2566",
    test_id: "822",
    answer: "2",
  },
  {
    id: "2567",
    test_id: "822",
    answer: "3",
  },
  {
    id: "2568",
    test_id: "823",
    answer: "Автобус",
  },
  {
    id: "2569",
    test_id: "823",
    answer: "Суудлын автомашин",
  },
  {
    id: "2570",
    test_id: "824",
    answer:
      "Ачааны автомашины хөдөлгөөний хурд болон чигийг өөрчлөхөд нөлөөлөхгүй байдлаар зогссон бол зөв",
  },
  {
    id: "2571",
    test_id: "824",
    answer: "Буруу",
  },
  {
    id: "2572",
    test_id: "825",
    answer: "Зөвхөн А",
  },
  {
    id: "2573",
    test_id: "825",
    answer: "Зөвхөн Б",
  },
  {
    id: "2574",
    test_id: "825",
    answer: "А, Б",
  },
  {
    id: "2575",
    test_id: "826",
    answer: "Зөвхөн суудлын автомашин",
  },
  {
    id: "2576",
    test_id: "826",
    answer: "Зөвхөн ачааны автомашин",
  },
  {
    id: "2577",
    test_id: "826",
    answer: "Хоёуланг хориглоно",
  },
  {
    id: "2578",
    test_id: "827",
    answer: "Баруун гар талын эгнээнд шилжихдээ давуу эрхтэй болохыг",
  },
  {
    id: "2579",
    test_id: "827",
    answer: "Тухайн чигт дунд эгнээ хасагдаж байгааг",
  },
  {
    id: "2580",
    test_id: "827",
    answer: "Зам баруун гар тийш огцом эргэхийг",
  },
  {
    id: "2581",
    test_id: "828",
    answer: "Үргэлжилсэн шугаман тэмдэглэлд ойртож байгааг",
  },
  {
    id: "2582",
    test_id: "828",
    answer: "Эгнээний төгсгөлд ойртож байгааг",
  },
  {
    id: "2583",
    test_id: "828",
    answer:
      "Баруун гар тийш эргэхийг зөвшөөрсөн уулзвар буюу гарцад ойртож байгааг",
  },
  {
    id: "2584",
    test_id: "829",
    answer: "Хөдөлгөөний нэг чигийн урсгал салж байгааг",
  },
  {
    id: "2585",
    test_id: "829",
    answer: "Хөдөлгөөний нэг чигийн урсгал нийлж байгааг",
  },
  {
    id: "2586",
    test_id: "829",
    answer: "Хөдөлгөөний эсрэг урсгалууд тусгаарлагдаж байгааг",
  },
  {
    id: "2587",
    test_id: "830",
    answer: "Зөвшөөрнө",
  },
  {
    id: "2588",
    test_id: "830",
    answer: "Хориглоно",
  },
  {
    id: "2589",
    test_id: "831",
    answer: "Чиглэлийн тээврийн хэрэгслийн маршрутыг",
  },
  {
    id: "2590",
    test_id: "831",
    answer: "Километрийн заалтыг ",
  },
  {
    id: "2591",
    test_id: "831",
    answer: "Замын дугаарыг",
  },
  {
    id: "2592",
    test_id: "832",
    answer: "Тухайн эгнээгээр явах хурдны дээд хязгаарлалыг",
  },
  {
    id: "2593",
    test_id: "832",
    answer: "Тохиромжтой хурдны хэмжээг",
  },
  {
    id: "2594",
    test_id: "832",
    answer: "Эгнээ тус бүрийн чиглэлийн дугаарыг",
  },
  {
    id: "2595",
    test_id: "833",
    answer: "Тэмдгийн заалтыг баримталж чигээрээ явна",
  },
  {
    id: "2596",
    test_id: "833",
    answer: "Тэмдэглэлийн заалтыг баримталж баруун гар тийш эргэнэ",
  },
  {
    id: "2597",
    test_id: "834",
    answer: "Улбар шар өнгийн тэмдэглэлийг",
  },
  {
    id: "2598",
    test_id: "834",
    answer: "Цагаан өнгийн тэмдэглэлийг",
  },
  {
    id: "2599",
    test_id: "835",
    answer:
      "Гүүрээр гарахдаа өөдөөс яваа тээврийн хэрэгсэлд зам тавьж өгөх шаардлагатайг",
  },
  {
    id: "2600",
    test_id: "835",
    answer: "Гүүрний хашилт хөдөлгөөнд аюул учруулж болзошгүйг",
  },
  {
    id: "2601",
    test_id: "835",
    answer: "Хүнд даацын тээврийн хэрэгсэл гүүрээр гарах хориотойг",
  },
  {
    id: "2602",
    test_id: "836",
    answer: "Гүүрний хөндлөн дамнуурга 5 м-ээс өндөргүй байрласныг",
  },
  {
    id: "2603",
    test_id: "836",
    answer:
      "Гүүрний босоо тулгуурууд хоорондоо 8 м-ээс илүүгүй зайтай байрласныг",
  },
  {
    id: "2604",
    test_id: "836",
    answer: "Гүүрний доогуур зэрэгцэж нэвтрэх хориотойг",
  },
  {
    id: "2605",
    test_id: "837",
    answer: "Зөвхөн А",
  },
  {
    id: "2606",
    test_id: "837",
    answer: "Зөвхөн Б",
  },
  {
    id: "2607",
    test_id: "837",
    answer: "А, Б",
  },
  {
    id: "2608",
    test_id: "838",
    answer: "Хашлага давж замаас гарахыг зөвшөөрснийг",
  },
  {
    id: "2609",
    test_id: "838",
    answer: "Хашлагагүй замд шилжихийг ",
  },
  {
    id: "2610",
    test_id: "838",
    answer: "Замын аюул бүхий хэсгийг",
  },
];

export default answers;
